/**
 * VendFactura Centralized Translations
 * Languages: ES, EN, FR, NL, DE, HI, ZH
 *
 * Key prefixes:
 *   nav_        – Navbar / footer
 *   hero_       – Landing hero
 *   features_   – Landing features section
 *   verifactu_  – Landing VeriFactu section
 *   pricing_    – Pricing page / section
 *   testimonials_ – Testimonials
 *   faq_        – FAQ
 *   cta_        – Call-to-action
 *   footer_     – Footer
 *   auth_       – Login / Register / Verify
 *   shop_nav_   – Shop sidebar navigation
 *   dashboard_  – Shop dashboard
 *   briefing_   – Daily briefing widget
 *   pos_        – Point of Sale
 *   products_   – Products management page
 */

const translations = {

  // ======================== ESPAÑOL ========================
  es: {
    // Navigation
    nav_features: 'Funcionalidades',
    nav_pricing: 'Precios',
    nav_about: 'Nosotros',
    nav_contact: 'Contacto',
    nav_mobile: 'App Móvil',
    nav_faq: 'FAQ',
    nav_login: 'Iniciar Sesión',
    nav_register: 'Registrarse',

    // Hero
    hero_badge: 'Cumplimiento VeriFactu Garantizado',
    hero_title: 'Tu Tienda.',
    hero_title_2: 'Legal. Simple.',
    hero_subtitle: 'Sistema TPV y facturación conforme a VeriFactu para tiendas y autónomos españoles. La fecha límite de VeriFactu se acerca - ¿estás preparado?',
    hero_cta_pos: 'TPV Completo €19.99/mes',
    hero_cta_invoice: 'Solo Facturas €4.99/mes',
    hero_trusted: 'Con la confianza de m\u00E1s de 500 negocios espa\u00F1oles',

    // Demo Video
    demo_badge: 'Demo Completa',
    demo_title: 'Sistema TPV VendFactura \u2014 Recorrido Completo',
    demo_subtitle: 'Mira nuestro recorrido completo \u2014 desde tu primer pedido hasta gestionar tu stock, todo en menos de 5 minutos.',
    demo_play_title: 'VendFactura TPV \u2014 Demo Completa',
    demo_play_cta: 'Haz clic para reproducir',
    demo_coming_soon: 'V\u00EDdeo demo pr\u00F3ximamente \u2014 \u00A1suscr\u00EDbete para ser notificado!',
    demo_hl_pos: 'Punto de Venta', demo_hl_invoicing: 'Facturaci\u00F3n VeriFactu', demo_hl_stock: 'Gesti\u00F3n de Stock', demo_hl_reports: 'Informes y An\u00E1lisis',

    // Features
    features_title: 'Todo lo que Necesitas',
    features_subtitle: 'Desde el TPV hasta las facturas, gestión de stock y mucho más',
    feature_pos_title: 'Sistema TPV Completo',
    feature_pos_desc: 'Escáner de código de barras, pagos en efectivo y tarjeta, tickets térmicos, modo offline y más.',
    feature_invoice_title: 'Facturas VeriFactu',
    feature_invoice_desc: 'Facturas conformes a la AEAT con códigos QR, cadena de hash y envío automático.',
    feature_stock_title: 'Gestión de Stock',
    feature_stock_desc: 'Escaneo IA de albaranes, alertas de stock bajo, fechas de caducidad y pedidos automáticos.',
    feature_staff_title: 'Gestión de Personal',
    feature_staff_desc: 'Acceso por PIN, roles (cajero, encargado, almacén), registro de actividad.',
    feature_reports_title: 'Informes de Cierre',
    feature_reports_desc: 'Resúmenes diarios, ventas por hora, productos más vendidos, exportar a CSV.',
    feature_delivery_title: 'Entregas a Domicilio',
    feature_delivery_desc: 'Gestión de repartidores, seguimiento de pedidos, tarifas de entrega configurables.',

    // Problem/Solution Section
    problem_title: '\u00BFCansado de Usar M\u00FAltiples Herramientas Desconectadas?',
    problem_subtitle: 'La mayor\u00EDa de due\u00F1os de tiendas pierden horas cada d\u00EDa cambiando entre apps separadas para ventas, facturaci\u00F3n, stock y cumplimiento fiscal. Tu TPV no habla con tu facturaci\u00F3n. \u00BFTe suena?',
    problem_tool_pos: 'Sistema TPV', problem_tool_invoicing: 'Facturaci\u00F3n', problem_tool_stock: 'Gesti\u00F3n de Stock',
    problem_tool_staff: 'Personal', problem_tool_delivery: 'Entregas', problem_tool_payments: 'Pagos',
    problem_tool_reports: 'Informes', problem_tool_compliance: 'Cumplimiento Fiscal',
    problem_solution: 'Una Plataforma. Todo Conectado.',

    // Feature Tabs
    feature_tab_pos: 'Punto de Venta', feature_tab_invoicing: 'Facturaci\u00F3n', feature_tab_stock: 'Stock',
    feature_tab_delivery: 'Entregas', feature_tab_reports: 'Informes',
    feature_pos_long_desc: 'Sistema TPV optimizado para pantalla t\u00E1ctil que funciona en cualquier dispositivo. Procesa pedidos r\u00E1pidamente, gestiona pagos en efectivo y tarjeta, e imprime tickets t\u00E9rmicos. Funciona sin conexi\u00F3n.',
    feature_pos_f1: 'Entrada r\u00E1pida con cuadr\u00EDcula de productos',
    feature_pos_f2: 'Pago en efectivo y tarjeta',
    feature_pos_f3: 'Esc\u00E1ner de c\u00F3digo de barras USB',
    feature_pos_f4: 'Impresi\u00F3n t\u00E9rmica ESC/POS',
    feature_pos_f5: 'Bloqueo PIN para terminales compartidos',
    feature_pos_f6: 'Modo offline completo con auto-sincronizaci\u00F3n',

    // Why Choose Section
    why_title: 'Por Qu\u00E9 los Due\u00F1os de Tiendas Eligen VendFactura',
    why_subtitle: 'Hemos eliminado todas las barreras. Sin hardware caro, sin configuraci\u00F3n compleja, sin contratos a largo plazo.',
    why_hardware_title: 'Sin Hardware Especial', why_hardware_desc: 'Funciona en cualquier tablet, m\u00F3vil u ordenador que ya tengas. Sin necesidad de terminales caros.',
    why_setup_title: 'Configura en Minutos', why_setup_desc: 'Reg\u00EDstrate, a\u00F1ade tus productos y empieza a vender hoy. Sin visitas de t\u00E9cnicos.',
    why_cloud_title: 'Basado en la Nube', why_cloud_desc: 'Accede a tus datos desde cualquier lugar. Las actualizaciones son autom\u00E1ticas.',
    why_secure_title: 'Seguro y Fiable', why_secure_desc: 'Cifrado de nivel bancario. Copias de seguridad diarias. Tus datos siempre protegidos.',

    // VeriFactu Expanded
    vf_section_title: 'Preparado para VeriFactu',
    vf_section_subtitle: 'VendFactura est\u00E1 totalmente preparado para los nuevos requisitos antifraude de facturaci\u00F3n de Espa\u00F1a. Tu negocio cumple autom\u00E1ticamente.',
    vf_mandatory_title: 'VeriFactu es Obligatorio',
    vf_mandatory_desc: 'La regulaci\u00F3n antifraude de Espa\u00F1a exige que TODOS los negocios que usen software de facturaci\u00F3n cumplan:',
    vf_who_1: 'Sociedades (SL, SA)', vf_who_2: 'Aut\u00F3nomos', vf_who_3: 'Tiendas, Restaurantes y Bares', vf_who_4: 'Comercio y Todos los Negocios',
    vf_what_requires: 'Lo que VeriFactu Requiere:',
    vf_req_1: 'Integridad de factura - Sin borrado ni manipulaci\u00F3n',
    vf_req_2: 'Trazabilidad - Pista de auditor\u00EDa completa',
    vf_req_3: 'C\u00F3digos QR en todas las facturas para verificaci\u00F3n',
    vf_req_4: 'Reporte autom\u00E1tico a la AEAT (Agencia Tributaria)',
    vf_ready_title: 'VendFactura est\u00E1 Preparado',
    vf_ready_1: '100% Conforme con VeriFactu',
    vf_ready_2: 'Cadena de Hash Criptogr\u00E1fica - Cada factura vinculada criptogr\u00E1ficamente',
    vf_ready_3: 'C\u00F3digos QR Autom\u00E1ticos en cada recibo',
    vf_ready_4: 'Integraci\u00F3n AEAT - Env\u00EDo autom\u00E1tico a la Agencia Tributaria',
    vf_ready_5: 'Soporte IVA Espa\u00F1ol: 21%, 10%, 4%, 0%',

    // CTA trust items
    cta_trust_1: '14 d\u00EDas gratis', cta_trust_2: 'Sin tarjeta de cr\u00E9dito', cta_trust_3: 'Cancela cuando quieras',
    testimonials_subtitle: 'Con la confianza de due\u00F1os de tiendas y aut\u00F3nomos en toda Espa\u00F1a',

    // Mobile Install
    mobile_install_guide_btn: 'C\u00F3mo Instalar',

    // VeriFactu
    verifactu_label: 'NORMATIVA AEAT',
    verifactu_title: 'VeriFactu te Obliga',
    verifactu_subtitle: 'A partir de julio 2027, todos los negocios españoles deben usar software de facturación homologado. VendFactura ya está preparado.',
    verifactu_feature_1: 'Cadena de hash SHA-256 verificable',
    verifactu_feature_2: 'Códigos QR en cada factura',
    verifactu_feature_3: 'Conexión directa con la AEAT',
    verifactu_feature_4: 'Certificado digital integrado',
    verifactu_approved: 'HOMOLOGADO',
    verifactu_cta: 'Cumple la Normativa Hoy',

    // Pricing
    pricing_title: 'Precios Claros',
    pricing_subtitle: 'Sin sorpresas. Sin comisiones ocultas. Cancela cuando quieras.',
    pricing_invoice_title: 'Facturas',
    pricing_invoice_subtitle: 'Para autónomos y pequeños negocios',
    pricing_invoice_price: '€4.99',
    pricing_invoice_period: '/mes',
    pricing_invoice_features: [
      'Facturas VeriFactu ilimitadas', 'Generación de PDF con QR', 'Directorio de clientes',
      'Plantillas personalizables', 'Facturas recurrentes', 'Seguimiento de pagos',
      'Exportar a CSV/Excel', 'App móvil iOS/Android', 'Soporte por email'
    ],
    pricing_pos_title: 'TPV Tienda',
    pricing_pos_subtitle: 'Para tiendas y comercios',
    pricing_pos_price: '€19.99',
    pricing_pos_period: '/mes',
    pricing_pos_features: [
      'Todo lo de Facturas +', 'Sistema TPV completo', 'Escáner de código de barras',
      'Gestión de stock con alertas', 'Escaneo IA de albaranes', 'Gestión de personal con PIN',
      'Informes de cierre de caja', 'Impresora térmica ESC/POS', 'Modo offline',
      'Entregas a domicilio', 'Soporte prioritario'
    ],
    pricing_popular: 'Más Popular',
    pricing_cta_invoice: 'Empezar con Facturas',
    pricing_cta_pos: 'Empezar con TPV',
    pricing_launch: 'OFERTA ESPECIAL: Regístrate antes del 1 de mayo 2026 - 50% de descuento en planes anuales',
    pricing_monthly: 'Mensual',
    pricing_yearly: 'Anual',
    pricing_yearly_save: 'Ahorra 15%',
    pricing_per_month: '/mes',
    pricing_per_year: '/año',
    pricing_billed_yearly: 'facturado anualmente',

    // Testimonials
    testimonials_title: 'Lo que Dicen Nuestros Clientes',
    testimonial_1_text: '"VendFactura me salvó de una multa. Ahora mis facturas cumplen con VeriFactu sin tener que hacer nada especial."',
    testimonial_1_author: 'María García',
    testimonial_1_role: 'Tienda de alimentación, Madrid',
    testimonial_2_text: '"El escáner de código de barras es rapidísimo. Mis clientes ya no esperan en cola."',
    testimonial_2_author: 'Antonio López',
    testimonial_2_role: 'Estanco, Barcelona',
    testimonial_3_text: '"Como autónomo, solo necesitaba las facturas. Por €4.99 al mes tengo todo resuelto."',
    testimonial_3_author: 'Carlos Ruiz',
    testimonial_3_role: 'Diseñador freelance, Valencia',

    // FAQ
    faq_title: 'Preguntas Frecuentes',
    faq_1_q: '¿Qué es VeriFactu?',
    faq_1_a: 'VeriFactu es el nuevo sistema de la AEAT que exige que todo software de facturación genere facturas verificables con código QR y cadena de hash. Es obligatorio a partir de julio 2027.',
    faq_2_q: '¿Puedo probar antes de pagar?',
    faq_2_a: 'Sí, ofrecemos 14 días de prueba gratuita sin necesidad de tarjeta de crédito.',
    faq_3_q: '¿Funciona sin internet?',
    faq_3_a: 'Sí, el modo offline permite seguir vendiendo aunque no tengas conexión. Las ventas se sincronizan automáticamente cuando vuelvas a tener internet.',
    faq_4_q: '¿Qué impresoras soporta?',
    faq_4_a: 'Cualquier impresora térmica con ESC/POS (la mayoría del mercado). Conexión por Bluetooth, USB o WiFi.',
    faq_5_q: '¿Puedo cambiar de plan?',
    faq_5_a: 'Sí, puedes subir de Facturas a TPV en cualquier momento. El cambio es inmediato.',

    // CTA
    cta_title: '¿Listo para Cumplir con VeriFactu?',
    cta_subtitle: 'Únete a cientos de negocios españoles que ya están preparados',
    cta_button: 'Empezar Gratis',

    // Footer
    footer_description: 'Sistema TPV y facturación VeriFactu para tiendas españolas.',
    footer_product: 'Producto',
    footer_company: 'Empresa',
    footer_legal: 'Legal',
    footer_terms: 'Términos y Condiciones',
    footer_privacy: 'Política de Privacidad',
    footer_cookies: 'Política de Cookies',
    footer_copyright: '© 2025 VendFactura. Todos los derechos reservados.',
    footer_made: 'Hecho con amor en España',

    // ---- Auth ----
    auth_login: 'Iniciar Sesión',
    auth_register: 'Registrarse',
    auth_email: 'Correo electrónico',
    auth_password: 'Contraseña',
    auth_forgot: '¿Olvidaste tu contraseña?',
    auth_no_account: '¿No tienes cuenta?',
    auth_has_account: '¿Ya tienes cuenta?',

    // ---- Shop Navigation ----
    shop_nav_dashboard: 'Panel Principal',
    shop_nav_pos: 'Punto de Venta',
    shop_nav_products: 'Productos',
    shop_nav_stock: 'Stock',
    shop_nav_invoices: 'Facturas',
    shop_nav_staff: 'Personal',
    shop_nav_reports: 'Informes',
    shop_nav_delivery: 'Entregas',
    shop_nav_printer: 'Impresora',
    shop_nav_settings: 'Configuración',
    shop_nav_tickets: 'Soporte',
    shop_nav_help: 'Ayuda',
    shop_nav_logout: 'Cerrar Sesión',

    // ---- Tickets ----
    tickets_title: 'Tickets de Soporte',
    tickets_subtitle: 'Gestiona tus solicitudes de soporte',
    tickets_new: 'Nuevo Ticket',
    tickets_empty: 'Sin tickets',
    tickets_empty_desc: 'Crea un ticket si necesitas ayuda',
    tickets_subject: 'Asunto',
    tickets_category: 'Categoría',
    tickets_priority: 'Prioridad',
    tickets_message: 'Mensaje',
    tickets_submit: 'Enviar Ticket',
    tickets_reply_placeholder: 'Escribe tu respuesta...',
    tickets_close: 'Cerrar ticket',
    tickets_closed_msg: 'Este ticket está cerrado',

    // Mobile App Page
    mobile_badge: 'Aplicación Web Progresiva',
    mobile_hero_title: 'VendFactura en Tu Móvil',
    mobile_hero_subtitle: 'Instala VendFactura como app móvil. TPV completo, facturación y cumplimiento VeriFactu — en tu bolsillo. Sin App Store.',
    mobile_install_btn: 'Instalar Ahora',
    mobile_download_guide: 'Descargar Guía PDF',
    mobile_features_title: 'Todo lo que Necesitas, en Cualquier Dispositivo',
    mobile_features_subtitle: 'La PWA de VendFactura lleva toda la potencia de nuestra plataforma a tu bolsillo.',
    mobile_feat_offline_title: 'Funciona Sin Conexión', mobile_feat_offline_desc: 'Procesa ventas y crea facturas sin internet. Los datos se sincronizan automáticamente al reconectar.',
    mobile_feat_push_title: 'Notificaciones Push', mobile_feat_push_desc: 'Recibe alertas de recordatorios de pago, respuestas a tickets de soporte y actualizaciones importantes.',
    mobile_feat_fast_title: 'Rápido y Ligero', mobile_feat_fast_desc: 'Sin descargas de tienda. Se instala en segundos, usa almacenamiento mínimo y carga al instante.',
    mobile_feat_update_title: 'Siempre Actualizado', mobile_feat_update_desc: 'Sin actualizaciones manuales. Siempre tienes la última versión automáticamente.',
    mobile_feat_secure_title: 'Seguro y Cifrado', mobile_feat_secure_desc: 'Funciona sobre HTTPS con cifrado completo. Tus datos siempre están protegidos.',
    mobile_feat_cross_title: 'Multiplataforma', mobile_feat_cross_desc: 'Funciona en Android, iOS, Windows, macOS y Linux. Una app para todos tus dispositivos.',
    mobile_install_title: 'Instalar en 30 Segundos', mobile_install_subtitle: 'Elige tu dispositivo y sigue los pasos.',
    mobile_android_step1: 'Abre Chrome y ve a vendfactura.es', mobile_android_step2: 'Inicia sesión en tu cuenta', mobile_android_step3: 'Toca el menú de tres puntos (arriba a la derecha)', mobile_android_step4: 'Selecciona "Añadir a pantalla de inicio" o "Instalar app"', mobile_android_step5: 'Toca "Instalar" para confirmar', mobile_android_step6: 'El icono de VendFactura aparecerá en tu pantalla.',
    mobile_ios_step1: 'Abre Safari (debe ser Safari)', mobile_ios_step2: 'Ve a vendfactura.es e inicia sesión', mobile_ios_step3: 'Toca el botón Compartir (cuadrado con flecha)', mobile_ios_step4: 'Desplázate y toca "Añadir a pantalla de inicio"', mobile_ios_step5: 'Toca "Añadir" para confirmar', mobile_ios_step6: 'El icono aparecerá en tu pantalla.',
    mobile_ios_note: 'Importante: En iOS, las PWA solo se instalan desde Safari. Chrome y otros navegadores en iOS no soportan la instalación PWA.',
    mobile_desktop_step1: 'Abre Chrome o Edge en tu ordenador', mobile_desktop_step2: 'Ve a vendfactura.es e inicia sesión', mobile_desktop_step3: 'Haz clic en el icono de instalación en la barra de direcciones', mobile_desktop_step4: 'Haz clic en "Instalar"', mobile_desktop_step5: 'VendFactura se abre como app de escritorio.',
    mobile_push_badge: 'Notificaciones Push', mobile_push_title: 'Nunca Pierdas un Pago', mobile_push_desc: 'Recibe alertas instantáneas cuando se envíen recordatorios de pago, se respondan tickets o surjan eventos importantes.',
    mobile_push_item1: 'Confirmaciones de recordatorios de pago', mobile_push_item2: 'Respuestas a tickets de soporte', mobile_push_item3: 'Alertas de cuenta y seguridad',
    mobile_push_howto: 'Cómo Activar', mobile_push_step1: 'Ve a tu Panel de Control', mobile_push_step2: 'Busca el interruptor "Notificaciones Push"', mobile_push_step3: 'Haz clic en "Activar" y permite cuando el navegador pregunte',
    mobile_offline_badge: 'Modo Sin Conexión', mobile_offline_title: '¿Sin Internet? Sin Problema.', mobile_offline_desc: 'VendFactura sigue funcionando sin conexión. Procesa ventas en efectivo, crea facturas y navega tus productos. Todo se sincroniza al reconectar.',
    mobile_offline_note: 'Nota: Los pagos con tarjeta requieren internet. El envío de emails se pone en cola hasta que se restablezca la conexión.',
    mobile_offline_status: 'Modo Sin Conexión Activo', mobile_offline_pos: 'Punto de Venta', mobile_offline_invoices: 'Creación de Facturas', mobile_offline_sync: 'Sincronización Auto', mobile_offline_available: 'Disponible', mobile_offline_waiting: 'Esperando conexión',
    mobile_faq_title: 'Preguntas Frecuentes',
    mobile_faq1_q: '¿Qué es una PWA?', mobile_faq1_a: 'Una Progressive Web App (PWA) es un sitio web que funciona como una app nativa. Se instala en tu dispositivo, funciona sin conexión y envía notificaciones push — sin descargar de una tienda de apps.',
    mobile_faq2_q: '¿Es diferente de una app normal?', mobile_faq2_a: 'Funcionalmente, no. La PWA de VendFactura tiene todas las mismas funciones: modo offline, notificaciones push, icono en pantalla y experiencia a pantalla completa.',
    mobile_faq3_q: '¿Funciona en iPhone?', mobile_faq3_a: 'Sí. En iPhone y iPad, abre vendfactura.es en Safari, toca Compartir, luego "Añadir a pantalla de inicio". Las notificaciones push en iOS requieren iOS 16.4 o superior.',
    mobile_faq4_q: '¿Qué funciona sin conexión?', mobile_faq4_a: 'Punto de Venta (pagos en efectivo), creación de facturas, consulta de productos y toda la navegación. Las ventas y facturas se sincronizan al reconectar.',
    mobile_faq5_q: '¿Cómo recibo notificaciones push?', mobile_faq5_a: 'Tras instalar, ve a tu Panel de Control y haz clic en "Activar" en el interruptor de Notificaciones Push. Permite las notificaciones cuando tu navegador pregunte.',
    mobile_cta_title: '¿Listo para Ir Móvil?', mobile_cta_desc: 'Instala VendFactura en tu dispositivo ahora o descarga la guía completa con instrucciones paso a paso.', mobile_cta_login: 'Iniciar Sesión',

    // ---- Dashboard ----
    dashboard_welcome: 'Bienvenido',
    dashboard_today_sales: 'Ventas Hoy',
    dashboard_today_revenue: 'Ingresos Hoy',
    dashboard_total_products: 'Productos',
    dashboard_low_stock: 'Stock Bajo',
    dashboard_pending_invoices: 'Facturas Pendientes',
    dashboard_recent_sales: 'Ventas Recientes',
    dashboard_quick_actions: 'Acciones Rápidas',
    dashboard_open_pos: 'Abrir TPV',
    dashboard_new_product: 'Nuevo Producto',
    dashboard_create_invoice: 'Crear Factura',
    dashboard_view_reports: 'Ver Informes',
    dashboard_setup_needed: '¡Completa la configuración!',
    dashboard_setup_desc: 'Configura tu tienda para empezar a vender',
    dashboard_start_setup: 'Iniciar Configuración',
    dashboard_no_sales_yet: 'No hay ventas todavía',
    dashboard_start_selling: 'Empieza a vender',
    dashboard_this_week: 'vs. semana anterior',
    dashboard_vs_yesterday: 'vs. ayer',
    dashboard_view_all: 'Ver todo',

    // ---- Daily Briefing ----
    briefing_title: 'Resumen del Día',
    briefing_good_morning: 'Buenos días',
    briefing_good_afternoon: 'Buenas tardes',
    briefing_good_evening: 'Buenas noches',
    briefing_yesterday: 'Cierre de Ayer',
    briefing_sales: 'ventas',
    briefing_revenue: 'ingresos',
    briefing_restock: 'Productos a Reponer',
    briefing_products_low: 'productos con stock bajo',
    briefing_view_all: 'Ver todos',
    briefing_verifactu: 'Estado VeriFactu',
    briefing_all_synced: 'Todo sincronizado',
    briefing_pending_sync: 'pendientes de enviar',
    briefing_no_issues: 'Sin incidencias',
    briefing_tasks: 'Tareas del Día',
    briefing_check_stock: 'Revisar stock bajo',
    briefing_review_sales: 'Revisar ventas de ayer',
    briefing_prepare_orders: 'Preparar pedidos pendientes',

    // ---- POS ----
    pos_title: 'Punto de Venta',
    pos_search: 'Buscar producto o escanear código...',
    pos_all: 'Todos',
    pos_cart: 'Carrito',
    pos_empty: 'Carrito vacío',
    pos_add_products: 'Añade productos para comenzar',
    pos_subtotal: 'Subtotal',
    pos_tax: 'IVA',
    pos_total: 'Total',
    pos_pay: 'Cobrar',
    pos_cash: 'Efectivo',
    pos_card: 'Tarjeta',
    pos_split: 'Dividir',
    pos_cash_received: 'Efectivo recibido',
    pos_change: 'Cambio',
    pos_customer_name: 'Nombre cliente (opcional)',
    pos_complete_sale: 'Completar Venta',
    pos_print_receipt: 'Imprimir Ticket',
    pos_new_sale: 'Nueva Venta',
    pos_sale_success: '¡Venta completada!',
    pos_sale_number: 'Venta #',
    pos_quick_cash: 'Pago rápido',
    pos_exact: 'Exacto',
    pos_back: 'Volver',
    pos_items: 'artículos',
    pos_park: 'Aparcar',
    pos_void: 'Anular',
    pos_no_products: 'No hay productos',
    pos_add_first: 'Añade productos desde el catálogo',
    pos_offline_mode: 'Modo sin conexión',
    pos_offline_sales_saved: 'Las ventas se guardan localmente',
    pos_back_online: 'Conexión restaurada',
    pos_online: 'En línea',
    pos_offline: 'Sin conexión',
    pos_offline_saved: 'Venta guardada sin conexión. Se sincronizará cuando vuelva la conexión.',
    pos_pending: 'pendientes',
    pos_syncing: 'Sincronizando...',
    pos_synced: 'sincronizadas',
    pos_failed: 'fallidas',
    pos_sales_synced: 'ventas sincronizadas',
    pos_sync_partial: 'Sincronización parcial',
    pos_cached: 'Cache',

    // ---- Products ----
    products_title: 'Productos',
    products_search: 'Buscar productos...',
    products_add: 'Nuevo Producto',
    products_edit: 'Editar Producto',
    products_create: 'Crear Producto',
    products_save: 'Guardar',
    products_cancel: 'Cancelar',
    products_delete: 'Eliminar',
    products_name: 'Nombre',
    products_description: 'Descripción',
    products_price: 'Precio (€)',
    products_category: 'Categoría',
    products_barcode: 'Código de barras',
    products_stock: 'Stock',
    products_low_threshold: 'Umbral bajo',
    products_tax_rate: 'IVA',
    products_unit: 'Unidad',
    products_available: 'Disponible',
    products_all: 'Todos',
    products_no_products: 'No hay productos',
    products_add_first: 'Añade tu primer producto',
    products_confirm_delete: '¿Eliminar este producto?',
    products_yes_delete: 'Sí, eliminar',
    products_total: 'Total productos',

    // ---- Invoices ----
    inv_title: 'Facturas',
    inv_create: 'Nueva Factura',
    inv_edit: 'Editar Factura',
    inv_number: 'Nº Factura',
    inv_date: 'Fecha',
    inv_due_date: 'Vencimiento',
    inv_customer: 'Cliente',
    inv_customer_name: 'Nombre del cliente',
    inv_customer_nif: 'NIF/CIF',
    inv_customer_address: 'Dirección',
    inv_customer_city: 'Ciudad',
    inv_customer_postal: 'Código postal',
    inv_customer_email: 'Email',
    inv_items: 'Líneas',
    inv_description: 'Concepto',
    inv_quantity: 'Cant.',
    inv_price: 'Precio',
    inv_tax_rate: 'IVA %',
    inv_line_total: 'Total',
    inv_add_line: 'Añadir línea',
    inv_subtotal: 'Base imponible',
    inv_tax: 'IVA',
    inv_total: 'Total',
    inv_payment: 'Forma de pago',
    inv_bank: 'Transferencia',
    inv_cash: 'Efectivo',
    inv_card: 'Tarjeta',
    inv_other: 'Otro',
    inv_notes: 'Notas',
    inv_status: 'Estado',
    inv_draft: 'Borrador',
    inv_issued: 'Emitida',
    inv_paid: 'Pagada',
    inv_cancelled: 'Anulada',
    inv_save: 'Guardar Factura',
    inv_download_pdf: 'Descargar PDF',
    inv_mark_paid: 'Marcar como Pagada',
    inv_cancel_invoice: 'Anular',
    inv_verify: 'Verificar Hash',
    inv_verifactu: 'VeriFactu',
    inv_hash_valid: 'Hash válido',
    inv_hash_invalid: 'Hash alterado',
    inv_no_invoices: 'No hay facturas',
    inv_create_first: 'Crea tu primera factura',
    inv_all: 'Todas',
    inv_search: 'Buscar facturas...',

    // Payment
    pay_processing: 'Procesando pago...',
    pay_wait: 'Por favor espera mientras confirmamos tu pago.',
    pay_success: 'Pago Exitoso!',
    pay_success_desc: 'Tu suscripción está activa.',
    pay_plan: 'Plan',
    pay_go_dashboard: 'Ir al Panel',
    pay_go_invoices: 'Crear Facturas',
    pay_back_home: 'Volver al Inicio',
    pay_error: 'Error de Pago',
    pay_error_desc: 'Hubo un problema con tu pago. Inténtalo de nuevo.',
    pay_try_again: 'Intentar de Nuevo',
    pay_cancelled: 'Pago Cancelado',
    pay_cancelled_desc: 'No se realizó ningún cargo. Puedes intentarlo en cualquier momento.',
    pay_back_pricing: 'Volver a Precios',


  // ======================== ENGLISH ========================
    // Invoice Portal
    inv_portal_dashboard: 'Panel',
    inv_portal_title: 'Portal de Facturas',
    inv_portal_welcome: 'Bienvenido',
    inv_portal_subtitle: 'Portal de Facturas VeriFactu',
    inv_portal_total_invoices: 'Total Facturas',
    inv_portal_pending: 'Pendientes',
    inv_portal_paid: 'Pagadas',
    inv_portal_revenue: 'Ingresos',
    inv_portal_recent: 'Facturas Recientes',
    inv_portal_view_all: 'Ver Todas',
    inv_portal_business: 'Datos del Negocio',
    inv_portal_biz_name: 'Nombre del Negocio',
    inv_setup_title: 'Configura Tu Negocio',
    inv_setup_desc: 'Introduce los datos de tu negocio para facturas VeriFactu',
    inv_setup_name: 'Nombre del Negocio',
    inv_setup_legal: 'Razón Social',
    inv_setup_submit: 'Crear Negocio y Empezar a Facturar',
    inv_setup_phone: 'Teléfono',

    // Stock Management
    stock_title: 'Gestión de Stock', stock_tracked: 'productos rastreados',
    stock_total: 'Total Productos', stock_low: 'Stock Bajo', stock_out: 'Sin Stock',
    stock_ok: 'OK', stock_unlimited: 'Ilimitado',
    stock_overview: 'Vista General', stock_history: 'Historial', stock_scanner: 'Escáner IA',
    stock_product: 'Producto', stock_category: 'Categoría', stock_current: 'Stock',
    stock_threshold: 'Mín', stock_status: 'Estado', stock_search: 'Buscar productos...',
    stock_alert_title: 'Alerta de Stock Bajo', stock_items: 'artículos',
    stock_add: 'Añadir Stock', stock_adjust: 'Ajustar', stock_adjust_title: 'Ajustar Stock',
    stock_type: 'Tipo', stock_intake: 'Entrada', stock_sale: 'Venta',
    stock_adjustment: 'Ajuste', stock_loss: 'Pérdida', stock_return: 'Devolución',
    stock_supplier: 'Proveedor', stock_cost: 'Coste/Unidad (€)', stock_confirm: 'Confirmar',
    stock_no_movements: 'Sin movimientos de stock',
    stock_scan_title: 'Escáner IA de Recibos',
    stock_scan_desc: 'Sube una foto de un recibo de proveedor para extraer productos',
    stock_upload: 'Subir Recibo', stock_scanning: 'Escaneando...',
    stock_scan_results: 'Resultados', stock_matched: 'Productos Coincidentes',
    stock_unmatched: 'No Coincidentes', stock_confirm_intake: 'Confirmar Entrada',
    stock_scan_error: 'Error al escanear',
    stock_cost_price: 'Coste', stock_sale_price: 'Precio Venta',
    stock_reorder: 'Sugerencias de Pedido', stock_reorder_desc: 'Basado en velocidad de ventas de los últimos 30 días',
    stock_reorder_all_good: 'Todo Abastecido!', stock_reorder_no_items: 'No hay productos que necesiten pedido.',
    stock_reorder_velocity: 'Ventas/Día', stock_reorder_days_left: 'Días Restantes',
    stock_reorder_qty: 'Cantidad Sugerida', stock_reorder_est_cost: 'Coste Est.',
    stock_reorder_urgency: 'Urgencia',
    stock_urgency_critical: 'Crítico', stock_urgency_urgent: 'Urgente',
    stock_urgency_soon: 'Pronto', stock_urgency_ok: 'OK',

    // Reports
    reports_title: 'Informes', reports_subtitle: 'Análisis de ventas e informes del día',
    reports_daily: 'Informe Diario', reports_weekly: 'Resumen Semanal',
    reports_today: 'Hoy', reports_revenue: 'Ingresos', reports_sales: 'Ventas',
    reports_avg: 'Venta Media', reports_invoices: 'Facturas',
    reports_payment_split: 'Métodos de Pago', reports_no_sales: 'Sin ventas para este día',
    reports_hourly: 'Desglose por Hora', reports_top_products: 'Productos Top',
    reports_sales_short: 'ventas', reports_cash: 'Efectivo', reports_card: 'Tarjeta',
    reports_weekly_summary: 'Resumen Semanal',
    reports_total_revenue: 'Ingresos Totales', reports_total_sales: 'Ventas Totales',
    reports_daily_avg: 'Media Diaria', reports_daily_breakdown: 'Desglose Diario',

    // Staff
    staff_title: 'Gestión de Personal', staff_members: 'miembros',
    staff_add: 'Añadir Personal', staff_active: 'Personal Activo',
    staff_inactive: 'Personal Inactivo', staff_empty: 'Sin Personal',
    staff_empty_desc: 'Añade tu primer miembro del equipo',
    staff_name: 'Nombre', staff_role_label: 'Rol',
    staff_role_manager: 'Gerente', staff_role_cashier: 'Cajero',
    staff_role_stock_clerk: 'Almacenero', staff_role_driver: 'Repartidor',
    staff_edit: 'Editar', staff_save: 'Guardar', staff_create: 'Crear',
    staff_delete: 'Eliminar', staff_delete_confirm: '¿Eliminar este miembro?',
    staff_deactivate: 'Desactivar', staff_activate: 'Activar',
    staff_regen_pin: 'Nuevo PIN', staff_new_pin: 'Nuevo PIN',
    notif_title: 'Notificaciones', notif_mark_all: 'Marcar todo leído', notif_empty: 'Sin notificaciones',
    // Receipt
    receipt_ticket: 'Ticket', receipt_subtotal: 'Subtotal', receipt_tax: 'IVA', receipt_payment: 'Pago',
    receipt_received: 'Recibido', receipt_change: 'Cambio', receipt_thanks: 'Gracias por su compra',
    // Invoice Email
    inv_send_email: 'Enviar por Email', inv_send: 'Enviar', inv_email_required: 'Email requerido',
    inv_email_sent: 'Factura enviada por email', inv_email_failed: 'Error al enviar email',
    inv_email_sent_to: 'Enviado a',
    // Print Settings
    print_title: 'Impresora', print_subtitle: 'Configurar impresora de tickets',
    print_how_title: 'Como conectar su impresora',
    print_usb_guide: 'USB: Conecte la impresora y selecciónela en el diálogo de impresión',
    print_wifi_guide: 'WiFi: Configure la IP de la impresora en su red local',
    print_browser_guide: 'Navegador: Use Ctrl+P o el botón Imprimir en el POS',
    print_paper_size: 'Tamaño de Papel', print_80mm_desc: 'Estándar para la mayoría de impresoras',
    print_58mm_desc: 'Impresoras compactas y portátiles',
    print_receipt_options: 'Opciones de Ticket', print_auto_print: 'Imprimir automáticamente después de venta',
    print_show_header: 'Mostrar datos de la tienda', print_show_footer: 'Mostrar pie de ticket',
    print_test: 'Imprimir Ticket de Prueba',
    // Payment Settings
    shop_nav_payments: 'Pagos',
    paysettings_title: 'Opciones de Pago',
    paysettings_subtitle: 'Configure las opciones de pago que verán sus clientes en las facturas',
    paysettings_info: 'Estas opciones de pago se mostrarán a sus clientes cuando vean sus facturas online. Puede añadir transferencias bancarias (EU/UK), efectivo u otros métodos.',
    paysettings_save: 'Guardar', paysettings_saved: 'Guardado',
    paysettings_empty: 'No hay métodos de pago configurados',
    paysettings_add: 'Añadir Método de Pago',
    paysettings_label: 'Nombre del Método', paysettings_bank_name: 'Nombre del Banco',
    paysettings_holder: 'Titular de la Cuenta', paysettings_sort_code: 'Sort Code',
    paysettings_acc_number: 'Número de Cuenta', paysettings_instructions: 'Instrucciones',
    // Invoice Portal
    inv_copy_link: 'Copiar Enlace', inv_view_online: 'Ver Online',
    inv_link_copied: 'Enlace copiado al portapapeles',
    // Reminders
    reminder_title: 'Recordatorios de Pago', reminder_desc: 'Enviar recordatorios automáticos a clientes con facturas vencidas',
    reminder_days_label: 'Enviar recordatorio después de', reminder_after: 'Después de',
    reminder_days_unit: 'días', reminder_add_day: 'Añadir intervalo',
    reminder_max: 'Máximo de recordatorios por factura', reminder_send_now: 'Enviar Recordatorios Ahora',
    reminder_sent_count: 'recordatorios enviados', inv_reminders_sent: 'Recordatorios enviados',
    // Delivery
    dlv_title: 'Entregas', dlv_subtitle: 'Gestionar pedidos y repartidores',
    dlv_new_delivery: 'Nueva Entrega', dlv_add_driver: 'Añadir Repartidor',
    dlv_orders: 'Pedidos', dlv_drivers: 'Repartidores', dlv_all: 'Todos',
    dlv_pending: 'Pendiente', dlv_in_progress: 'En Curso', dlv_delivered: 'Entregado', dlv_failed: 'Fallido',
    dlv_drivers_available: 'Disponibles', dlv_revenue: 'Ingresos',
    dlv_assign: 'Asignar', dlv_picked_up: 'Recogido', dlv_mark_delivered: 'Entregado', dlv_mark_failed: 'Fallido',
    dlv_cancel: 'Cancelar', dlv_select_driver: 'Seleccionar repartidor',
    dlv_no_available_drivers: 'No hay repartidores disponibles',
    dlv_no_deliveries: 'Sin entregas', dlv_no_drivers: 'Sin repartidores',
    dlv_customer_name: 'Nombre Cliente', dlv_customer_phone: 'Teléfono',
    dlv_address: 'Dirección de Entrega', dlv_city: 'Ciudad', dlv_payment: 'Pago',
    dlv_fee: 'Tarifa Entrega', dlv_notes: 'Notas', dlv_create: 'Crear Entrega',
    dlv_driver_name: 'Nombre', dlv_driver_phone: 'Teléfono', dlv_vehicle: 'Vehículo',
    dlv_motorcycle: 'Moto', dlv_car: 'Coche', dlv_bicycle: 'Bicicleta', dlv_van: 'Furgoneta',
    dlv_available: 'Disponible', dlv_busy: 'Ocupado', dlv_completed: 'completadas',
    dlv_delete_driver_confirm: '¿Eliminar repartidor?',
    // SMTP Settings
    shop_nav_smtp: 'Email SMTP', shop_nav_email_templates: 'Plantillas Email',
    smtp_title: 'Configuración SMTP',
    smtp_subtitle: 'Configure su propio servidor SMTP para enviar emails desde su dominio',
    smtp_verified: 'Verificado', smtp_not_verified: 'No Verificado',
    smtp_config_title: 'Configuración SMTP',
    smtp_config_desc: 'Configure su servidor de correo saliente',
    smtp_preset: 'Proveedor Email',
    smtp_preset_hint: 'Seleccione un proveedor para auto-completar los datos del servidor, o elija Custom.',
    smtp_host: 'Servidor SMTP', smtp_port: 'Puerto SMTP',
    smtp_username: 'Usuario', smtp_password: 'Contraseña',
    smtp_password_hint: 'dejar vacío para mantener actual',
    smtp_password_required_new: 'La contraseña es obligatoria para una nueva configuración',
    smtp_from_email: 'Email Remitente', smtp_from_name: 'Nombre Remitente',
    smtp_tls: 'Cifrado TLS',
    smtp_tls_465: 'Puerto 465 usa SSL directo. TLS no aplicable.',
    smtp_tls_587: 'Recomendado para puerto 587. Desactivar para SSL en puerto 465.',
    smtp_save: 'Guardar Configuración',
    smtp_saved: 'Configuración SMTP guardada',
    smtp_fill_required: 'Complete todos los campos obligatorios',
    smtp_test_title: 'Enviar Email de Prueba',
    smtp_test_desc: 'Verifique su configuración enviando un email de prueba',
    smtp_test_recipient: 'Email Destinatario',
    smtp_test_message: 'Mensaje personalizado (opcional)',
    smtp_test_message_placeholder: 'Escriba un mensaje personalizado para el email de prueba...',
    smtp_send_test: 'Enviar Prueba',
    smtp_sending: 'Enviando...',
    smtp_enter_recipient: 'Introduzca un email destinatario',
    smtp_test_success: 'Email de prueba enviado correctamente',
    smtp_save_first: 'Guarde la configuración SMTP primero antes de enviar una prueba',
    smtp_last_tested: 'Última prueba',
    // Email Templates
    et_title: 'Plantillas de Email',
    et_subtitle: 'Cree y gestione plantillas de notificación por email',
    et_create: 'Crear Plantilla', et_add_defaults: 'Añadir Plantillas Predeterminadas',
    et_empty: 'No hay plantillas aún',
    et_empty_hint: 'Cree su primera plantilla o añada las predeterminadas',
    et_create_title: 'Crear Plantilla', et_edit_title: 'Editar Plantilla',
    et_create_desc: 'Configure su plantilla de notificación', et_edit_desc: 'Actualice su plantilla de notificación',
    et_name: 'Nombre Plantilla', et_name_placeholder: 'Ej: Email de Bienvenida',
    et_channel: 'Canal', et_event_type: 'Tipo de Evento',
    et_subject: 'Asunto', et_subject_placeholder: 'Asunto del email con {{variables}}',
    et_body: 'Cuerpo del Mensaje', et_body_placeholder: 'Escriba el cuerpo del email. Use {{variable}} para insertar datos dinámicos.',
    et_placeholders: 'Variables',
    et_active: 'Plantilla activa', et_inactive: 'Inactiva',
    et_cancel: 'Cancelar', et_save: 'Guardar', et_update: 'Actualizar',
    et_updated: 'Plantilla actualizada', et_created: 'Plantilla creada',
    et_deleted: 'Plantilla eliminada', et_confirm_delete: '¿Está seguro de eliminar esta plantilla?',
    et_fill_required: 'Complete nombre, asunto y cuerpo',
    et_preview: 'Vista Previa', et_edit: 'Editar', et_delete: 'Eliminar', et_send_test: 'Enviar Prueba',
    et_test_sent: 'Email de prueba enviado',
    et_preview_title: 'Vista Previa de Plantilla',
    et_preview_desc: 'Así se verá su email con datos de ejemplo',
    et_preview_plain: 'Texto Plano', et_preview_email: 'Email HTML',
  },
  en: {
    nav_features: 'Features', nav_pricing: 'Pricing', nav_about: 'About',
    nav_contact: 'Contact', nav_faq: 'FAQ', nav_login: 'Log In', nav_register: 'Sign Up',
    nav_mobile: 'Mobile App',

    hero_badge: 'VeriFactu Compliance Guaranteed',
    hero_title: 'Your Shop.', hero_title_2: 'Compliant. Simple.',
    hero_subtitle: 'POS system and VeriFactu-compliant invoicing for Spanish shops and freelancers. The VeriFactu deadline is coming - are you ready?',
    hero_cta_pos: 'Full POS €19.99/mo', hero_cta_invoice: 'Invoices Only €4.99/mo',
    hero_trusted: 'Trusted by 500+ Spanish businesses',

    // Demo Video
    demo_badge: 'Full Demo',
    demo_title: 'VendFactura POS System \u2014 Complete Walkthrough',
    demo_subtitle: 'Watch our complete walkthrough \u2014 from taking your first order to managing your stock, all in under 5 minutes.',
    demo_play_title: 'VendFactura POS \u2014 Full Demo',
    demo_play_cta: 'Click to play',
    demo_coming_soon: 'Demo video coming soon \u2014 subscribe to get notified!',
    demo_hl_pos: 'Point of Sale', demo_hl_invoicing: 'VeriFactu Invoicing', demo_hl_stock: 'Stock Management', demo_hl_reports: 'Reports & Analytics',

    features_title: 'Everything You Need',
    features_subtitle: 'From POS to invoices, stock management and much more',
    feature_pos_title: 'Complete POS System',
    feature_pos_desc: 'Barcode scanner, cash and card payments, thermal receipts, offline mode and more.',
    feature_invoice_title: 'VeriFactu Invoices',
    feature_invoice_desc: 'AEAT-compliant invoices with QR codes, hash chain and automatic submission.',
    feature_stock_title: 'Stock Management',
    feature_stock_desc: 'AI receipt scanning, low stock alerts, expiry dates and automatic reordering.',
    feature_staff_title: 'Staff Management',
    feature_staff_desc: 'PIN access, roles (cashier, manager, stock), activity logging.',
    feature_reports_title: 'End of Day Reports',
    feature_reports_desc: 'Daily summaries, hourly sales, top products, export to CSV.',
    feature_delivery_title: 'Home Delivery',
    feature_delivery_desc: 'Driver management, order tracking, configurable delivery fees.',

    // Problem/Solution Section
    problem_title: 'Tired of Using Multiple Disconnected Tools?',
    problem_subtitle: 'Most shop owners waste hours every day switching between separate apps for sales, invoicing, stock, and tax compliance. Your POS doesn\'t talk to your invoicing. Sound familiar?',
    problem_tool_pos: 'POS System', problem_tool_invoicing: 'Invoicing', problem_tool_stock: 'Stock Management',
    problem_tool_staff: 'Staff Management', problem_tool_delivery: 'Delivery Tracking', problem_tool_payments: 'Payments',
    problem_tool_reports: 'Reports', problem_tool_compliance: 'Tax Compliance',
    problem_solution: 'One Platform. Everything Connected.',

    // Feature Tabs
    feature_tab_pos: 'Point of Sale', feature_tab_invoicing: 'Invoicing', feature_tab_stock: 'Stock',
    feature_tab_delivery: 'Delivery', feature_tab_reports: 'Reports',
    feature_pos_long_desc: 'A touch-optimized POS system that works on any device. Process orders quickly, handle cash and card payments, and print thermal receipts. Works offline so you never miss a sale.',
    feature_pos_f1: 'Quick order entry with product grid',
    feature_pos_f2: 'Cash & card payment processing',
    feature_pos_f3: 'USB barcode scanner support',
    feature_pos_f4: 'ESC/POS thermal receipt printing',
    feature_pos_f5: 'Staff PIN lock for shared terminals',
    feature_pos_f6: 'Full offline mode with auto-sync',

    // Why Choose Section
    why_title: 'Why Shop Owners Choose VendFactura',
    why_subtitle: 'We\'ve removed every barrier to getting started. No expensive hardware, no complex setup, no long-term contracts.',
    why_hardware_title: 'No Hardware Required', why_hardware_desc: 'Works on any tablet, phone, or computer you already own. No expensive terminals needed.',
    why_setup_title: 'Setup in Minutes', why_setup_desc: 'Sign up, add your products, and start selling today. No technician visits or complex configuration.',
    why_cloud_title: 'Cloud-Based', why_cloud_desc: 'Access your data from anywhere. Updates happen automatically. Always running the latest version.',
    why_secure_title: 'Secure & Reliable', why_secure_desc: 'Bank-level encryption. Daily backups. Your business data is always protected and available.',

    // VeriFactu Expanded
    vf_section_title: 'VeriFactu Ready',
    vf_section_subtitle: 'VendFactura is fully prepared for Spain\'s new anti-fraud invoicing requirements. Your business stays compliant automatically.',
    vf_mandatory_title: 'VeriFactu is Mandatory',
    vf_mandatory_desc: 'Spain\'s anti-fraud regulation requires ALL businesses using invoicing software to comply:',
    vf_who_1: 'Companies (SL, SA)', vf_who_2: 'Freelancers (Autonomos)', vf_who_3: 'Shops, Restaurants & Bars', vf_who_4: 'Retail & All Businesses',
    vf_what_requires: 'What VeriFactu Requires:',
    vf_req_1: 'Invoice integrity - No deletion or manipulation',
    vf_req_2: 'Traceability - Complete audit trail',
    vf_req_3: 'QR codes on all invoices for verification',
    vf_req_4: 'Automatic reporting to AEAT (Tax Authority)',
    vf_ready_title: 'VendFactura is Ready',
    vf_ready_1: '100% VeriFactu Compliant',
    vf_ready_2: 'Cryptographic Hash Chain - Every invoice cryptographically linked',
    vf_ready_3: 'Automatic QR Codes on every receipt',
    vf_ready_4: 'AEAT Integration - Automatic submission to Tax Authority',
    vf_ready_5: 'Spanish IVA Support: 21%, 10%, 4%, 0%',

    // CTA trust items
    cta_trust_1: '14-day free trial', cta_trust_2: 'No credit card required', cta_trust_3: 'Cancel anytime',
    testimonials_subtitle: 'Trusted by shop owners and freelancers across Spain',

    // Mobile Install
    mobile_install_guide_btn: 'How to Install',

    verifactu_label: 'AEAT REGULATION', verifactu_title: 'VeriFactu Requires You',
    verifactu_subtitle: 'From July 2027, all Spanish businesses must use approved invoicing software. VendFactura is already ready.',
    verifactu_feature_1: 'Verifiable SHA-256 hash chain', verifactu_feature_2: 'QR codes on every invoice',
    verifactu_feature_3: 'Direct connection to AEAT', verifactu_feature_4: 'Integrated digital certificate',
    verifactu_approved: 'APPROVED', verifactu_cta: 'Get Compliant Today',

    pricing_title: 'Clear Pricing',
    pricing_subtitle: 'No surprises. No hidden fees. Cancel anytime.',
    pricing_invoice_title: 'Invoices', pricing_invoice_subtitle: 'For freelancers and small businesses',
    pricing_invoice_price: '€4.99', pricing_invoice_period: '/mo',
    pricing_invoice_features: [
      'Unlimited VeriFactu invoices', 'PDF generation with QR', 'Client directory',
      'Customizable templates', 'Recurring invoices', 'Payment tracking',
      'Export to CSV/Excel', 'Mobile app iOS/Android', 'Email support'
    ],
    pricing_pos_title: 'Shop POS', pricing_pos_subtitle: 'For shops and stores',
    pricing_pos_price: '€19.99', pricing_pos_period: '/mo',
    pricing_pos_features: [
      'Everything in Invoices +', 'Complete POS system', 'Barcode scanner',
      'Stock management with alerts', 'AI receipt scanning', 'Staff management with PIN',
      'End of day reports', 'ESC/POS thermal printer', 'Offline mode',
      'Home delivery', 'Priority support'
    ],
    pricing_popular: 'Most Popular', pricing_cta_invoice: 'Start with Invoices',
    pricing_cta_pos: 'Start with POS',
    pricing_launch: 'SPECIAL OFFER: Sign up before 1st May 2026 - 50% OFF on yearly plans',
    pricing_monthly: 'Monthly',
    pricing_yearly: 'Yearly',
    pricing_yearly_save: 'Save 15%',
    pricing_per_month: '/mo',
    pricing_per_year: '/year',
    pricing_billed_yearly: 'billed annually',

    testimonials_title: 'What Our Customers Say',
    testimonial_1_text: '"VendFactura saved me from a fine. Now my invoices comply with VeriFactu without doing anything special."',
    testimonial_1_author: 'María García', testimonial_1_role: 'Grocery store, Madrid',
    testimonial_2_text: '"The barcode scanner is super fast. My customers no longer wait in line."',
    testimonial_2_author: 'Antonio López', testimonial_2_role: 'Tobacco shop, Barcelona',
    testimonial_3_text: '"As a freelancer, I only needed invoicing. For €4.99/month I have everything sorted."',
    testimonial_3_author: 'Carlos Ruiz', testimonial_3_role: 'Freelance designer, Valencia',

    faq_title: 'Frequently Asked Questions',
    faq_1_q: 'What is VeriFactu?',
    faq_1_a: 'VeriFactu is the new AEAT system that requires all invoicing software to generate verifiable invoices with QR codes and hash chains. It is mandatory from July 2027.',
    faq_2_q: 'Can I try before paying?',
    faq_2_a: 'Yes, we offer a 14-day free trial without requiring a credit card.',
    faq_3_q: 'Does it work without internet?',
    faq_3_a: 'Yes, offline mode allows you to keep selling even without connection. Sales sync automatically when you reconnect.',
    faq_4_q: 'What printers are supported?',
    faq_4_a: 'Any thermal printer with ESC/POS (most on the market). Connection via Bluetooth, USB or WiFi.',
    faq_5_q: 'Can I change plans?',
    faq_5_a: 'Yes, you can upgrade from Invoices to POS at any time. The change is immediate.',

    cta_title: 'Ready to Comply with VeriFactu?',
    cta_subtitle: 'Join hundreds of Spanish businesses that are already prepared',
    cta_button: 'Start Free',

    footer_description: 'POS system and VeriFactu invoicing for Spanish shops.',
    footer_product: 'Product', footer_company: 'Company', footer_legal: 'Legal',
    footer_terms: 'Terms & Conditions', footer_privacy: 'Privacy Policy', footer_cookies: 'Cookie Policy',
    footer_copyright: '© 2025 VendFactura. All rights reserved.', footer_made: 'Made with love in Spain',

    auth_login: 'Log In', auth_register: 'Sign Up', auth_email: 'Email',
    auth_password: 'Password', auth_forgot: 'Forgot your password?',
    auth_no_account: "Don't have an account?", auth_has_account: 'Already have an account?',

    shop_nav_dashboard: 'Dashboard', shop_nav_pos: 'Point of Sale', shop_nav_products: 'Products',
    shop_nav_stock: 'Stock', shop_nav_invoices: 'Invoices', shop_nav_staff: 'Staff',
    shop_nav_reports: 'Reports', shop_nav_delivery: 'Delivery', shop_nav_printer: 'Printer',
    shop_nav_settings: 'Settings', shop_nav_help: 'Help', shop_nav_logout: 'Log Out',
    shop_nav_tickets: 'Support',
    tickets_title: 'Support Tickets', tickets_subtitle: 'Manage your support requests',
    tickets_new: 'New Ticket', tickets_empty: 'No tickets', tickets_empty_desc: 'Create a ticket if you need help',
    tickets_subject: 'Subject', tickets_category: 'Category', tickets_priority: 'Priority',
    tickets_message: 'Message', tickets_submit: 'Submit Ticket',
    tickets_reply_placeholder: 'Type your reply...', tickets_close: 'Close ticket',
    tickets_closed_msg: 'This ticket is closed',

    // Mobile App Page
    mobile_badge: 'Progressive Web App',
    mobile_hero_title: 'VendFactura on Your Phone',
    mobile_hero_subtitle: 'Install VendFactura as a mobile app. Full POS, invoicing, and VeriFactu compliance — right in your pocket. No app store needed.',
    mobile_install_btn: 'Install Now', mobile_download_guide: 'Download PDF Guide',
    mobile_features_title: 'Everything You Need, On Any Device', mobile_features_subtitle: 'The VendFactura PWA brings the full power of our platform to your pocket.',
    mobile_feat_offline_title: 'Works Offline', mobile_feat_offline_desc: 'Process sales and create invoices without internet. Data syncs automatically when you reconnect.',
    mobile_feat_push_title: 'Push Notifications', mobile_feat_push_desc: 'Get notified about payment reminders, support ticket replies, and important account updates.',
    mobile_feat_fast_title: 'Fast & Lightweight', mobile_feat_fast_desc: 'No app store download. Installs in seconds, uses minimal storage, and loads instantly.',
    mobile_feat_update_title: 'Always Up to Date', mobile_feat_update_desc: 'No manual updates needed. You always have the latest version automatically.',
    mobile_feat_secure_title: 'Secure & Encrypted', mobile_feat_secure_desc: 'Runs over HTTPS with full data encryption. Your business data is always protected.',
    mobile_feat_cross_title: 'Cross-Platform', mobile_feat_cross_desc: 'Works on Android, iOS, Windows, macOS, and Linux. One app for all your devices.',
    mobile_install_title: 'Install in 30 Seconds', mobile_install_subtitle: 'Choose your device and follow the simple steps below.',
    mobile_android_step1: 'Open Chrome and go to vendfactura.es', mobile_android_step2: 'Log in to your account', mobile_android_step3: 'Tap the three-dot menu (top right)', mobile_android_step4: 'Select "Add to Home Screen" or "Install App"', mobile_android_step5: 'Tap "Install" to confirm', mobile_android_step6: 'VendFactura icon appears on your home screen!',
    mobile_ios_step1: 'Open Safari (must be Safari, not Chrome)', mobile_ios_step2: 'Go to vendfactura.es and log in', mobile_ios_step3: 'Tap the Share button (square with arrow)', mobile_ios_step4: 'Scroll down and tap "Add to Home Screen"', mobile_ios_step5: 'Tap "Add" to confirm', mobile_ios_step6: 'VendFactura icon appears on your home screen!',
    mobile_ios_note: 'Important: On iOS, PWAs must be installed from Safari. Chrome and other browsers on iOS do not support PWA installation.',
    mobile_desktop_step1: 'Open Chrome or Edge on your computer', mobile_desktop_step2: 'Go to vendfactura.es and log in', mobile_desktop_step3: 'Click the install icon in the address bar', mobile_desktop_step4: 'Click "Install" in the popup', mobile_desktop_step5: 'VendFactura opens as a standalone desktop app!',
    mobile_push_badge: 'Push Notifications', mobile_push_title: 'Never Miss a Payment', mobile_push_desc: 'Get instant alerts on your phone when payment reminders are sent, support tickets are answered, or important events need your attention.',
    mobile_push_item1: 'Payment reminder confirmations', mobile_push_item2: 'Support ticket replies', mobile_push_item3: 'Account and security alerts',
    mobile_push_howto: 'How to Enable', mobile_push_step1: 'Go to your Shop Dashboard', mobile_push_step2: 'Find the "Push Notifications" toggle', mobile_push_step3: 'Click "Enable" and allow when browser asks',
    mobile_offline_badge: 'Offline Mode', mobile_offline_title: 'No Internet? No Problem.', mobile_offline_desc: 'VendFactura keeps working even without an internet connection. Process cash sales, create invoices, and browse your products. Everything syncs automatically when you are back online.',
    mobile_offline_note: 'Note: Card payments require internet. Email delivery queues until connectivity is restored.',
    mobile_offline_status: 'Offline Mode Active', mobile_offline_pos: 'Point of Sale', mobile_offline_invoices: 'Invoice Creation', mobile_offline_sync: 'Auto Sync', mobile_offline_available: 'Available', mobile_offline_waiting: 'Waiting for connection',
    mobile_faq_title: 'Frequently Asked Questions',
    mobile_faq1_q: 'What is a PWA?', mobile_faq1_a: 'A Progressive Web App (PWA) is a website that works like a native app. It can be installed on your device, work offline, and send push notifications — without downloading from an app store.',
    mobile_faq2_q: 'Is it different from a regular app?', mobile_faq2_a: 'Functionally, no. The VendFactura PWA has all the same features: offline mode, push notifications, home screen icon, and full-screen experience. The only difference is you install it from your browser.',
    mobile_faq3_q: 'Does it work on iPhone?', mobile_faq3_a: 'Yes! On iPhone and iPad, open vendfactura.es in Safari, tap the Share button, then "Add to Home Screen". Push notifications on iOS require iOS 16.4 or later.',
    mobile_faq4_q: 'What works offline?', mobile_faq4_a: 'Point of Sale (cash payments), invoice creation, product browsing, and all navigation. Sales and invoices sync automatically when you reconnect. Card payments require internet.',
    mobile_faq5_q: 'How do I get push notifications?', mobile_faq5_a: 'After installing, go to your Dashboard and click "Enable" on the Push Notifications toggle. Allow notifications when your browser asks.',
    mobile_cta_title: 'Ready to Go Mobile?', mobile_cta_desc: 'Install VendFactura on your device now or download the complete guide for step-by-step instructions.', mobile_cta_login: 'Log In to Your Account',

    dashboard_welcome: 'Welcome', dashboard_today_sales: "Today's Sales",
    dashboard_today_revenue: "Today's Revenue", dashboard_total_products: 'Products',
    dashboard_low_stock: 'Low Stock', dashboard_pending_invoices: 'Pending Invoices',
    dashboard_recent_sales: 'Recent Sales', dashboard_quick_actions: 'Quick Actions',
    dashboard_open_pos: 'Open POS', dashboard_new_product: 'New Product',
    dashboard_create_invoice: 'Create Invoice', dashboard_view_reports: 'View Reports',
    dashboard_setup_needed: 'Complete Setup!', dashboard_setup_desc: 'Set up your shop to start selling',
    dashboard_start_setup: 'Start Setup', dashboard_no_sales_yet: 'No sales yet',
    dashboard_start_selling: 'Start selling', dashboard_this_week: 'vs. last week',
    dashboard_vs_yesterday: 'vs. yesterday', dashboard_view_all: 'View all',

    briefing_title: 'Daily Briefing', briefing_good_morning: 'Good morning',
    briefing_good_afternoon: 'Good afternoon', briefing_good_evening: 'Good evening',
    briefing_yesterday: "Yesterday's Closing", briefing_sales: 'sales', briefing_revenue: 'revenue',
    briefing_restock: 'Restock Needed', briefing_products_low: 'products low on stock',
    briefing_view_all: 'View all', briefing_verifactu: 'VeriFactu Status',
    briefing_all_synced: 'All synced', briefing_pending_sync: 'pending submission',
    briefing_no_issues: 'No issues', briefing_tasks: "Today's Tasks",
    briefing_check_stock: 'Check low stock items', briefing_review_sales: "Review yesterday's sales",
    briefing_prepare_orders: 'Prepare pending orders',

    pos_title: 'Point of Sale', pos_search: 'Search product or scan barcode...',
    pos_all: 'All', pos_cart: 'Cart', pos_empty: 'Cart empty',
    pos_add_products: 'Add products to start', pos_subtotal: 'Subtotal', pos_tax: 'VAT',
    pos_total: 'Total', pos_pay: 'Pay', pos_cash: 'Cash', pos_card: 'Card', pos_split: 'Split',
    pos_cash_received: 'Cash received', pos_change: 'Change',
    pos_customer_name: 'Customer name (optional)', pos_complete_sale: 'Complete Sale',
    pos_print_receipt: 'Print Receipt', pos_new_sale: 'New Sale',
    pos_sale_success: 'Sale completed!', pos_sale_number: 'Sale #',
    pos_quick_cash: 'Quick cash', pos_exact: 'Exact', pos_back: 'Back', pos_items: 'items',
    pos_park: 'Park', pos_void: 'Void', pos_no_products: 'No products',
    pos_add_first: 'Add products from catalog',
    pos_offline_mode: 'Offline mode', pos_offline_sales_saved: 'Sales are saved locally',
    pos_back_online: 'Back online', pos_online: 'Online', pos_offline: 'Offline',
    pos_offline_saved: 'Sale saved offline. Will sync when connection returns.',
    pos_pending: 'pending', pos_syncing: 'Syncing...', pos_synced: 'synced',
    pos_failed: 'failed', pos_sales_synced: 'sales synced', pos_sync_partial: 'Partial sync',
    pos_cached: 'Cached',

    products_title: 'Products', products_search: 'Search products...',
    products_add: 'New Product', products_edit: 'Edit Product', products_create: 'Create Product',
    products_save: 'Save', products_cancel: 'Cancel', products_delete: 'Delete',
    products_name: 'Name', products_description: 'Description', products_price: 'Price (€)',
    products_category: 'Category', products_barcode: 'Barcode', products_stock: 'Stock',
    products_low_threshold: 'Low threshold', products_tax_rate: 'VAT', products_unit: 'Unit',
    products_available: 'Available', products_all: 'All', products_no_products: 'No products found',
    products_add_first: 'Add your first product', products_confirm_delete: 'Delete this product?',
    products_yes_delete: 'Yes, delete', products_total: 'Total products',

    inv_title: 'Invoices', inv_create: 'New Invoice', inv_edit: 'Edit Invoice',
    inv_number: 'Invoice #', inv_date: 'Date', inv_due_date: 'Due Date',
    inv_customer: 'Customer', inv_customer_name: 'Customer name', inv_customer_nif: 'Tax ID (NIF)',
    inv_customer_address: 'Address', inv_customer_city: 'City', inv_customer_postal: 'Postal code',
    inv_customer_email: 'Email', inv_items: 'Line Items', inv_description: 'Description',
    inv_quantity: 'Qty', inv_price: 'Price', inv_tax_rate: 'VAT %', inv_line_total: 'Total',
    inv_add_line: 'Add line', inv_subtotal: 'Subtotal', inv_tax: 'VAT', inv_total: 'Total',
    inv_payment: 'Payment method', inv_bank: 'Bank transfer', inv_cash: 'Cash', inv_card: 'Card', inv_other: 'Other',
    inv_notes: 'Notes', inv_status: 'Status', inv_draft: 'Draft', inv_issued: 'Issued',
    inv_paid: 'Paid', inv_cancelled: 'Cancelled', inv_save: 'Save Invoice',
    inv_download_pdf: 'Download PDF', inv_mark_paid: 'Mark as Paid', inv_cancel_invoice: 'Cancel',
    inv_verify: 'Verify Hash', inv_verifactu: 'VeriFactu', inv_hash_valid: 'Hash valid',
    inv_hash_invalid: 'Hash tampered', inv_no_invoices: 'No invoices',
    inv_create_first: 'Create your first invoice', inv_all: 'All', inv_search: 'Search invoices...',

    // Payment
    pay_processing: 'Processing payment...', pay_wait: 'Please wait while we confirm your payment.',
    pay_success: 'Payment Successful!', pay_success_desc: 'Your subscription is now active.',
    pay_plan: 'Plan', pay_go_dashboard: 'Go to Dashboard', pay_go_invoices: 'Start Creating Invoices',
    pay_back_home: 'Back to Home', pay_error: 'Payment Issue',
    pay_error_desc: 'There was an issue processing your payment. Please try again.',
    pay_try_again: 'Try Again', pay_cancelled: 'Payment Cancelled',
    pay_cancelled_desc: 'No charges were made. You can try again anytime.',
    pay_back_pricing: 'Back to Pricing',

    // Invoice Portal
    inv_portal_dashboard: 'Dashboard', inv_portal_title: 'Invoice Portal',
    inv_portal_welcome: 'Welcome', inv_portal_subtitle: 'VeriFactu Invoice Portal',
    inv_portal_total_invoices: 'Total Invoices', inv_portal_pending: 'Pending',
    inv_portal_paid: 'Paid', inv_portal_revenue: 'Revenue',
    inv_portal_recent: 'Recent Invoices', inv_portal_view_all: 'View All',
    inv_portal_business: 'Business Details', inv_portal_biz_name: 'Business Name',
    inv_setup_title: 'Set Up Your Business', inv_setup_desc: 'Enter your business details for VeriFactu invoices',
    inv_setup_name: 'Business Name', inv_setup_legal: 'Legal Name',
    inv_setup_submit: 'Create Business & Start Invoicing',
    inv_setup_phone: 'Phone',

    // Stock Management
    stock_title: 'Stock Management', stock_tracked: 'tracked products',
    stock_total: 'Total Products', stock_low: 'Low Stock', stock_out: 'Out of Stock',
    stock_ok: 'OK', stock_unlimited: 'Unlimited',
    stock_overview: 'Stock Overview', stock_history: 'Movement History', stock_scanner: 'AI Receipt Scanner',
    stock_product: 'Product', stock_category: 'Category', stock_current: 'Stock',
    stock_threshold: 'Min', stock_status: 'Status', stock_search: 'Search products...',
    stock_alert_title: 'Low Stock Alert', stock_items: 'items',
    stock_add: 'Add Stock', stock_adjust: 'Adjust', stock_adjust_title: 'Adjust Stock',
    stock_type: 'Type', stock_intake: 'Intake (+)', stock_sale: 'Sale',
    stock_adjustment: 'Adjustment', stock_loss: 'Loss (-)', stock_return: 'Return (+)',
    stock_supplier: 'Supplier', stock_cost: 'Cost/Unit (€)', stock_confirm: 'Confirm',
    stock_no_movements: 'No stock movements yet',
    stock_scan_title: 'AI Receipt Scanner',
    stock_scan_desc: 'Upload a photo of a supplier receipt to auto-extract products',
    stock_upload: 'Upload Receipt', stock_scanning: 'Scanning...',
    stock_scan_results: 'Scan Results', stock_matched: 'Matched Products',
    stock_unmatched: 'Unmatched Items', stock_confirm_intake: 'Confirm Stock Intake',
    stock_scan_error: 'Receipt scan failed',
    stock_cost_price: 'Cost', stock_sale_price: 'Sale Price',
    stock_reorder: 'Reorder Suggestions', stock_reorder_desc: 'Based on sales velocity from the last 30 days',
    stock_reorder_all_good: 'All Stocked Up!', stock_reorder_no_items: 'No products need reordering right now.',
    stock_reorder_velocity: 'Daily Sales', stock_reorder_days_left: 'Days Left',
    stock_reorder_qty: 'Suggested Qty', stock_reorder_est_cost: 'Est. Cost',
    stock_reorder_urgency: 'Urgency',
    stock_urgency_critical: 'Critical', stock_urgency_urgent: 'Urgent',
    stock_urgency_soon: 'Soon', stock_urgency_ok: 'OK',

    // Reports
    reports_title: 'Reports', reports_subtitle: 'Sales analytics and End of Day reports',
    reports_daily: 'Daily Report', reports_weekly: 'Weekly Summary',
    reports_today: 'Today', reports_revenue: 'Revenue', reports_sales: 'Sales',
    reports_avg: 'Avg Sale', reports_invoices: 'Invoices',
    reports_payment_split: 'Payment Methods', reports_no_sales: 'No sales for this day',
    reports_hourly: 'Hourly Breakdown', reports_top_products: 'Top Products',
    reports_sales_short: 'sales', reports_cash: 'Cash', reports_card: 'Card',
    reports_weekly_summary: 'Weekly Summary',
    reports_total_revenue: 'Total Revenue', reports_total_sales: 'Total Sales',
    reports_daily_avg: 'Daily Average', reports_daily_breakdown: 'Daily Breakdown',

    // Staff & Notifications
    staff_title: 'Staff Management', staff_members: 'team members',
    staff_add: 'Add Staff', staff_active: 'Active Staff',
    staff_inactive: 'Inactive Staff', staff_empty: 'No Staff Yet',
    staff_empty_desc: 'Add your first team member to get started',
    staff_name: 'Name', staff_role_label: 'Role',
    staff_role_manager: 'Manager', staff_role_cashier: 'Cashier',
    staff_role_stock_clerk: 'Stock Clerk', staff_role_driver: 'Driver',
    staff_edit: 'Edit', staff_save: 'Save', staff_create: 'Create',
    staff_delete: 'Delete', staff_delete_confirm: 'Delete this staff member?',
    staff_deactivate: 'Deactivate', staff_activate: 'Activate',
    staff_regen_pin: 'New PIN', staff_new_pin: 'New PIN',
    notif_title: 'Notifications', notif_mark_all: 'Mark all read', notif_empty: 'No notifications',
    receipt_ticket: 'Ticket', receipt_subtotal: 'Subtotal', receipt_tax: 'Tax', receipt_payment: 'Payment',
    receipt_received: 'Received', receipt_change: 'Change', receipt_thanks: 'Thank you for your purchase',
    inv_send_email: 'Send via Email', inv_send: 'Send', inv_email_required: 'Email address required',
    inv_email_sent: 'Invoice sent by email', inv_email_failed: 'Failed to send email',
    inv_email_sent_to: 'Sent to',
    print_title: 'Printer', print_subtitle: 'Configure receipt printer settings',
    print_how_title: 'How to connect your printer',
    print_usb_guide: 'USB: Connect printer and select it in the print dialog',
    print_wifi_guide: 'WiFi: Set up printer IP on your local network',
    print_browser_guide: 'Browser: Use Ctrl+P or the Print button in POS',
    print_paper_size: 'Paper Size', print_80mm_desc: 'Standard for most thermal printers',
    print_58mm_desc: 'Compact and portable printers',
    print_receipt_options: 'Receipt Options', print_auto_print: 'Auto-print after each sale',
    print_show_header: 'Show shop details on receipt', print_show_footer: 'Show receipt footer',
    print_test: 'Print Test Receipt',
    shop_nav_payments: 'Payments',
    paysettings_title: 'Payment Options',
    paysettings_subtitle: 'Configure payment options your customers will see on invoices',
    paysettings_info: 'These payment options will be shown to customers when they view invoices online. Add EU/UK bank transfers, cash pickup, or other payment methods.',
    paysettings_save: 'Save', paysettings_saved: 'Saved',
    paysettings_empty: 'No payment methods configured',
    paysettings_add: 'Add Payment Method',
    paysettings_label: 'Method Name', paysettings_bank_name: 'Bank Name',
    paysettings_holder: 'Account Holder', paysettings_sort_code: 'Sort Code',
    paysettings_acc_number: 'Account Number', paysettings_instructions: 'Instructions',
    inv_copy_link: 'Copy Link', inv_view_online: 'View Online',
    inv_link_copied: 'Link copied to clipboard',
    reminder_title: 'Payment Reminders', reminder_desc: 'Send automatic reminders to customers with overdue invoices',
    reminder_days_label: 'Send reminder after', reminder_after: 'After',
    reminder_days_unit: 'days', reminder_add_day: 'Add interval',
    reminder_max: 'Max reminders per invoice', reminder_send_now: 'Send Reminders Now',
    reminder_sent_count: 'reminders sent', inv_reminders_sent: 'Reminders sent',
    dlv_title: 'Deliveries', dlv_subtitle: 'Manage orders and drivers',
    dlv_new_delivery: 'New Delivery', dlv_add_driver: 'Add Driver',
    dlv_orders: 'Orders', dlv_drivers: 'Drivers', dlv_all: 'All',
    dlv_pending: 'Pending', dlv_in_progress: 'In Progress', dlv_delivered: 'Delivered', dlv_failed: 'Failed',
    dlv_drivers_available: 'Available', dlv_revenue: 'Revenue',
    dlv_assign: 'Assign', dlv_picked_up: 'Picked Up', dlv_mark_delivered: 'Delivered', dlv_mark_failed: 'Failed',
    dlv_cancel: 'Cancel', dlv_select_driver: 'Select driver',
    dlv_no_available_drivers: 'No available drivers',
    dlv_no_deliveries: 'No deliveries', dlv_no_drivers: 'No drivers',
    dlv_customer_name: 'Customer Name', dlv_customer_phone: 'Phone',
    dlv_address: 'Delivery Address', dlv_city: 'City', dlv_payment: 'Payment',
    dlv_fee: 'Delivery Fee', dlv_notes: 'Notes', dlv_create: 'Create Delivery',
    dlv_driver_name: 'Name', dlv_driver_phone: 'Phone', dlv_vehicle: 'Vehicle',
    dlv_motorcycle: 'Motorcycle', dlv_car: 'Car', dlv_bicycle: 'Bicycle', dlv_van: 'Van',
    dlv_available: 'Available', dlv_busy: 'Busy', dlv_completed: 'completed',
    dlv_delete_driver_confirm: 'Delete this driver?',
    // SMTP Settings
    shop_nav_smtp: 'Email SMTP', shop_nav_email_templates: 'Email Templates',
    smtp_title: 'SMTP Configuration',
    smtp_subtitle: 'Configure your own SMTP server to send emails from your domain',
    smtp_verified: 'Verified', smtp_not_verified: 'Not Verified',
    smtp_config_title: 'SMTP Configuration',
    smtp_config_desc: 'Set up your outgoing mail server',
    smtp_preset: 'Email Provider Preset',
    smtp_preset_hint: 'Select a preset to auto-fill server details, or choose Custom.',
    smtp_host: 'SMTP Host', smtp_port: 'SMTP Port',
    smtp_username: 'Username', smtp_password: 'Password',
    smtp_password_hint: 'leave blank to keep current',
    smtp_password_required_new: 'Password is required for new SMTP configuration',
    smtp_from_email: 'From Email', smtp_from_name: 'From Name',
    smtp_tls: 'Use TLS Encryption',
    smtp_tls_465: 'Port 465 uses direct SSL. TLS not applicable.',
    smtp_tls_587: 'Recommended for port 587. Disable for SSL on port 465.',
    smtp_save: 'Save Email Settings',
    smtp_saved: 'SMTP settings saved',
    smtp_fill_required: 'Please fill all required fields',
    smtp_test_title: 'Send Test Email',
    smtp_test_desc: 'Verify your configuration by sending a test email',
    smtp_test_recipient: 'Recipient Email',
    smtp_test_message: 'Custom Message (optional)',
    smtp_test_message_placeholder: 'Type a custom message for the test email...',
    smtp_send_test: 'Send Test Email',
    smtp_sending: 'Sending...',
    smtp_enter_recipient: 'Please enter a recipient email',
    smtp_test_success: 'Test email sent successfully',
    smtp_save_first: 'Save your SMTP settings first before sending a test',
    smtp_last_tested: 'Last tested',
    // Email Templates
    et_title: 'Email Templates',
    et_subtitle: 'Create and manage notification email templates',
    et_create: 'Create Template', et_add_defaults: 'Add Missing Defaults',
    et_empty: 'No templates yet',
    et_empty_hint: 'Create your first template or add the defaults',
    et_create_title: 'Create Template', et_edit_title: 'Edit Template',
    et_create_desc: 'Set up your notification template', et_edit_desc: 'Update your notification template',
    et_name: 'Template Name', et_name_placeholder: 'e.g. Welcome Email',
    et_channel: 'Channel', et_event_type: 'Event Type',
    et_subject: 'Subject Line', et_subject_placeholder: 'Email subject with {{variables}}',
    et_body: 'Message Body', et_body_placeholder: 'Write the email body. Use {{variable}} to insert dynamic data.',
    et_placeholders: 'Placeholders',
    et_active: 'Template is active', et_inactive: 'Inactive',
    et_cancel: 'Cancel', et_save: 'Save', et_update: 'Update',
    et_updated: 'Template updated', et_created: 'Template created',
    et_deleted: 'Template deleted', et_confirm_delete: 'Are you sure you want to delete this template?',
    et_fill_required: 'Please fill name, subject and body',
    et_preview: 'Preview', et_edit: 'Edit', et_delete: 'Delete', et_send_test: 'Send Test',
    et_test_sent: 'Test email sent',
    et_preview_title: 'Template Preview',
    et_preview_desc: 'This is how your email will look with sample data',
    et_preview_plain: 'Plain Text', et_preview_email: 'Email HTML',
  },

  // ======================== FRANÇAIS ========================
  fr: {
    nav_features: 'Fonctionnalités', nav_pricing: 'Tarifs', nav_about: 'À Propos',
    nav_contact: 'Contact', nav_faq: 'FAQ', nav_login: 'Connexion', nav_register: 'Inscription',
    nav_mobile: 'App Mobile',

    hero_badge: 'Conformité VeriFactu Garantie',
    hero_title: 'Votre Boutique.', hero_title_2: 'Conforme. Simple.',
    hero_subtitle: 'Système de caisse et facturation conforme VeriFactu pour les commerces et freelances espagnols.',
    hero_cta_pos: 'Caisse Complète €19.99/mois', hero_cta_invoice: 'Factures Seulement €4.99/mois',
    hero_trusted: 'Approuvé par plus de 500 entreprises espagnoles',

    features_title: 'Tout Ce Dont Vous Avez Besoin',
    features_subtitle: 'Du TPV aux factures, gestion des stocks et bien plus',
    feature_pos_title: 'Système de Caisse Complet',
    feature_pos_desc: 'Scanner de codes-barres, paiements espèces et carte, tickets thermiques, mode hors ligne.',
    feature_invoice_title: 'Factures VeriFactu',
    feature_invoice_desc: 'Factures conformes AEAT avec codes QR, chaîne de hachage et envoi automatique.',
    feature_stock_title: 'Gestion des Stocks',
    feature_stock_desc: 'Scan IA des bons de livraison, alertes stock bas, dates de péremption.',
    feature_staff_title: 'Gestion du Personnel',
    feature_staff_desc: 'Accès par PIN, rôles (caissier, gérant, stock), journal d\'activité.',
    feature_reports_title: 'Rapports de Clôture',
    feature_reports_desc: 'Résumés quotidiens, ventes par heure, meilleurs produits, export CSV.',
    feature_delivery_title: 'Livraison à Domicile',
    feature_delivery_desc: 'Gestion des livreurs, suivi des commandes, frais de livraison configurables.',

    verifactu_label: 'RÉGLEMENTATION AEAT', verifactu_title: 'VeriFactu Vous Oblige',
    verifactu_subtitle: 'À partir de juillet 2027, toutes les entreprises espagnoles doivent utiliser un logiciel de facturation approuvé.',
    verifactu_feature_1: 'Chaîne de hachage SHA-256 vérifiable', verifactu_feature_2: 'Codes QR sur chaque facture',
    verifactu_feature_3: 'Connexion directe à l\'AEAT', verifactu_feature_4: 'Certificat numérique intégré',
    verifactu_approved: 'APPROUVÉ', verifactu_cta: 'Conformez-vous Aujourd\'hui',

    pricing_title: 'Tarifs Clairs', pricing_subtitle: 'Pas de surprises. Pas de frais cachés. Annulez quand vous voulez.',
    pricing_invoice_title: 'Factures', pricing_invoice_subtitle: 'Pour freelances et petites entreprises',
    pricing_invoice_price: '€4.99', pricing_invoice_period: '/mois',
    pricing_invoice_features: [
      'Factures VeriFactu illimitées', 'Génération PDF avec QR', 'Répertoire clients',
      'Modèles personnalisables', 'Factures récurrentes', 'Suivi des paiements',
      'Export CSV/Excel', 'App mobile iOS/Android', 'Support par email'
    ],
    pricing_pos_title: 'Caisse Boutique', pricing_pos_subtitle: 'Pour commerces et magasins',
    pricing_pos_price: '€19.99', pricing_pos_period: '/mois',
    pricing_pos_features: [
      'Tout de Factures +', 'Système de caisse complet', 'Scanner de codes-barres',
      'Gestion des stocks avec alertes', 'Scan IA des bons', 'Gestion du personnel avec PIN',
      'Rapports de clôture', 'Imprimante thermique ESC/POS', 'Mode hors ligne',
      'Livraison à domicile', 'Support prioritaire'
    ],
    pricing_popular: 'Le Plus Populaire', pricing_cta_invoice: 'Commencer avec Factures',
    pricing_cta_pos: 'Commencer avec Caisse',
    pricing_launch: 'OFFRE SPÉCIALE: Inscrivez-vous avant le 1er mai 2026 - 50% de réduction sur les plans annuels',
    pricing_monthly: 'Mensuel',
    pricing_yearly: 'Annuel',
    pricing_yearly_save: 'Économisez 15%',
    pricing_per_month: '/mois',
    pricing_per_year: '/an',
    pricing_billed_yearly: 'facturé annuellement',

    testimonials_title: 'Ce Que Disent Nos Clients',
    testimonial_1_text: '"VendFactura m\'a sauvé d\'une amende. Mes factures sont conformes à VeriFactu sans effort."',
    testimonial_1_author: 'María García', testimonial_1_role: 'Épicerie, Madrid',
    testimonial_2_text: '"Le scanner de codes-barres est ultra-rapide. Plus de file d\'attente."',
    testimonial_2_author: 'Antonio López', testimonial_2_role: 'Bureau de tabac, Barcelone',
    testimonial_3_text: '"En tant que freelance, j\'avais juste besoin des factures. Pour 4,99€/mois, c\'est parfait."',
    testimonial_3_author: 'Carlos Ruiz', testimonial_3_role: 'Designer freelance, Valence',

    faq_title: 'Questions Fréquentes',
    faq_1_q: 'Qu\'est-ce que VeriFactu?', faq_1_a: 'VeriFactu est le nouveau système de l\'AEAT exigeant des factures vérifiables avec codes QR et chaînes de hachage. Obligatoire à partir de juillet 2027.',
    faq_2_q: 'Puis-je essayer avant de payer?', faq_2_a: 'Oui, 14 jours d\'essai gratuit sans carte bancaire.',
    faq_3_q: 'Fonctionne-t-il hors ligne?', faq_3_a: 'Oui, le mode hors ligne permet de continuer à vendre. Les ventes se synchronisent automatiquement.',
    faq_4_q: 'Quelles imprimantes sont supportées?', faq_4_a: 'Toute imprimante thermique ESC/POS. Connexion Bluetooth, USB ou WiFi.',
    faq_5_q: 'Puis-je changer de forfait?', faq_5_a: 'Oui, passez de Factures à Caisse à tout moment.',

    cta_title: 'Prêt pour la Conformité VeriFactu?',
    cta_subtitle: 'Rejoignez des centaines d\'entreprises espagnoles déjà préparées',
    cta_button: 'Commencer Gratuitement',

    footer_description: 'Système de caisse et facturation VeriFactu pour commerces espagnols.',
    footer_product: 'Produit', footer_company: 'Entreprise', footer_legal: 'Légal',
    footer_terms: 'Conditions Générales', footer_privacy: 'Politique de Confidentialité',
    footer_cookies: 'Politique de Cookies',
    footer_copyright: '© 2025 VendFactura. Tous droits réservés.', footer_made: 'Fait avec amour en Espagne',

    auth_login: 'Connexion', auth_register: 'Inscription', auth_email: 'Adresse e-mail',
    auth_password: 'Mot de passe', auth_forgot: 'Mot de passe oublié?',
    auth_no_account: 'Pas encore de compte?', auth_has_account: 'Déjà un compte?',

    shop_nav_dashboard: 'Tableau de Bord', shop_nav_pos: 'Point de Vente', shop_nav_products: 'Produits',
    shop_nav_stock: 'Stock', shop_nav_invoices: 'Factures', shop_nav_staff: 'Personnel',
    shop_nav_reports: 'Rapports', shop_nav_delivery: 'Livraison', shop_nav_printer: 'Imprimante',
    shop_nav_settings: 'Paramètres', shop_nav_help: 'Aide', shop_nav_logout: 'Déconnexion',
    shop_nav_tickets: 'Support',
    tickets_title: 'Tickets de Support', tickets_subtitle: 'Gérez vos demandes de support',
    tickets_new: 'Nouveau Ticket', tickets_empty: 'Aucun ticket', tickets_empty_desc: 'Créez un ticket si vous avez besoin d\'aide',
    tickets_subject: 'Sujet', tickets_category: 'Catégorie', tickets_priority: 'Priorité',
    tickets_message: 'Message', tickets_submit: 'Envoyer le Ticket',
    tickets_reply_placeholder: 'Tapez votre réponse...', tickets_close: 'Fermer le ticket',
    tickets_closed_msg: 'Ce ticket est fermé',

    dashboard_welcome: 'Bienvenue', dashboard_today_sales: 'Ventes du Jour',
    dashboard_today_revenue: 'Revenus du Jour', dashboard_total_products: 'Produits',
    dashboard_low_stock: 'Stock Bas', dashboard_pending_invoices: 'Factures en Attente',
    dashboard_recent_sales: 'Ventes Récentes', dashboard_quick_actions: 'Actions Rapides',
    dashboard_open_pos: 'Ouvrir la Caisse', dashboard_new_product: 'Nouveau Produit',
    dashboard_create_invoice: 'Créer une Facture', dashboard_view_reports: 'Voir les Rapports',
    dashboard_setup_needed: 'Configuration requise!', dashboard_setup_desc: 'Configurez votre boutique pour commencer à vendre',
    dashboard_start_setup: 'Lancer la Configuration', dashboard_no_sales_yet: 'Pas de ventes encore',
    dashboard_start_selling: 'Commencer à vendre', dashboard_this_week: 'vs. semaine dernière',
    dashboard_vs_yesterday: 'vs. hier', dashboard_view_all: 'Voir tout',

    briefing_title: 'Résumé du Jour', briefing_good_morning: 'Bonjour',
    briefing_good_afternoon: 'Bon après-midi', briefing_good_evening: 'Bonsoir',
    briefing_yesterday: 'Clôture d\'Hier', briefing_sales: 'ventes', briefing_revenue: 'revenus',
    briefing_restock: 'Réapprovisionnement', briefing_products_low: 'produits en stock bas',
    briefing_view_all: 'Voir tout', briefing_verifactu: 'Statut VeriFactu',
    briefing_all_synced: 'Tout synchronisé', briefing_pending_sync: 'en attente d\'envoi',
    briefing_no_issues: 'Aucun problème', briefing_tasks: 'Tâches du Jour',
    briefing_check_stock: 'Vérifier le stock bas', briefing_review_sales: 'Revoir les ventes d\'hier',
    briefing_prepare_orders: 'Préparer les commandes en attente',

    pos_title: 'Point de Vente', pos_search: 'Rechercher un produit ou scanner un code...',
    pos_all: 'Tous', pos_cart: 'Panier', pos_empty: 'Panier vide',
    pos_add_products: 'Ajoutez des produits pour commencer', pos_subtotal: 'Sous-total', pos_tax: 'TVA',
    pos_total: 'Total', pos_pay: 'Payer', pos_cash: 'Espèces', pos_card: 'Carte', pos_split: 'Diviser',
    pos_cash_received: 'Espèces reçues', pos_change: 'Monnaie',
    pos_customer_name: 'Nom du client (optionnel)', pos_complete_sale: 'Finaliser la Vente',
    pos_print_receipt: 'Imprimer le Ticket', pos_new_sale: 'Nouvelle Vente',
    pos_sale_success: 'Vente finalisée!', pos_sale_number: 'Vente #',
    pos_quick_cash: 'Paiement rapide', pos_exact: 'Exact', pos_back: 'Retour', pos_items: 'articles',
    pos_park: 'Mettre en attente', pos_void: 'Annuler', pos_no_products: 'Aucun produit',
    pos_add_first: 'Ajoutez des produits depuis le catalogue',
    pos_offline_mode: 'Mode hors ligne', pos_offline_sales_saved: 'Les ventes sont enregistrées localement',
    pos_back_online: 'Connexion rétablie', pos_online: 'En ligne', pos_offline: 'Hors ligne',
    pos_offline_saved: 'Vente enregistrée hors ligne. Sera synchronisée au retour de la connexion.',
    pos_pending: 'en attente', pos_syncing: 'Synchronisation...', pos_synced: 'synchronisées',
    pos_failed: 'échouées', pos_sales_synced: 'ventes synchronisées', pos_sync_partial: 'Synchronisation partielle',
    pos_cached: 'Cache',

    products_title: 'Produits', products_search: 'Rechercher des produits...',
    products_add: 'Nouveau Produit', products_edit: 'Modifier le Produit', products_create: 'Créer un Produit',
    products_save: 'Enregistrer', products_cancel: 'Annuler', products_delete: 'Supprimer',
    products_name: 'Nom', products_description: 'Description', products_price: 'Prix (€)',
    products_category: 'Catégorie', products_barcode: 'Code-barres', products_stock: 'Stock',
    products_low_threshold: 'Seuil bas', products_tax_rate: 'TVA', products_unit: 'Unité',
    products_available: 'Disponible', products_all: 'Tous', products_no_products: 'Aucun produit trouvé',
    products_add_first: 'Ajoutez votre premier produit', products_confirm_delete: 'Supprimer ce produit?',
    products_yes_delete: 'Oui, supprimer', products_total: 'Total produits',

    inv_title: 'Factures', inv_create: 'Nouvelle Facture', inv_edit: 'Modifier la Facture',
    inv_number: 'Facture #', inv_date: 'Date', inv_due_date: 'Échéance',
    inv_customer: 'Client', inv_customer_name: 'Nom du client', inv_customer_nif: 'NIF/SIRET',
    inv_customer_address: 'Adresse', inv_customer_city: 'Ville', inv_customer_postal: 'Code postal',
    inv_customer_email: 'Email', inv_items: 'Lignes', inv_description: 'Description',
    inv_quantity: 'Qté', inv_price: 'Prix', inv_tax_rate: 'TVA %', inv_line_total: 'Total',
    inv_add_line: 'Ajouter une ligne', inv_subtotal: 'Sous-total', inv_tax: 'TVA', inv_total: 'Total',
    inv_payment: 'Mode de paiement', inv_bank: 'Virement', inv_cash: 'Espèces', inv_card: 'Carte', inv_other: 'Autre',
    inv_notes: 'Notes', inv_status: 'Statut', inv_draft: 'Brouillon', inv_issued: 'Émise',
    inv_paid: 'Payée', inv_cancelled: 'Annulée', inv_save: 'Enregistrer la Facture',
    inv_download_pdf: 'Télécharger PDF', inv_mark_paid: 'Marquer Payée', inv_cancel_invoice: 'Annuler',
    inv_verify: 'Vérifier Hash', inv_verifactu: 'VeriFactu', inv_hash_valid: 'Hash valide',
    inv_hash_invalid: 'Hash altéré', inv_no_invoices: 'Aucune facture',
    inv_create_first: 'Créez votre première facture', inv_all: 'Toutes', inv_search: 'Rechercher des factures...',

    // Payment
    pay_processing: 'Traitement du paiement...', pay_wait: 'Veuillez patienter pendant la confirmation.',
    pay_success: 'Paiement Réussi!', pay_success_desc: 'Votre abonnement est actif.',
    pay_plan: 'Plan', pay_go_dashboard: 'Aller au Tableau de Bord', pay_go_invoices: 'Créer des Factures',
    pay_back_home: 'Retour à l\'Accueil', pay_error: 'Erreur de Paiement',
    pay_error_desc: 'Un problème est survenu. Veuillez réessayer.',
    pay_try_again: 'Réessayer', pay_cancelled: 'Paiement Annulé',
    pay_cancelled_desc: 'Aucun frais n\'a été facturé. Vous pouvez réessayer à tout moment.',
    pay_back_pricing: 'Retour aux Tarifs',

    // Invoice Portal
    inv_portal_dashboard: 'Tableau de Bord', inv_portal_title: 'Portail Factures',
    inv_portal_welcome: 'Bienvenue', inv_portal_subtitle: 'Portail Factures VeriFactu',
    inv_portal_total_invoices: 'Total Factures', inv_portal_pending: 'En Attente',
    inv_portal_paid: 'Payées', inv_portal_revenue: 'Revenus',
    inv_portal_recent: 'Factures Récentes', inv_portal_view_all: 'Voir Tout',
    inv_portal_business: 'Détails Entreprise', inv_portal_biz_name: 'Nom Entreprise',
    inv_setup_title: 'Configurez Votre Entreprise', inv_setup_desc: 'Saisissez les détails pour les factures VeriFactu',
    inv_setup_name: 'Nom Entreprise', inv_setup_legal: 'Raison Sociale',
    inv_setup_submit: 'Créer Entreprise & Commencer',
    inv_setup_phone: 'Téléphone',

    // Stock
    stock_title: 'Gestion des Stocks', stock_tracked: 'produits suivis',
    stock_total: 'Total Produits', stock_low: 'Stock Faible', stock_out: 'Rupture',
    stock_ok: 'OK', stock_unlimited: 'Illimité',
    stock_overview: 'Aperçu', stock_history: 'Historique', stock_scanner: 'Scanner IA',
    stock_product: 'Produit', stock_category: 'Catégorie', stock_current: 'Stock',
    stock_threshold: 'Min', stock_status: 'Statut', stock_search: 'Rechercher...',
    stock_alert_title: 'Alerte Stock Faible', stock_items: 'articles',
    stock_add: 'Ajouter', stock_adjust: 'Ajuster', stock_adjust_title: 'Ajuster le Stock',
    stock_type: 'Type', stock_intake: 'Entrée', stock_sale: 'Vente',
    stock_adjustment: 'Ajustement', stock_loss: 'Perte', stock_return: 'Retour',
    stock_supplier: 'Fournisseur', stock_cost: 'Coût/Unité (€)', stock_confirm: 'Confirmer',
    stock_no_movements: 'Aucun mouvement de stock',
    stock_scan_title: 'Scanner IA de Reçus', stock_scan_desc: 'Téléchargez un reçu fournisseur',
    stock_upload: 'Télécharger Reçu', stock_scanning: 'Analyse...',
    stock_scan_results: 'Résultats', stock_matched: 'Produits Correspondants',
    stock_unmatched: 'Non Correspondants', stock_confirm_intake: 'Confirmer Entrée',
    stock_scan_error: 'Échec du scan',
    stock_cost_price: 'Coût', stock_sale_price: 'Prix de Vente',
    stock_reorder: 'Suggestions de Commande', stock_reorder_desc: 'Basé sur les ventes des 30 derniers jours',
    stock_reorder_all_good: 'Tout est en Stock!', stock_reorder_no_items: 'Aucun produit ne nécessite de commande.',
    stock_reorder_velocity: 'Ventes/Jour', stock_reorder_days_left: 'Jours Restants',
    stock_reorder_qty: 'Qté Suggérée', stock_reorder_est_cost: 'Coût Est.',
    stock_reorder_urgency: 'Urgence',
    stock_urgency_critical: 'Critique', stock_urgency_urgent: 'Urgent',
    stock_urgency_soon: 'Bientôt', stock_urgency_ok: 'OK',

    // Reports
    reports_title: 'Rapports', reports_subtitle: 'Analyses des ventes et rapports de fin de journée',
    reports_daily: 'Rapport Quotidien', reports_weekly: 'Résumé Hebdomadaire',
    reports_today: 'Aujourd\'hui', reports_revenue: 'Revenus', reports_sales: 'Ventes',
    reports_avg: 'Vente Moyenne', reports_invoices: 'Factures',
    reports_payment_split: 'Méthodes de Paiement', reports_no_sales: 'Aucune vente',
    reports_hourly: 'Par Heure', reports_top_products: 'Meilleurs Produits',
    reports_sales_short: 'ventes', reports_cash: 'Espèces', reports_card: 'Carte',
    reports_weekly_summary: 'Résumé Hebdomadaire',
    reports_total_revenue: 'Revenus Totaux', reports_total_sales: 'Ventes Totales',
    reports_daily_avg: 'Moyenne Quotidienne', reports_daily_breakdown: 'Par Jour',
    staff_title: 'Gestion du Personnel', staff_members: 'membres',
    staff_add: 'Ajouter', staff_active: 'Personnel Actif', staff_inactive: 'Personnel Inactif',
    staff_empty: 'Aucun Personnel', staff_empty_desc: 'Ajoutez votre premier membre',
    staff_name: 'Nom', staff_role_label: 'Rôle',
    staff_role_manager: 'Gérant', staff_role_cashier: 'Caissier',
    staff_role_stock_clerk: 'Magasinier', staff_role_driver: 'Livreur',
    staff_edit: 'Modifier', staff_save: 'Enregistrer', staff_create: 'Créer',
    staff_delete: 'Supprimer', staff_delete_confirm: 'Supprimer ce membre?',
    staff_deactivate: 'Désactiver', staff_activate: 'Activer',
    staff_regen_pin: 'Nouveau PIN', staff_new_pin: 'Nouveau PIN',
    notif_title: 'Notifications', notif_mark_all: 'Tout lire', notif_empty: 'Aucune notification',
    receipt_ticket: 'Ticket', receipt_subtotal: 'Sous-total', receipt_tax: 'TVA', receipt_payment: 'Paiement',
    receipt_received: 'Reçu', receipt_change: 'Monnaie', receipt_thanks: 'Merci pour votre achat',
    inv_send_email: 'Envoyer par Email', inv_send: 'Envoyer', inv_email_required: 'Email requis',
    inv_email_sent: 'Facture envoyée par email', inv_email_failed: "Erreur d'envoi",
    inv_email_sent_to: 'Envoyé à',
    print_title: 'Imprimante', print_subtitle: 'Configurer imprimante de tickets',
    print_how_title: 'Comment connecter votre imprimante',
    print_usb_guide: 'USB: Connectez et sélectionnez dans le dialogue',
    print_wifi_guide: 'WiFi: Configurez IP sur le réseau local',
    print_browser_guide: 'Navigateur: Ctrl+P ou bouton Imprimer',
    print_paper_size: 'Taille Papier', print_80mm_desc: 'Standard pour la plupart',
    print_58mm_desc: 'Imprimantes compactes et portables',
    print_receipt_options: 'Options de Ticket', print_auto_print: "Imprimer auto après vente",
    print_show_header: 'Afficher détails du magasin', print_show_footer: 'Afficher pied de ticket',
    print_test: 'Imprimer Ticket Test',
    shop_nav_payments: 'Paiements',
    paysettings_title: 'Options de Paiement',
    paysettings_subtitle: 'Configurer les options de paiement pour vos clients',
    paysettings_info: "Ces options seront affichées aux clients sur les factures en ligne. Ajoutez des virements EU/UK, espèces ou autres.",
    paysettings_save: 'Enregistrer', paysettings_saved: 'Enregistré',
    paysettings_empty: 'Aucune méthode configurée',
    paysettings_add: 'Ajouter Méthode',
    paysettings_label: 'Nom', paysettings_bank_name: 'Nom de la Banque',
    paysettings_holder: 'Titulaire', paysettings_sort_code: 'Sort Code',
    paysettings_acc_number: 'Numéro de Compte', paysettings_instructions: 'Instructions',
    inv_copy_link: 'Copier Lien', inv_view_online: 'Voir en Ligne',
    inv_link_copied: 'Lien copié',
    reminder_title: 'Rappels de Paiement', reminder_desc: "Envoyer des rappels aux clients avec factures en retard",
    reminder_days_label: 'Envoyer rappel après', reminder_after: 'Après',
    reminder_days_unit: 'jours', reminder_add_day: 'Ajouter intervalle',
    reminder_max: 'Rappels max par facture', reminder_send_now: 'Envoyer Rappels',
    reminder_sent_count: 'rappels envoyés', inv_reminders_sent: 'Rappels envoyés',
    dlv_title: 'Livraisons', dlv_subtitle: 'Gérer commandes et livreurs',
    dlv_new_delivery: 'Nouvelle Livraison', dlv_add_driver: 'Ajouter Livreur',
    dlv_orders: 'Commandes', dlv_drivers: 'Livreurs', dlv_all: 'Tous',
    dlv_pending: 'En attente', dlv_in_progress: 'En cours', dlv_delivered: 'Livré', dlv_failed: 'Échoué',
    dlv_drivers_available: 'Disponibles', dlv_revenue: 'Revenus',
    dlv_assign: 'Assigner', dlv_picked_up: 'Récupéré', dlv_mark_delivered: 'Livré', dlv_mark_failed: 'Échoué',
    dlv_cancel: 'Annuler', dlv_select_driver: 'Sélectionner livreur',
    dlv_no_available_drivers: 'Aucun livreur disponible',
    dlv_no_deliveries: 'Aucune livraison', dlv_no_drivers: 'Aucun livreur',
    dlv_customer_name: 'Nom Client', dlv_customer_phone: 'Téléphone',
    dlv_address: 'Adresse de Livraison', dlv_city: 'Ville', dlv_payment: 'Paiement',
    dlv_fee: 'Frais de Livraison', dlv_notes: 'Notes', dlv_create: 'Créer Livraison',
    dlv_driver_name: 'Nom', dlv_driver_phone: 'Téléphone', dlv_vehicle: 'Véhicule',
    dlv_motorcycle: 'Moto', dlv_car: 'Voiture', dlv_bicycle: 'Vélo', dlv_van: 'Fourgon',
    dlv_available: 'Disponible', dlv_busy: 'Occupé', dlv_completed: 'terminées',
    dlv_delete_driver_confirm: 'Supprimer ce livreur ?',
    // SMTP Settings
    shop_nav_smtp: 'Email SMTP', shop_nav_email_templates: 'Modèles Email',
    smtp_title: 'Configuration SMTP',
    smtp_subtitle: 'Configurez votre propre serveur SMTP pour envoyer des emails depuis votre domaine',
    smtp_verified: 'Vérifié', smtp_not_verified: 'Non vérifié',
    smtp_config_title: 'Configuration SMTP',
    smtp_config_desc: 'Configurez votre serveur de messagerie sortant',
    smtp_preset: 'Fournisseur Email',
    smtp_preset_hint: 'Sélectionnez un fournisseur pour remplir automatiquement, ou choisissez Custom.',
    smtp_host: 'Hôte SMTP', smtp_port: 'Port SMTP',
    smtp_username: 'Utilisateur', smtp_password: 'Mot de passe',
    smtp_password_hint: 'laisser vide pour garder le mot de passe actuel',
    smtp_password_required_new: 'Le mot de passe est requis pour une nouvelle configuration',
    smtp_from_email: 'Email expéditeur', smtp_from_name: 'Nom expéditeur',
    smtp_tls: 'Chiffrement TLS',
    smtp_tls_465: 'Le port 465 utilise SSL direct. TLS non applicable.',
    smtp_tls_587: 'Recommandé pour le port 587. Désactiver pour SSL sur le port 465.',
    smtp_save: 'Enregistrer la configuration',
    smtp_saved: 'Configuration SMTP enregistrée',
    smtp_fill_required: 'Veuillez remplir tous les champs obligatoires',
    smtp_test_title: 'Envoyer un email de test',
    smtp_test_desc: 'Vérifiez votre configuration en envoyant un email de test',
    smtp_test_recipient: 'Email destinataire',
    smtp_test_message: 'Message personnalisé (optionnel)',
    smtp_test_message_placeholder: 'Tapez un message personnalisé pour le test...',
    smtp_send_test: 'Envoyer le test',
    smtp_sending: 'Envoi...',
    smtp_enter_recipient: 'Veuillez entrer un email destinataire',
    smtp_test_success: 'Email de test envoyé avec succès',
    smtp_save_first: 'Enregistrez les paramètres SMTP avant d\'envoyer un test',
    smtp_last_tested: 'Dernier test',
    // Email Templates
    et_title: 'Modèles d\'Email',
    et_subtitle: 'Créez et gérez vos modèles de notification par email',
    et_create: 'Créer Modèle', et_add_defaults: 'Ajouter les modèles par défaut',
    et_empty: 'Aucun modèle',
    et_empty_hint: 'Créez votre premier modèle ou ajoutez les modèles par défaut',
    et_create_title: 'Créer Modèle', et_edit_title: 'Modifier Modèle',
    et_create_desc: 'Configurez votre modèle de notification', et_edit_desc: 'Mettez à jour votre modèle de notification',
    et_name: 'Nom du modèle', et_name_placeholder: 'ex: Email de bienvenue',
    et_channel: 'Canal', et_event_type: 'Type d\'événement',
    et_subject: 'Objet', et_subject_placeholder: 'Objet de l\'email avec {{variables}}',
    et_body: 'Corps du message', et_body_placeholder: 'Écrivez le corps de l\'email. Utilisez {{variable}} pour insérer des données dynamiques.',
    et_placeholders: 'Variables',
    et_active: 'Modèle actif', et_inactive: 'Inactif',
    et_cancel: 'Annuler', et_save: 'Enregistrer', et_update: 'Mettre à jour',
    et_updated: 'Modèle mis à jour', et_created: 'Modèle créé',
    et_deleted: 'Modèle supprimé', et_confirm_delete: 'Voulez-vous vraiment supprimer ce modèle ?',
    et_fill_required: 'Veuillez remplir le nom, l\'objet et le corps',
    et_preview: 'Aperçu', et_edit: 'Modifier', et_delete: 'Supprimer', et_send_test: 'Envoyer test',
    et_test_sent: 'Email de test envoyé',
    et_preview_title: 'Aperçu du modèle',
    et_preview_desc: 'Voici comment votre email apparaîtra avec des données d\'exemple',
    et_preview_plain: 'Texte brut', et_preview_email: 'Email HTML',
  },

  // ======================== DEUTSCH ========================
  de: {
    nav_features: 'Funktionen', nav_pricing: 'Preise', nav_about: 'Über Uns',
    nav_contact: 'Kontakt', nav_faq: 'FAQ', nav_login: 'Anmelden', nav_register: 'Registrieren',
    nav_mobile: 'Mobile App',

    hero_badge: 'VeriFactu Konformität Garantiert',
    hero_title: 'Ihr Laden.', hero_title_2: 'Konform. Einfach.',
    hero_subtitle: 'Kassensystem und VeriFactu-konforme Rechnungsstellung für spanische Geschäfte und Freiberufler.',
    hero_cta_pos: 'Vollständige Kasse €19.99/Mo', hero_cta_invoice: 'Nur Rechnungen €4.99/Mo',
    hero_trusted: 'Vertraut von über 500 spanischen Unternehmen',

    features_title: 'Alles Was Sie Brauchen',
    features_subtitle: 'Vom Kassensystem bis zur Rechnungsstellung, Lagerverwaltung und mehr',
    feature_pos_title: 'Vollständiges Kassensystem',
    feature_pos_desc: 'Barcode-Scanner, Bar- und Kartenzahlung, Thermodruck, Offline-Modus.',
    feature_invoice_title: 'VeriFactu Rechnungen',
    feature_invoice_desc: 'AEAT-konforme Rechnungen mit QR-Codes, Hash-Kette und automatischem Versand.',
    feature_stock_title: 'Lagerverwaltung',
    feature_stock_desc: 'KI-Lieferschein-Scan, Niedrigbestandswarnungen, Verfallsdaten.',
    feature_staff_title: 'Personalverwaltung',
    feature_staff_desc: 'PIN-Zugang, Rollen (Kassierer, Manager, Lager), Aktivitätsprotokoll.',
    feature_reports_title: 'Tagesabschlussberichte',
    feature_reports_desc: 'Tägliche Zusammenfassungen, stündliche Verkäufe, Top-Produkte, CSV-Export.',
    feature_delivery_title: 'Hauslieferung',
    feature_delivery_desc: 'Fahrerverwaltung, Bestellverfolgung, konfigurierbare Liefergebühren.',

    verifactu_label: 'AEAT-VERORDNUNG', verifactu_title: 'VeriFactu Verpflichtet Sie',
    verifactu_subtitle: 'Ab Juli 2027 müssen alle spanischen Unternehmen zugelassene Rechnungssoftware verwenden.',
    verifactu_feature_1: 'Überprüfbare SHA-256-Hash-Kette', verifactu_feature_2: 'QR-Codes auf jeder Rechnung',
    verifactu_feature_3: 'Direkte Verbindung zur AEAT', verifactu_feature_4: 'Integriertes digitales Zertifikat',
    verifactu_approved: 'ZUGELASSEN', verifactu_cta: 'Heute Konform Werden',

    pricing_title: 'Klare Preise', pricing_subtitle: 'Keine Überraschungen. Keine versteckten Gebühren. Jederzeit kündbar.',
    pricing_invoice_title: 'Rechnungen', pricing_invoice_subtitle: 'Für Freiberufler und Kleinunternehmen',
    pricing_invoice_price: '€4.99', pricing_invoice_period: '/Mo',
    pricing_invoice_features: [
      'Unbegrenzte VeriFactu-Rechnungen', 'PDF-Erstellung mit QR', 'Kundenverzeichnis',
      'Anpassbare Vorlagen', 'Wiederkehrende Rechnungen', 'Zahlungsverfolgung',
      'Export nach CSV/Excel', 'Mobile App iOS/Android', 'E-Mail-Support'
    ],
    pricing_pos_title: 'Laden-Kasse', pricing_pos_subtitle: 'Für Geschäfte und Läden',
    pricing_pos_price: '€19.99', pricing_pos_period: '/Mo',
    pricing_pos_features: [
      'Alles aus Rechnungen +', 'Vollständiges Kassensystem', 'Barcode-Scanner',
      'Lagerverwaltung mit Warnungen', 'KI-Lieferschein-Scan', 'Personalverwaltung mit PIN',
      'Tagesabschlussberichte', 'ESC/POS-Thermodrucker', 'Offline-Modus',
      'Hauslieferung', 'Prioritäts-Support'
    ],
    pricing_popular: 'Am Beliebtesten', pricing_cta_invoice: 'Mit Rechnungen Starten',
    pricing_cta_pos: 'Mit Kasse Starten',
    pricing_launch: 'SONDERANGEBOT: Anmeldung vor dem 1. Mai 2026 - 50% RABATT auf Jahrespläne',
    pricing_monthly: 'Monatlich',
    pricing_yearly: 'Jährlich',
    pricing_yearly_save: '15% sparen',
    pricing_per_month: '/Mo',
    pricing_per_year: '/Jahr',
    pricing_billed_yearly: 'jährlich abgerechnet',

    testimonials_title: 'Was Unsere Kunden Sagen',
    testimonial_1_text: '"VendFactura hat mich vor einem Bußgeld bewahrt. Meine Rechnungen sind jetzt VeriFactu-konform."',
    testimonial_1_author: 'María García', testimonial_1_role: 'Lebensmittelgeschäft, Madrid',
    testimonial_2_text: '"Der Barcode-Scanner ist superschnell. Keine Warteschlangen mehr."',
    testimonial_2_author: 'Antonio López', testimonial_2_role: 'Tabakladen, Barcelona',
    testimonial_3_text: '"Als Freiberufler brauchte ich nur Rechnungen. Für 4,99€/Monat habe ich alles."',
    testimonial_3_author: 'Carlos Ruiz', testimonial_3_role: 'Freelance-Designer, Valencia',

    faq_title: 'Häufig Gestellte Fragen',
    faq_1_q: 'Was ist VeriFactu?', faq_1_a: 'VeriFactu ist das neue AEAT-System, das überprüfbare Rechnungen mit QR-Codes und Hash-Ketten verlangt. Ab Juli 2027 verpflichtend.',
    faq_2_q: 'Kann ich vor dem Bezahlen testen?', faq_2_a: 'Ja, 14 Tage kostenlos testen ohne Kreditkarte.',
    faq_3_q: 'Funktioniert es offline?', faq_3_a: 'Ja, der Offline-Modus ermöglicht den Verkauf ohne Verbindung. Verkäufe werden automatisch synchronisiert.',
    faq_4_q: 'Welche Drucker werden unterstützt?', faq_4_a: 'Jeder ESC/POS-Thermodrucker. Bluetooth, USB oder WiFi.',
    faq_5_q: 'Kann ich den Plan wechseln?', faq_5_a: 'Ja, jederzeit von Rechnungen auf Kasse upgraden.',

    cta_title: 'Bereit für VeriFactu Konformität?',
    cta_subtitle: 'Schließen Sie sich Hunderten spanischer Unternehmen an',
    cta_button: 'Kostenlos Starten',

    footer_description: 'Kassensystem und VeriFactu-Rechnungsstellung für spanische Geschäfte.',
    footer_product: 'Produkt', footer_company: 'Unternehmen', footer_legal: 'Rechtliches',
    footer_terms: 'AGB', footer_privacy: 'Datenschutz', footer_cookies: 'Cookie-Richtlinie',
    footer_copyright: '© 2025 VendFactura. Alle Rechte vorbehalten.', footer_made: 'Mit Liebe in Spanien gemacht',

    auth_login: 'Anmelden', auth_register: 'Registrieren', auth_email: 'E-Mail',
    auth_password: 'Passwort', auth_forgot: 'Passwort vergessen?',
    auth_no_account: 'Noch kein Konto?', auth_has_account: 'Bereits ein Konto?',

    shop_nav_dashboard: 'Dashboard', shop_nav_pos: 'Kasse', shop_nav_products: 'Produkte',
    shop_nav_stock: 'Lager', shop_nav_invoices: 'Rechnungen', shop_nav_staff: 'Personal',
    shop_nav_reports: 'Berichte', shop_nav_delivery: 'Lieferung', shop_nav_printer: 'Drucker',
    shop_nav_settings: 'Einstellungen', shop_nav_help: 'Hilfe', shop_nav_logout: 'Abmelden',
    shop_nav_tickets: 'Support',
    tickets_title: 'Support-Tickets', tickets_subtitle: 'Verwalten Sie Ihre Supportanfragen',
    tickets_new: 'Neues Ticket', tickets_empty: 'Keine Tickets', tickets_empty_desc: 'Erstellen Sie ein Ticket, wenn Sie Hilfe benötigen',
    tickets_subject: 'Betreff', tickets_category: 'Kategorie', tickets_priority: 'Priorität',
    tickets_message: 'Nachricht', tickets_submit: 'Ticket senden',
    tickets_reply_placeholder: 'Antwort eingeben...', tickets_close: 'Ticket schließen',
    tickets_closed_msg: 'Dieses Ticket ist geschlossen',

    dashboard_welcome: 'Willkommen', dashboard_today_sales: 'Heutige Verkäufe',
    dashboard_today_revenue: 'Heutiger Umsatz', dashboard_total_products: 'Produkte',
    dashboard_low_stock: 'Niedriger Bestand', dashboard_pending_invoices: 'Ausstehende Rechnungen',
    dashboard_recent_sales: 'Letzte Verkäufe', dashboard_quick_actions: 'Schnellaktionen',
    dashboard_open_pos: 'Kasse Öffnen', dashboard_new_product: 'Neues Produkt',
    dashboard_create_invoice: 'Rechnung Erstellen', dashboard_view_reports: 'Berichte Ansehen',
    dashboard_setup_needed: 'Einrichtung erforderlich!', dashboard_setup_desc: 'Richten Sie Ihren Laden ein, um zu verkaufen',
    dashboard_start_setup: 'Einrichtung Starten', dashboard_no_sales_yet: 'Noch keine Verkäufe',
    dashboard_start_selling: 'Verkaufen starten', dashboard_this_week: 'vs. letzte Woche',
    dashboard_vs_yesterday: 'vs. gestern', dashboard_view_all: 'Alle ansehen',

    briefing_title: 'Tagesübersicht', briefing_good_morning: 'Guten Morgen',
    briefing_good_afternoon: 'Guten Nachmittag', briefing_good_evening: 'Guten Abend',
    briefing_yesterday: 'Gestriger Abschluss', briefing_sales: 'Verkäufe', briefing_revenue: 'Umsatz',
    briefing_restock: 'Nachbestellung Nötig', briefing_products_low: 'Produkte mit niedrigem Bestand',
    briefing_view_all: 'Alle ansehen', briefing_verifactu: 'VeriFactu Status',
    briefing_all_synced: 'Alles synchronisiert', briefing_pending_sync: 'ausstehend',
    briefing_no_issues: 'Keine Probleme', briefing_tasks: 'Heutige Aufgaben',
    briefing_check_stock: 'Niedrigen Bestand prüfen', briefing_review_sales: 'Gestrige Verkäufe prüfen',
    briefing_prepare_orders: 'Ausstehende Bestellungen vorbereiten',

    pos_title: 'Kasse', pos_search: 'Produkt suchen oder Barcode scannen...',
    pos_all: 'Alle', pos_cart: 'Warenkorb', pos_empty: 'Warenkorb leer',
    pos_add_products: 'Produkte hinzufügen zum Starten', pos_subtotal: 'Zwischensumme', pos_tax: 'MwSt.',
    pos_total: 'Gesamt', pos_pay: 'Bezahlen', pos_cash: 'Bar', pos_card: 'Karte', pos_split: 'Teilen',
    pos_cash_received: 'Barzahlung erhalten', pos_change: 'Rückgeld',
    pos_customer_name: 'Kundenname (optional)', pos_complete_sale: 'Verkauf Abschließen',
    pos_print_receipt: 'Beleg Drucken', pos_new_sale: 'Neuer Verkauf',
    pos_sale_success: 'Verkauf abgeschlossen!', pos_sale_number: 'Verkauf #',
    pos_quick_cash: 'Schnellzahlung', pos_exact: 'Passend', pos_back: 'Zurück', pos_items: 'Artikel',
    pos_park: 'Parken', pos_void: 'Stornieren', pos_no_products: 'Keine Produkte',
    pos_add_first: 'Produkte aus dem Katalog hinzufügen',
    pos_offline_mode: 'Offline-Modus', pos_offline_sales_saved: 'Verkäufe werden lokal gespeichert',
    pos_back_online: 'Wieder online', pos_online: 'Online', pos_offline: 'Offline',
    pos_offline_saved: 'Verkauf offline gespeichert. Wird bei Verbindungsrückkehr synchronisiert.',
    pos_pending: 'ausstehend', pos_syncing: 'Synchronisiere...', pos_synced: 'synchronisiert',
    pos_failed: 'fehlgeschlagen', pos_sales_synced: 'Verkäufe synchronisiert', pos_sync_partial: 'Teilsynchronisierung',
    pos_cached: 'Zwischengespeichert',

    products_title: 'Produkte', products_search: 'Produkte suchen...',
    products_add: 'Neues Produkt', products_edit: 'Produkt Bearbeiten', products_create: 'Produkt Erstellen',
    products_save: 'Speichern', products_cancel: 'Abbrechen', products_delete: 'Löschen',
    products_name: 'Name', products_description: 'Beschreibung', products_price: 'Preis (€)',
    products_category: 'Kategorie', products_barcode: 'Barcode', products_stock: 'Bestand',
    products_low_threshold: 'Niedrigschwelle', products_tax_rate: 'MwSt.', products_unit: 'Einheit',
    products_available: 'Verfügbar', products_all: 'Alle', products_no_products: 'Keine Produkte gefunden',
    products_add_first: 'Erstes Produkt hinzufügen', products_confirm_delete: 'Dieses Produkt löschen?',
    products_yes_delete: 'Ja, löschen', products_total: 'Produkte gesamt',

    inv_title: 'Rechnungen', inv_create: 'Neue Rechnung', inv_edit: 'Rechnung Bearbeiten',
    inv_number: 'Rechnung #', inv_date: 'Datum', inv_due_date: 'Fällig am',
    inv_customer: 'Kunde', inv_customer_name: 'Kundenname', inv_customer_nif: 'Steuer-ID (NIF)',
    inv_customer_address: 'Adresse', inv_customer_city: 'Stadt', inv_customer_postal: 'PLZ',
    inv_customer_email: 'E-Mail', inv_items: 'Positionen', inv_description: 'Beschreibung',
    inv_quantity: 'Menge', inv_price: 'Preis', inv_tax_rate: 'MwSt. %', inv_line_total: 'Gesamt',
    inv_add_line: 'Position hinzufügen', inv_subtotal: 'Zwischensumme', inv_tax: 'MwSt.', inv_total: 'Gesamt',
    inv_payment: 'Zahlungsart', inv_bank: 'Überweisung', inv_cash: 'Bar', inv_card: 'Karte', inv_other: 'Andere',
    inv_notes: 'Notizen', inv_status: 'Status', inv_draft: 'Entwurf', inv_issued: 'Ausgestellt',
    inv_paid: 'Bezahlt', inv_cancelled: 'Storniert', inv_save: 'Rechnung Speichern',
    inv_download_pdf: 'PDF Herunterladen', inv_mark_paid: 'Als Bezahlt Markieren', inv_cancel_invoice: 'Stornieren',
    inv_verify: 'Hash Prüfen', inv_verifactu: 'VeriFactu', inv_hash_valid: 'Hash gültig',
    inv_hash_invalid: 'Hash manipuliert', inv_no_invoices: 'Keine Rechnungen',
    inv_create_first: 'Erstellen Sie Ihre erste Rechnung', inv_all: 'Alle', inv_search: 'Rechnungen suchen...',

    // Payment
    pay_processing: 'Zahlung wird verarbeitet...', pay_wait: 'Bitte warten Sie, während wir Ihre Zahlung bestätigen.',
    pay_success: 'Zahlung Erfolgreich!', pay_success_desc: 'Ihr Abonnement ist jetzt aktiv.',
    pay_plan: 'Plan', pay_go_dashboard: 'Zum Dashboard', pay_go_invoices: 'Rechnungen Erstellen',
    pay_back_home: 'Zurück zur Startseite', pay_error: 'Zahlungsproblem',
    pay_error_desc: 'Es gab ein Problem mit Ihrer Zahlung. Bitte versuchen Sie es erneut.',
    pay_try_again: 'Erneut Versuchen', pay_cancelled: 'Zahlung Abgebrochen',
    pay_cancelled_desc: 'Es wurden keine Gebühren erhoben. Sie können es jederzeit erneut versuchen.',
    pay_back_pricing: 'Zurück zu den Preisen',

    // Invoice Portal
    inv_portal_dashboard: 'Dashboard', inv_portal_title: 'Rechnungsportal',
    inv_portal_welcome: 'Willkommen', inv_portal_subtitle: 'VeriFactu Rechnungsportal',
    inv_portal_total_invoices: 'Rechnungen Gesamt', inv_portal_pending: 'Ausstehend',
    inv_portal_paid: 'Bezahlt', inv_portal_revenue: 'Umsatz',
    inv_portal_recent: 'Letzte Rechnungen', inv_portal_view_all: 'Alle Anzeigen',
    inv_portal_business: 'Unternehmensdaten', inv_portal_biz_name: 'Firmenname',
    inv_setup_title: 'Richten Sie Ihr Unternehmen Ein', inv_setup_desc: 'Geben Sie Ihre Geschäftsdaten für VeriFactu ein',
    inv_setup_name: 'Firmenname', inv_setup_legal: 'Handelsname',
    inv_setup_submit: 'Unternehmen Erstellen & Starten',
    inv_setup_phone: 'Telefon',

    // Stock
    stock_title: 'Lagerverwaltung', stock_tracked: 'verfolgte Produkte',
    stock_total: 'Gesamt', stock_low: 'Niedriger Bestand', stock_out: 'Ausverkauft',
    stock_ok: 'OK', stock_unlimited: 'Unbegrenzt',
    stock_overview: 'Übersicht', stock_history: 'Verlauf', stock_scanner: 'KI-Scanner',
    stock_product: 'Produkt', stock_category: 'Kategorie', stock_current: 'Bestand',
    stock_threshold: 'Min', stock_status: 'Status', stock_search: 'Suchen...',
    stock_alert_title: 'Bestandswarnung', stock_items: 'Artikel',
    stock_add: 'Hinzufügen', stock_adjust: 'Anpassen', stock_adjust_title: 'Bestand Anpassen',
    stock_type: 'Typ', stock_intake: 'Eingang', stock_sale: 'Verkauf',
    stock_adjustment: 'Anpassung', stock_loss: 'Verlust', stock_return: 'Rückgabe',
    stock_supplier: 'Lieferant', stock_cost: 'Kosten/Einheit (€)', stock_confirm: 'Bestätigen',
    stock_no_movements: 'Keine Bestandsbewegungen',
    stock_scan_title: 'KI-Belegscanner', stock_scan_desc: 'Lieferantenbeleg hochladen',
    stock_upload: 'Beleg Hochladen', stock_scanning: 'Scanne...',
    stock_scan_results: 'Ergebnisse', stock_matched: 'Zugeordnete Produkte',
    stock_unmatched: 'Nicht Zugeordnet', stock_confirm_intake: 'Eingang Bestätigen',
    stock_scan_error: 'Scan fehlgeschlagen',
    stock_cost_price: 'Einkauf', stock_sale_price: 'Verkaufspreis',
    stock_reorder: 'Nachbestellung', stock_reorder_desc: 'Basierend auf Verkaufsgeschwindigkeit der letzten 30 Tage',
    stock_reorder_all_good: 'Alles Vorrätig!', stock_reorder_no_items: 'Keine Nachbestellung nötig.',
    stock_reorder_velocity: 'Verkäufe/Tag', stock_reorder_days_left: 'Tage Übrig',
    stock_reorder_qty: 'Empfohlene Menge', stock_reorder_est_cost: 'Gesch. Kosten',
    stock_reorder_urgency: 'Dringlichkeit',
    stock_urgency_critical: 'Kritisch', stock_urgency_urgent: 'Dringend',
    stock_urgency_soon: 'Bald', stock_urgency_ok: 'OK',

    // Reports
    reports_title: 'Berichte', reports_subtitle: 'Verkaufsanalysen und Tagesberichte',
    reports_daily: 'Tagesbericht', reports_weekly: 'Wochenübersicht',
    reports_today: 'Heute', reports_revenue: 'Umsatz', reports_sales: 'Verkäufe',
    reports_avg: 'Ø Verkauf', reports_invoices: 'Rechnungen',
    reports_payment_split: 'Zahlungsmethoden', reports_no_sales: 'Keine Verkäufe',
    reports_hourly: 'Stündlich', reports_top_products: 'Top Produkte',
    reports_sales_short: 'Verkäufe', reports_cash: 'Bargeld', reports_card: 'Karte',
    reports_weekly_summary: 'Wochenübersicht',
    reports_total_revenue: 'Gesamtumsatz', reports_total_sales: 'Gesamtverkäufe',
    reports_daily_avg: 'Tagesdurchschnitt', reports_daily_breakdown: 'Tägliche Aufschlüsselung',
    staff_title: 'Personalverwaltung', staff_members: 'Mitglieder',
    staff_add: 'Hinzufügen', staff_active: 'Aktives Personal', staff_inactive: 'Inaktiv',
    staff_empty: 'Kein Personal', staff_empty_desc: 'Fügen Sie Ihr erstes Teammitglied hinzu',
    staff_name: 'Name', staff_role_label: 'Rolle',
    staff_role_manager: 'Manager', staff_role_cashier: 'Kassierer',
    staff_role_stock_clerk: 'Lagerist', staff_role_driver: 'Fahrer',
    staff_edit: 'Bearbeiten', staff_save: 'Speichern', staff_create: 'Erstellen',
    staff_delete: 'Löschen', staff_delete_confirm: 'Dieses Mitglied löschen?',
    staff_deactivate: 'Deaktivieren', staff_activate: 'Aktivieren',
    staff_regen_pin: 'Neuer PIN', staff_new_pin: 'Neuer PIN',
    notif_title: 'Benachrichtigungen', notif_mark_all: 'Alle gelesen', notif_empty: 'Keine Benachrichtigungen',
    receipt_ticket: 'Beleg', receipt_subtotal: 'Zwischensumme', receipt_tax: 'MwSt', receipt_payment: 'Zahlung',
    receipt_received: 'Erhalten', receipt_change: 'Wechselgeld', receipt_thanks: 'Vielen Dank für Ihren Einkauf',
    inv_send_email: 'Per E-Mail senden', inv_send: 'Senden', inv_email_required: 'E-Mail erforderlich',
    inv_email_sent: 'Rechnung per E-Mail gesendet', inv_email_failed: 'Fehler beim Senden',
    inv_email_sent_to: 'Gesendet an',
    print_title: 'Drucker', print_subtitle: 'Bondrucker konfigurieren',
    print_how_title: 'So verbinden Sie Ihren Drucker',
    print_usb_guide: 'USB: Drucker anschließen und im Dialog auswählen',
    print_wifi_guide: 'WiFi: Drucker-IP im Netzwerk einrichten',
    print_browser_guide: 'Browser: Strg+P oder Drucken-Button',
    print_paper_size: 'Papierformat', print_80mm_desc: 'Standard für die meisten Drucker',
    print_58mm_desc: 'Kompakte und tragbare Drucker',
    print_receipt_options: 'Beleg-Optionen', print_auto_print: 'Nach Verkauf automatisch drucken',
    print_show_header: 'Geschäftsdaten anzeigen', print_show_footer: 'Beleg-Fußzeile anzeigen',
    print_test: 'Testbeleg Drucken',
    shop_nav_payments: 'Zahlungen',
    paysettings_title: 'Zahlungsoptionen',
    paysettings_subtitle: 'Zahlungsoptionen für Kunden konfigurieren',
    paysettings_info: 'Diese Optionen werden Kunden auf Online-Rechnungen angezeigt. EU/UK-Überweisungen, Barzahlung oder andere Methoden.',
    paysettings_save: 'Speichern', paysettings_saved: 'Gespeichert',
    paysettings_empty: 'Keine Zahlungsmethoden konfiguriert',
    paysettings_add: 'Methode Hinzufügen',
    paysettings_label: 'Methodenname', paysettings_bank_name: 'Bankname',
    paysettings_holder: 'Kontoinhaber', paysettings_sort_code: 'Sort Code',
    paysettings_acc_number: 'Kontonummer', paysettings_instructions: 'Anweisungen',
    inv_copy_link: 'Link Kopieren', inv_view_online: 'Online Ansehen',
    inv_link_copied: 'Link kopiert',
    reminder_title: 'Zahlungserinnerungen', reminder_desc: 'Automatische Erinnerungen an Kunden mit überfälligen Rechnungen',
    reminder_days_label: 'Erinnerung senden nach', reminder_after: 'Nach',
    reminder_days_unit: 'Tagen', reminder_add_day: 'Intervall hinzufügen',
    reminder_max: 'Max Erinnerungen pro Rechnung', reminder_send_now: 'Erinnerungen Jetzt Senden',
    reminder_sent_count: 'Erinnerungen gesendet', inv_reminders_sent: 'Erinnerungen gesendet',
    dlv_title: 'Lieferungen', dlv_subtitle: 'Bestellungen und Fahrer verwalten',
    dlv_new_delivery: 'Neue Lieferung', dlv_add_driver: 'Fahrer Hinzufügen',
    dlv_orders: 'Bestellungen', dlv_drivers: 'Fahrer', dlv_all: 'Alle',
    dlv_pending: 'Ausstehend', dlv_in_progress: 'In Bearbeitung', dlv_delivered: 'Geliefert', dlv_failed: 'Fehlgeschlagen',
    dlv_drivers_available: 'Verfügbar', dlv_revenue: 'Umsatz',
    dlv_assign: 'Zuweisen', dlv_picked_up: 'Abgeholt', dlv_mark_delivered: 'Geliefert', dlv_mark_failed: 'Fehlgeschlagen',
    dlv_cancel: 'Abbrechen', dlv_select_driver: 'Fahrer auswählen',
    dlv_no_available_drivers: 'Keine verfügbaren Fahrer',
    dlv_no_deliveries: 'Keine Lieferungen', dlv_no_drivers: 'Keine Fahrer',
    dlv_customer_name: 'Kundenname', dlv_customer_phone: 'Telefon',
    dlv_address: 'Lieferadresse', dlv_city: 'Stadt', dlv_payment: 'Zahlung',
    dlv_fee: 'Liefergebühr', dlv_notes: 'Notizen', dlv_create: 'Lieferung Erstellen',
    dlv_driver_name: 'Name', dlv_driver_phone: 'Telefon', dlv_vehicle: 'Fahrzeug',
    dlv_motorcycle: 'Motorrad', dlv_car: 'Auto', dlv_bicycle: 'Fahrrad', dlv_van: 'Transporter',
    dlv_available: 'Verfügbar', dlv_busy: 'Beschäftigt', dlv_completed: 'erledigt',
    dlv_delete_driver_confirm: 'Diesen Fahrer löschen?',
    // SMTP Settings
    shop_nav_smtp: 'Email SMTP', shop_nav_email_templates: 'E-Mail-Vorlagen',
    smtp_title: 'SMTP-Konfiguration',
    smtp_subtitle: 'Konfigurieren Sie Ihren eigenen SMTP-Server zum Versand von E-Mails von Ihrer Domain',
    smtp_verified: 'Verifiziert', smtp_not_verified: 'Nicht verifiziert',
    smtp_config_title: 'SMTP-Konfiguration',
    smtp_config_desc: 'Richten Sie Ihren ausgehenden Mailserver ein',
    smtp_preset: 'E-Mail-Anbieter',
    smtp_preset_hint: 'Wählen Sie einen Anbieter zum automatischen Ausfüllen oder wählen Sie Custom.',
    smtp_host: 'SMTP-Host', smtp_port: 'SMTP-Port',
    smtp_username: 'Benutzername', smtp_password: 'Passwort',
    smtp_password_hint: 'leer lassen um aktuelles Passwort zu behalten',
    smtp_password_required_new: 'Passwort ist für eine neue Konfiguration erforderlich',
    smtp_from_email: 'Absender-Email', smtp_from_name: 'Absendername',
    smtp_tls: 'TLS-Verschlüsselung',
    smtp_tls_465: 'Port 465 verwendet direktes SSL. TLS nicht anwendbar.',
    smtp_tls_587: 'Empfohlen für Port 587. Für SSL auf Port 465 deaktivieren.',
    smtp_save: 'E-Mail-Einstellungen speichern',
    smtp_saved: 'SMTP-Einstellungen gespeichert',
    smtp_fill_required: 'Bitte füllen Sie alle Pflichtfelder aus',
    smtp_test_title: 'Test-E-Mail senden',
    smtp_test_desc: 'Überprüfen Sie Ihre Konfiguration durch Senden einer Test-E-Mail',
    smtp_test_recipient: 'Empfänger-Email',
    smtp_test_message: 'Benutzerdefinierte Nachricht (optional)',
    smtp_test_message_placeholder: 'Geben Sie eine benutzerdefinierte Nachricht ein...',
    smtp_send_test: 'Test-E-Mail senden',
    smtp_sending: 'Wird gesendet...',
    smtp_enter_recipient: 'Bitte geben Sie eine Empfänger-Email ein',
    smtp_test_success: 'Test-E-Mail erfolgreich gesendet',
    smtp_save_first: 'Speichern Sie zuerst Ihre SMTP-Einstellungen',
    smtp_last_tested: 'Zuletzt getestet',
    // Email Templates
    et_title: 'E-Mail-Vorlagen',
    et_subtitle: 'Erstellen und verwalten Sie Benachrichtigungs-E-Mail-Vorlagen',
    et_create: 'Vorlage erstellen', et_add_defaults: 'Standardvorlagen hinzufügen',
    et_empty: 'Noch keine Vorlagen',
    et_empty_hint: 'Erstellen Sie Ihre erste Vorlage oder fügen Sie die Standardvorlagen hinzu',
    et_create_title: 'Vorlage erstellen', et_edit_title: 'Vorlage bearbeiten',
    et_create_desc: 'Konfigurieren Sie Ihre Benachrichtigungsvorlage', et_edit_desc: 'Aktualisieren Sie Ihre Benachrichtigungsvorlage',
    et_name: 'Vorlagenname', et_name_placeholder: 'z.B. Willkommens-E-Mail',
    et_channel: 'Kanal', et_event_type: 'Ereignistyp',
    et_subject: 'Betreffzeile', et_subject_placeholder: 'E-Mail-Betreff mit {{Variablen}}',
    et_body: 'Nachrichtentext', et_body_placeholder: 'Schreiben Sie den E-Mail-Text. Verwenden Sie {{Variable}} für dynamische Daten.',
    et_placeholders: 'Platzhalter',
    et_active: 'Vorlage ist aktiv', et_inactive: 'Inaktiv',
    et_cancel: 'Abbrechen', et_save: 'Speichern', et_update: 'Aktualisieren',
    et_updated: 'Vorlage aktualisiert', et_created: 'Vorlage erstellt',
    et_deleted: 'Vorlage gelöscht', et_confirm_delete: 'Möchten Sie diese Vorlage wirklich löschen?',
    et_fill_required: 'Bitte füllen Sie Name, Betreff und Text aus',
    et_preview: 'Vorschau', et_edit: 'Bearbeiten', et_delete: 'Löschen', et_send_test: 'Test senden',
    et_test_sent: 'Test-E-Mail gesendet',
    et_preview_title: 'Vorlagenvorschau',
    et_preview_desc: 'So sieht Ihre E-Mail mit Beispieldaten aus',
    et_preview_plain: 'Klartext', et_preview_email: 'Email HTML',
  },

  // ======================== NEDERLANDS ========================
  nl: {
    nav_features: 'Functies', nav_pricing: 'Prijzen', nav_about: 'Over Ons',
    nav_contact: 'Contact', nav_faq: 'FAQ', nav_login: 'Inloggen', nav_register: 'Registreren',
    nav_mobile: 'Mobiele App',

    hero_badge: 'VeriFactu Compliance Gegarandeerd',
    hero_title: 'Uw Winkel.', hero_title_2: 'Compliant. Simpel.',
    hero_subtitle: 'Kassasysteem en VeriFactu-conforme facturering voor Spaanse winkels en freelancers.',
    hero_cta_pos: 'Volledig Kassa €19.99/mnd', hero_cta_invoice: 'Alleen Facturen €4.99/mnd',
    hero_trusted: 'Vertrouwd door 500+ Spaanse bedrijven',

    features_title: 'Alles Wat Je Nodig Hebt',
    features_subtitle: 'Van kassa tot facturen, voorraadbeheer en meer',
    feature_pos_title: 'Volledig Kassasysteem',
    feature_pos_desc: 'Barcodescanner, contant en pin betaling, thermische bonnen, offline modus.',
    feature_invoice_title: 'VeriFactu Facturen',
    feature_invoice_desc: 'AEAT-conforme facturen met QR-codes, hash-keten en automatische verzending.',
    feature_stock_title: 'Voorraadbeheer',
    feature_stock_desc: 'AI-scan van afleveringsbonnen, lage voorraadwaarschuwingen, houdbaarheidsdatums.',
    feature_staff_title: 'Personeelsbeheer',
    feature_staff_desc: 'PIN-toegang, rollen (kassamedewerker, manager, magazijn), activiteitenlog.',
    feature_reports_title: 'Dagafsluitingsrapporten',
    feature_reports_desc: 'Dagelijkse samenvattingen, verkoop per uur, topproducten, CSV-export.',
    feature_delivery_title: 'Thuisbezorging',
    feature_delivery_desc: 'Bezorgerbeheer, ordertracking, instelbare bezorgkosten.',

    verifactu_label: 'AEAT-REGELGEVING', verifactu_title: 'VeriFactu Verplicht U',
    verifactu_subtitle: 'Vanaf juli 2027 moeten alle Spaanse bedrijven goedgekeurde facturatiesoftware gebruiken.',
    verifactu_feature_1: 'Verifieerbare SHA-256 hash-keten', verifactu_feature_2: 'QR-codes op elke factuur',
    verifactu_feature_3: 'Directe verbinding met AEAT', verifactu_feature_4: 'Geïntegreerd digitaal certificaat',
    verifactu_approved: 'GOEDGEKEURD', verifactu_cta: 'Vandaag Nog Compliant',

    pricing_title: 'Duidelijke Prijzen', pricing_subtitle: 'Geen verrassingen. Geen verborgen kosten. Op elk moment opzegbaar.',
    pricing_invoice_title: 'Facturen', pricing_invoice_subtitle: 'Voor freelancers en kleine bedrijven',
    pricing_invoice_price: '€4.99', pricing_invoice_period: '/mnd',
    pricing_invoice_features: [
      'Onbeperkte VeriFactu-facturen', 'PDF-generatie met QR', 'Klantenbestand',
      'Aanpasbare sjablonen', 'Terugkerende facturen', 'Betalingsopvolging',
      'Export naar CSV/Excel', 'Mobiele app iOS/Android', 'E-mailondersteuning'
    ],
    pricing_pos_title: 'Winkelkassa', pricing_pos_subtitle: 'Voor winkels en zaken',
    pricing_pos_price: '€19.99', pricing_pos_period: '/mnd',
    pricing_pos_features: [
      'Alles van Facturen +', 'Volledig kassasysteem', 'Barcodescanner',
      'Voorraadbeheer met waarschuwingen', 'AI-scan van bonnen', 'Personeelsbeheer met PIN',
      'Dagafsluitingsrapporten', 'ESC/POS thermoprinter', 'Offline modus',
      'Thuisbezorging', 'Prioriteitsondersteuning'
    ],
    pricing_popular: 'Meest Populair', pricing_cta_invoice: 'Start met Facturen',
    pricing_cta_pos: 'Start met Kassa',
    pricing_launch: 'SPECIALE AANBIEDING: Schrijf in vóór 1 mei 2026 - 50% KORTING op jaarplannen',
    pricing_monthly: 'Maandelijks',
    pricing_yearly: 'Jaarlijks',
    pricing_yearly_save: 'Bespaar 15%',
    pricing_per_month: '/mnd',
    pricing_per_year: '/jaar',
    pricing_billed_yearly: 'jaarlijks gefactureerd',

    testimonials_title: 'Wat Onze Klanten Zeggen',
    testimonial_1_text: '"VendFactura heeft me van een boete gered. Mijn facturen voldoen nu aan VeriFactu."',
    testimonial_1_author: 'María García', testimonial_1_role: 'Kruidenierswinkel, Madrid',
    testimonial_2_text: '"De barcodescanner is supernel. Geen wachtrijen meer."',
    testimonial_2_author: 'Antonio López', testimonial_2_role: 'Tabakswinkel, Barcelona',
    testimonial_3_text: '"Als freelancer had ik alleen facturen nodig. Voor €4,99/maand heb ik alles."',
    testimonial_3_author: 'Carlos Ruiz', testimonial_3_role: 'Freelance ontwerper, Valencia',

    faq_title: 'Veelgestelde Vragen',
    faq_1_q: 'Wat is VeriFactu?', faq_1_a: 'VeriFactu is het nieuwe AEAT-systeem dat verifieerbare facturen met QR-codes en hash-ketens vereist. Verplicht vanaf juli 2027.',
    faq_2_q: 'Kan ik uitproberen voor betaling?', faq_2_a: 'Ja, 14 dagen gratis proberen zonder creditcard.',
    faq_3_q: 'Werkt het offline?', faq_3_a: 'Ja, de offline modus laat u verkopen zonder verbinding. Verkopen worden automatisch gesynchroniseerd.',
    faq_4_q: 'Welke printers worden ondersteund?', faq_4_a: 'Elke ESC/POS thermoprinter. Bluetooth, USB of WiFi.',
    faq_5_q: 'Kan ik van plan wisselen?', faq_5_a: 'Ja, op elk moment upgraden van Facturen naar Kassa.',

    cta_title: 'Klaar voor VeriFactu Compliance?',
    cta_subtitle: 'Sluit u aan bij honderden Spaanse bedrijven',
    cta_button: 'Gratis Beginnen',

    footer_description: 'Kassasysteem en VeriFactu-facturering voor Spaanse winkels.',
    footer_product: 'Product', footer_company: 'Bedrijf', footer_legal: 'Juridisch',
    footer_terms: 'Algemene Voorwaarden', footer_privacy: 'Privacybeleid', footer_cookies: 'Cookiebeleid',
    footer_copyright: '© 2025 VendFactura. Alle rechten voorbehouden.', footer_made: 'Met liefde gemaakt in Spanje',

    auth_login: 'Inloggen', auth_register: 'Registreren', auth_email: 'E-mail',
    auth_password: 'Wachtwoord', auth_forgot: 'Wachtwoord vergeten?',
    auth_no_account: 'Nog geen account?', auth_has_account: 'Al een account?',

    shop_nav_dashboard: 'Dashboard', shop_nav_pos: 'Kassa', shop_nav_products: 'Producten',
    shop_nav_stock: 'Voorraad', shop_nav_invoices: 'Facturen', shop_nav_staff: 'Personeel',
    shop_nav_reports: 'Rapporten', shop_nav_delivery: 'Bezorging', shop_nav_printer: 'Printer',
    shop_nav_settings: 'Instellingen', shop_nav_help: 'Help', shop_nav_logout: 'Uitloggen',

    dashboard_welcome: 'Welkom', dashboard_today_sales: 'Verkopen Vandaag',
    dashboard_today_revenue: 'Omzet Vandaag', dashboard_total_products: 'Producten',
    dashboard_low_stock: 'Lage Voorraad', dashboard_pending_invoices: 'Openstaande Facturen',
    dashboard_recent_sales: 'Recente Verkopen', dashboard_quick_actions: 'Snelle Acties',
    dashboard_open_pos: 'Kassa Openen', dashboard_new_product: 'Nieuw Product',
    dashboard_create_invoice: 'Factuur Maken', dashboard_view_reports: 'Rapporten Bekijken',
    dashboard_setup_needed: 'Instelling vereist!', dashboard_setup_desc: 'Stel uw winkel in om te beginnen met verkopen',
    dashboard_start_setup: 'Instelling Starten', dashboard_no_sales_yet: 'Nog geen verkopen',
    dashboard_start_selling: 'Begin met verkopen', dashboard_this_week: 'vs. vorige week',
    dashboard_vs_yesterday: 'vs. gisteren', dashboard_view_all: 'Alles bekijken',

    briefing_title: 'Dagoverzicht', briefing_good_morning: 'Goedemorgen',
    briefing_good_afternoon: 'Goedemiddag', briefing_good_evening: 'Goedenavond',
    briefing_yesterday: 'Afsluiting Gisteren', briefing_sales: 'verkopen', briefing_revenue: 'omzet',
    briefing_restock: 'Herbevoorrading Nodig', briefing_products_low: 'producten met lage voorraad',
    briefing_view_all: 'Alles bekijken', briefing_verifactu: 'VeriFactu Status',
    briefing_all_synced: 'Alles gesynchroniseerd', briefing_pending_sync: 'in afwachting',
    briefing_no_issues: 'Geen problemen', briefing_tasks: 'Taken Vandaag',
    briefing_check_stock: 'Lage voorraad controleren', briefing_review_sales: 'Verkopen van gisteren bekijken',
    briefing_prepare_orders: 'Openstaande bestellingen voorbereiden',

    pos_title: 'Kassa', pos_search: 'Product zoeken of barcode scannen...',
    pos_all: 'Alle', pos_cart: 'Winkelwagen', pos_empty: 'Winkelwagen leeg',
    pos_add_products: 'Voeg producten toe om te beginnen', pos_subtotal: 'Subtotaal', pos_tax: 'BTW',
    pos_total: 'Totaal', pos_pay: 'Betalen', pos_cash: 'Contant', pos_card: 'Pin', pos_split: 'Splitsen',
    pos_cash_received: 'Contant ontvangen', pos_change: 'Wisselgeld',
    pos_customer_name: 'Klantnaam (optioneel)', pos_complete_sale: 'Verkoop Afronden',
    pos_print_receipt: 'Bon Afdrukken', pos_new_sale: 'Nieuwe Verkoop',
    pos_sale_success: 'Verkoop afgerond!', pos_sale_number: 'Verkoop #',
    pos_quick_cash: 'Snelle betaling', pos_exact: 'Exact', pos_back: 'Terug', pos_items: 'artikelen',
    pos_park: 'Parkeren', pos_void: 'Annuleren', pos_no_products: 'Geen producten',
    pos_add_first: 'Voeg producten toe uit de catalogus',
    pos_offline_mode: 'Offline modus', pos_offline_sales_saved: 'Verkopen worden lokaal opgeslagen',
    pos_back_online: 'Weer online', pos_online: 'Online', pos_offline: 'Offline',
    pos_offline_saved: 'Verkoop offline opgeslagen. Wordt gesynchroniseerd wanneer de verbinding terugkeert.',
    pos_pending: 'in afwachting', pos_syncing: 'Synchroniseren...', pos_synced: 'gesynchroniseerd',
    pos_failed: 'mislukt', pos_sales_synced: 'verkopen gesynchroniseerd', pos_sync_partial: 'Gedeeltelijke synchronisatie',
    pos_cached: 'Cache',

    products_title: 'Producten', products_search: 'Producten zoeken...',
    products_add: 'Nieuw Product', products_edit: 'Product Bewerken', products_create: 'Product Aanmaken',
    products_save: 'Opslaan', products_cancel: 'Annuleren', products_delete: 'Verwijderen',
    products_name: 'Naam', products_description: 'Beschrijving', products_price: 'Prijs (€)',
    products_category: 'Categorie', products_barcode: 'Barcode', products_stock: 'Voorraad',
    products_low_threshold: 'Lage drempel', products_tax_rate: 'BTW', products_unit: 'Eenheid',
    products_available: 'Beschikbaar', products_all: 'Alle', products_no_products: 'Geen producten gevonden',
    products_add_first: 'Voeg uw eerste product toe', products_confirm_delete: 'Dit product verwijderen?',
    products_yes_delete: 'Ja, verwijderen', products_total: 'Totaal producten',

    inv_title: 'Facturen', inv_create: 'Nieuwe Factuur', inv_edit: 'Factuur Bewerken',
    inv_number: 'Factuur #', inv_date: 'Datum', inv_due_date: 'Vervaldatum',
    inv_customer: 'Klant', inv_customer_name: 'Klantnaam', inv_customer_nif: 'Btw-nummer (NIF)',
    inv_customer_address: 'Adres', inv_customer_city: 'Stad', inv_customer_postal: 'Postcode',
    inv_customer_email: 'E-mail', inv_items: 'Regels', inv_description: 'Omschrijving',
    inv_quantity: 'Aantal', inv_price: 'Prijs', inv_tax_rate: 'BTW %', inv_line_total: 'Totaal',
    inv_add_line: 'Regel toevoegen', inv_subtotal: 'Subtotaal', inv_tax: 'BTW', inv_total: 'Totaal',
    inv_payment: 'Betaalwijze', inv_bank: 'Overschrijving', inv_cash: 'Contant', inv_card: 'Pin', inv_other: 'Overig',
    inv_notes: 'Opmerkingen', inv_status: 'Status', inv_draft: 'Concept', inv_issued: 'Uitgegeven',
    inv_paid: 'Betaald', inv_cancelled: 'Geannuleerd', inv_save: 'Factuur Opslaan',
    inv_download_pdf: 'PDF Downloaden', inv_mark_paid: 'Als Betaald Markeren', inv_cancel_invoice: 'Annuleren',
    inv_verify: 'Hash Controleren', inv_verifactu: 'VeriFactu', inv_hash_valid: 'Hash geldig',
    inv_hash_invalid: 'Hash gewijzigd', inv_no_invoices: 'Geen facturen',
    inv_create_first: 'Maak uw eerste factuur', inv_all: 'Alle', inv_search: 'Facturen zoeken...',

    // Payment
    pay_processing: 'Betaling wordt verwerkt...', pay_wait: 'Even geduld terwijl we uw betaling bevestigen.',
    pay_success: 'Betaling Geslaagd!', pay_success_desc: 'Uw abonnement is nu actief.',
    pay_plan: 'Plan', pay_go_dashboard: 'Naar Dashboard', pay_go_invoices: 'Facturen Maken',
    pay_back_home: 'Terug naar Home', pay_error: 'Betalingsprobleem',
    pay_error_desc: 'Er was een probleem met uw betaling. Probeer het opnieuw.',
    pay_try_again: 'Opnieuw Proberen', pay_cancelled: 'Betaling Geannuleerd',
    pay_cancelled_desc: 'Er zijn geen kosten in rekening gebracht. U kunt het op elk moment opnieuw proberen.',
    pay_back_pricing: 'Terug naar Prijzen',

    // Invoice Portal
    inv_portal_dashboard: 'Dashboard', inv_portal_title: 'Facturenportaal',
    inv_portal_welcome: 'Welkom', inv_portal_subtitle: 'VeriFactu Facturenportaal',
    inv_portal_total_invoices: 'Totaal Facturen', inv_portal_pending: 'Openstaand',
    inv_portal_paid: 'Betaald', inv_portal_revenue: 'Omzet',
    inv_portal_recent: 'Recente Facturen', inv_portal_view_all: 'Alles Bekijken',
    inv_portal_business: 'Bedrijfsgegevens', inv_portal_biz_name: 'Bedrijfsnaam',
    inv_setup_title: 'Stel Uw Bedrijf In', inv_setup_desc: 'Voer uw bedrijfsgegevens in voor VeriFactu facturen',
    inv_setup_name: 'Bedrijfsnaam', inv_setup_legal: 'Handelsnaam',
    inv_setup_submit: 'Bedrijf Aanmaken & Starten',
    inv_setup_phone: 'Telefoon',

    // Stock
    stock_title: 'Voorraadbeheer', stock_tracked: 'gevolgde producten',
    stock_total: 'Totaal', stock_low: 'Lage Voorraad', stock_out: 'Uitverkocht',
    stock_ok: 'OK', stock_unlimited: 'Onbeperkt',
    stock_overview: 'Overzicht', stock_history: 'Geschiedenis', stock_scanner: 'AI Scanner',
    stock_product: 'Product', stock_category: 'Categorie', stock_current: 'Voorraad',
    stock_threshold: 'Min', stock_status: 'Status', stock_search: 'Zoeken...',
    stock_alert_title: 'Voorraadwaarschuwing', stock_items: 'artikelen',
    stock_add: 'Toevoegen', stock_adjust: 'Aanpassen', stock_adjust_title: 'Voorraad Aanpassen',
    stock_type: 'Type', stock_intake: 'Inkomst', stock_sale: 'Verkoop',
    stock_adjustment: 'Aanpassing', stock_loss: 'Verlies', stock_return: 'Retour',
    stock_supplier: 'Leverancier', stock_cost: 'Kosten/Eenheid (€)', stock_confirm: 'Bevestigen',
    stock_no_movements: 'Geen voorraadmutaties',
    stock_scan_title: 'AI Bonscanner', stock_scan_desc: 'Upload een leveranciersbon',
    stock_upload: 'Bon Uploaden', stock_scanning: 'Scannen...',
    stock_scan_results: 'Resultaten', stock_matched: 'Overeenkomende Producten',
    stock_unmatched: 'Niet Overeenkomend', stock_confirm_intake: 'Inkomst Bevestigen',
    stock_scan_error: 'Scan mislukt',
    stock_cost_price: 'Inkoop', stock_sale_price: 'Verkoopprijs',
    stock_reorder: 'Herbestelsuggesties', stock_reorder_desc: 'Gebaseerd op verkoopsnelheid afgelopen 30 dagen',
    stock_reorder_all_good: 'Alles Op Voorraad!', stock_reorder_no_items: 'Geen producten hoeven besteld te worden.',
    stock_reorder_velocity: 'Verkopen/Dag', stock_reorder_days_left: 'Dagen Over',
    stock_reorder_qty: 'Voorgestelde Hoeveelheid', stock_reorder_est_cost: 'Gesch. Kosten',
    stock_reorder_urgency: 'Urgentie',
    stock_urgency_critical: 'Kritiek', stock_urgency_urgent: 'Dringend',
    stock_urgency_soon: 'Binnenkort', stock_urgency_ok: 'OK',

    // Reports
    reports_title: 'Rapporten', reports_subtitle: 'Verkoopanalyse en eindedagrapporten',
    reports_daily: 'Dagrapport', reports_weekly: 'Weekoverzicht',
    reports_today: 'Vandaag', reports_revenue: 'Omzet', reports_sales: 'Verkopen',
    reports_avg: 'Gem. Verkoop', reports_invoices: 'Facturen',
    reports_payment_split: 'Betaalmethoden', reports_no_sales: 'Geen verkopen',
    reports_hourly: 'Per Uur', reports_top_products: 'Top Producten',
    reports_sales_short: 'verkopen', reports_cash: 'Contant', reports_card: 'Kaart',
    reports_weekly_summary: 'Weekoverzicht',
    reports_total_revenue: 'Totale Omzet', reports_total_sales: 'Totale Verkopen',
    reports_daily_avg: 'Daggemiddelde', reports_daily_breakdown: 'Dagelijkse Verdeling',
    staff_title: 'Personeelsbeheer', staff_members: 'leden',
    staff_add: 'Toevoegen', staff_active: 'Actief Personeel', staff_inactive: 'Inactief',
    staff_empty: 'Geen Personeel', staff_empty_desc: 'Voeg uw eerste teamlid toe',
    staff_name: 'Naam', staff_role_label: 'Rol',
    staff_role_manager: 'Manager', staff_role_cashier: 'Kassier',
    staff_role_stock_clerk: 'Magazijnier', staff_role_driver: 'Chauffeur',
    staff_edit: 'Bewerken', staff_save: 'Opslaan', staff_create: 'Aanmaken',
    staff_delete: 'Verwijderen', staff_delete_confirm: 'Dit lid verwijderen?',
    staff_deactivate: 'Deactiveren', staff_activate: 'Activeren',
    staff_regen_pin: 'Nieuwe PIN', staff_new_pin: 'Nieuwe PIN',
    notif_title: 'Meldingen', notif_mark_all: 'Alles gelezen', notif_empty: 'Geen meldingen',
    receipt_ticket: 'Bon', receipt_subtotal: 'Subtotaal', receipt_tax: 'BTW', receipt_payment: 'Betaling',
    receipt_received: 'Ontvangen', receipt_change: 'Wisselgeld', receipt_thanks: 'Bedankt voor uw aankoop',
    inv_send_email: 'Per Email Verzenden', inv_send: 'Verzenden', inv_email_required: 'Email vereist',
    inv_email_sent: 'Factuur per email verzonden', inv_email_failed: 'Fout bij verzenden',
    inv_email_sent_to: 'Verzonden naar',
    print_title: 'Printer', print_subtitle: 'Bonprinter instellingen',
    print_how_title: 'Hoe u uw printer aansluit',
    print_usb_guide: 'USB: Sluit aan en selecteer in afdrukdialoog',
    print_wifi_guide: 'WiFi: Stel printer-IP in op uw netwerk',
    print_browser_guide: 'Browser: Ctrl+P of Afdrukknop',
    print_paper_size: 'Papierformaat', print_80mm_desc: 'Standaard voor de meeste printers',
    print_58mm_desc: 'Compacte en draagbare printers',
    print_receipt_options: 'Bon Opties', print_auto_print: 'Automatisch afdrukken na verkoop',
    print_show_header: 'Winkelgegevens tonen', print_show_footer: 'Bonvoettekst tonen',
    print_test: 'Testbon Afdrukken',
    shop_nav_payments: 'Betalingen',
    paysettings_title: 'Betalingsopties',
    paysettings_subtitle: 'Betalingsopties configureren voor klanten',
    paysettings_info: 'Deze opties worden getoond aan klanten op online facturen. Voeg EU/UK bankoverschrijvingen, contant of andere methodes toe.',
    paysettings_save: 'Opslaan', paysettings_saved: 'Opgeslagen',
    paysettings_empty: 'Geen betaalmethoden geconfigureerd',
    paysettings_add: 'Methode Toevoegen',
    paysettings_label: 'Naam', paysettings_bank_name: 'Banknaam',
    paysettings_holder: 'Rekeninghouder', paysettings_sort_code: 'Sort Code',
    paysettings_acc_number: 'Rekeningnummer', paysettings_instructions: 'Instructies',
    inv_copy_link: 'Link Kopiëren', inv_view_online: 'Online Bekijken',
    inv_link_copied: 'Link gekopieerd',
    reminder_title: 'Betalingsherinneringen', reminder_desc: 'Automatische herinneringen voor klanten met achterstallige facturen',
    reminder_days_label: 'Herinnering sturen na', reminder_after: 'Na',
    reminder_days_unit: 'dagen', reminder_add_day: 'Interval toevoegen',
    reminder_max: 'Max herinneringen per factuur', reminder_send_now: 'Herinneringen Nu Sturen',
    reminder_sent_count: 'herinneringen verzonden', inv_reminders_sent: 'Herinneringen verzonden',
    dlv_title: 'Bezorgingen', dlv_subtitle: 'Bestellingen en bezorgers beheren',
    dlv_new_delivery: 'Nieuwe Bezorging', dlv_add_driver: 'Bezorger Toevoegen',
    dlv_orders: 'Bestellingen', dlv_drivers: 'Bezorgers', dlv_all: 'Alle',
    dlv_pending: 'In afwachting', dlv_in_progress: 'Onderweg', dlv_delivered: 'Bezorgd', dlv_failed: 'Mislukt',
    dlv_drivers_available: 'Beschikbaar', dlv_revenue: 'Omzet',
    dlv_assign: 'Toewijzen', dlv_picked_up: 'Opgehaald', dlv_mark_delivered: 'Bezorgd', dlv_mark_failed: 'Mislukt',
    dlv_cancel: 'Annuleren', dlv_select_driver: 'Bezorger selecteren',
    dlv_no_available_drivers: 'Geen beschikbare bezorgers',
    dlv_no_deliveries: 'Geen bezorgingen', dlv_no_drivers: 'Geen bezorgers',
    dlv_customer_name: 'Klantnaam', dlv_customer_phone: 'Telefoon',
    dlv_address: 'Bezorgadres', dlv_city: 'Stad', dlv_payment: 'Betaling',
    dlv_fee: 'Bezorgkosten', dlv_notes: 'Notities', dlv_create: 'Bezorging Aanmaken',
    dlv_driver_name: 'Naam', dlv_driver_phone: 'Telefoon', dlv_vehicle: 'Voertuig',
    dlv_motorcycle: 'Motor', dlv_car: 'Auto', dlv_bicycle: 'Fiets', dlv_van: 'Bestelbus',
    dlv_available: 'Beschikbaar', dlv_busy: 'Bezet', dlv_completed: 'voltooid',
    dlv_delete_driver_confirm: 'Deze bezorger verwijderen?',
    // SMTP Settings
    shop_nav_smtp: 'Email SMTP', shop_nav_email_templates: 'E-mailsjablonen',
    smtp_title: 'SMTP-configuratie',
    smtp_subtitle: 'Configureer uw eigen SMTP-server om e-mails te verzenden vanaf uw domein',
    smtp_verified: 'Geverifieerd', smtp_not_verified: 'Niet geverifieerd',
    smtp_config_title: 'SMTP-configuratie',
    smtp_config_desc: 'Stel uw uitgaande mailserver in',
    smtp_preset: 'E-mailprovider',
    smtp_preset_hint: 'Selecteer een provider om automatisch in te vullen, of kies Custom.',
    smtp_host: 'SMTP-host', smtp_port: 'SMTP-poort',
    smtp_username: 'Gebruikersnaam', smtp_password: 'Wachtwoord',
    smtp_password_hint: 'leeg laten om huidig wachtwoord te behouden',
    smtp_password_required_new: 'Wachtwoord is vereist voor een nieuwe configuratie',
    smtp_from_email: 'Afzender e-mail', smtp_from_name: 'Afzendernaam',
    smtp_tls: 'TLS-versleuteling',
    smtp_tls_465: 'Poort 465 gebruikt directe SSL. TLS niet van toepassing.',
    smtp_tls_587: 'Aanbevolen voor poort 587. Uitschakelen voor SSL op poort 465.',
    smtp_save: 'E-mailinstellingen opslaan',
    smtp_saved: 'SMTP-instellingen opgeslagen',
    smtp_fill_required: 'Vul alle verplichte velden in',
    smtp_test_title: 'Test-e-mail verzenden',
    smtp_test_desc: 'Verifieer uw configuratie door een test-e-mail te verzenden',
    smtp_test_recipient: 'Ontvanger e-mail',
    smtp_test_message: 'Aangepast bericht (optioneel)',
    smtp_test_message_placeholder: 'Typ een aangepast bericht voor de test-e-mail...',
    smtp_send_test: 'Test-e-mail verzenden',
    smtp_sending: 'Verzenden...',
    smtp_enter_recipient: 'Voer een ontvanger e-mailadres in',
    smtp_test_success: 'Test-e-mail succesvol verzonden',
    smtp_save_first: 'Sla eerst uw SMTP-instellingen op voordat u een test verzendt',
    smtp_last_tested: 'Laatst getest',
    // Email Templates
    et_title: 'E-mailsjablonen',
    et_subtitle: 'Maak en beheer e-mailnotificatiesjablonen',
    et_create: 'Sjabloon maken', et_add_defaults: 'Standaardsjablonen toevoegen',
    et_empty: 'Nog geen sjablonen',
    et_empty_hint: 'Maak uw eerste sjabloon of voeg de standaarden toe',
    et_create_title: 'Sjabloon maken', et_edit_title: 'Sjabloon bewerken',
    et_create_desc: 'Configureer uw notificatiesjabloon', et_edit_desc: 'Werk uw notificatiesjabloon bij',
    et_name: 'Sjabloonnaam', et_name_placeholder: 'bijv. Welkomst-e-mail',
    et_channel: 'Kanaal', et_event_type: 'Evenementtype',
    et_subject: 'Onderwerp', et_subject_placeholder: 'E-mail onderwerp met {{variabelen}}',
    et_body: 'Berichttekst', et_body_placeholder: 'Schrijf de e-mailtekst. Gebruik {{variabele}} voor dynamische gegevens.',
    et_placeholders: 'Variabelen',
    et_active: 'Sjabloon is actief', et_inactive: 'Inactief',
    et_cancel: 'Annuleren', et_save: 'Opslaan', et_update: 'Bijwerken',
    et_updated: 'Sjabloon bijgewerkt', et_created: 'Sjabloon aangemaakt',
    et_deleted: 'Sjabloon verwijderd', et_confirm_delete: 'Weet u zeker dat u dit sjabloon wilt verwijderen?',
    et_fill_required: 'Vul naam, onderwerp en tekst in',
    et_preview: 'Voorbeeld', et_edit: 'Bewerken', et_delete: 'Verwijderen', et_send_test: 'Test verzenden',
    et_test_sent: 'Test-e-mail verzonden',
    et_preview_title: 'Sjabloonvoorbeeld',
    et_preview_desc: 'Zo ziet uw e-mail eruit met voorbeeldgegevens',
    et_preview_plain: 'Platte tekst', et_preview_email: 'Email HTML',

    // Tickets / Support
    shop_nav_tickets: 'Ondersteuning',
    tickets_title: 'Supporttickets', tickets_subtitle: 'Beheer uw ondersteuningsverzoeken',
    tickets_new: 'Nieuw Ticket', tickets_empty: 'Geen tickets', tickets_empty_desc: 'Maak een ticket aan als u hulp nodig heeft',
    tickets_subject: 'Onderwerp', tickets_category: 'Categorie', tickets_priority: 'Prioriteit',
    tickets_message: 'Bericht', tickets_submit: 'Ticket Verzenden',
    tickets_reply_placeholder: 'Typ uw antwoord...', tickets_close: 'Ticket sluiten',
    tickets_closed_msg: 'Dit ticket is gesloten',
  },

  // ======================== हिन्दी (HINDI) ========================
  hi: {
    nav_features: 'सुविधाएँ', nav_pricing: 'मूल्य', nav_about: 'हमारे बारे में',
    nav_contact: 'संपर्क', nav_faq: 'FAQ', nav_login: 'लॉग इन', nav_register: 'साइन अप',
    nav_mobile: 'मोबाइल ऐप',

    hero_badge: 'VeriFactu अनुपालन गारंटीकृत',
    hero_title: 'आपकी दुकान.', hero_title_2: 'अनुपालित. सरल.',
    hero_subtitle: 'स्पेनिश दुकानों और फ्रीलांसरों के लिए POS सिस्टम और VeriFactu-अनुपालित इनवॉइसिंग।',
    hero_cta_pos: 'पूर्ण POS €19.99/माह', hero_cta_invoice: 'केवल इनवॉइस €4.99/माह',
    hero_trusted: '500+ स्पेनिश व्यवसायों द्वारा विश्वसनीय',

    features_title: 'आपको जो कुछ भी चाहिए',
    features_subtitle: 'POS से इनवॉइस तक, स्टॉक प्रबंधन और बहुत कुछ',
    feature_pos_title: 'पूर्ण POS सिस्टम',
    feature_pos_desc: 'बारकोड स्कैनर, नकद और कार्ड भुगतान, थर्मल रसीदें, ऑफ़लाइन मोड।',
    feature_invoice_title: 'VeriFactu इनवॉइस',
    feature_invoice_desc: 'QR कोड, हैश चेन और स्वचालित सबमिशन के साथ AEAT-अनुपालित इनवॉइस।',
    feature_stock_title: 'स्टॉक प्रबंधन',
    feature_stock_desc: 'AI रसीद स्कैनिंग, कम स्टॉक अलर्ट, समाप्ति तिथियां।',
    feature_staff_title: 'कर्मचारी प्रबंधन',
    feature_staff_desc: 'PIN एक्सेस, भूमिकाएं (कैशियर, मैनेजर, स्टॉक), गतिविधि लॉग।',
    feature_reports_title: 'दिन की समाप्ति रिपोर्ट',
    feature_reports_desc: 'दैनिक सारांश, प्रति घंटा बिक्री, शीर्ष उत्पाद, CSV निर्यात।',
    feature_delivery_title: 'होम डिलीवरी',
    feature_delivery_desc: 'ड्राइवर प्रबंधन, ऑर्डर ट्रैकिंग, कॉन्फ़िगर करने योग्य डिलीवरी शुल्क।',

    verifactu_label: 'AEAT विनियमन', verifactu_title: 'VeriFactu आपको बाध्य करता है',
    verifactu_subtitle: 'जुलाई 2027 से, सभी स्पेनिश व्यवसायों को अनुमोदित इनवॉइसिंग सॉफ़्टवेयर का उपयोग करना होगा।',
    verifactu_feature_1: 'सत्यापन योग्य SHA-256 हैश चेन', verifactu_feature_2: 'हर इनवॉइस पर QR कोड',
    verifactu_feature_3: 'AEAT से सीधा कनेक्शन', verifactu_feature_4: 'एकीकृत डिजिटल प्रमाणपत्र',
    verifactu_approved: 'अनुमोदित', verifactu_cta: 'आज ही अनुपालित बनें',

    pricing_title: 'स्पष्ट मूल्य निर्धारण', pricing_subtitle: 'कोई आश्चर्य नहीं। कोई छिपे शुल्क नहीं। कभी भी रद्द करें।',
    pricing_invoice_title: 'इनवॉइस', pricing_invoice_subtitle: 'फ्रीलांसरों और छोटे व्यवसायों के लिए',
    pricing_invoice_price: '€4.99', pricing_invoice_period: '/माह',
    pricing_invoice_features: [
      'असीमित VeriFactu इनवॉइस', 'QR के साथ PDF निर्माण', 'ग्राहक निर्देशिका',
      'अनुकूलन योग्य टेम्पलेट', 'आवर्ती इनवॉइस', 'भुगतान ट्रैकिंग',
      'CSV/Excel निर्यात', 'मोबाइल ऐप iOS/Android', 'ईमेल सहायता'
    ],
    pricing_pos_title: 'दुकान POS', pricing_pos_subtitle: 'दुकानों और स्टोर के लिए',
    pricing_pos_price: '€19.99', pricing_pos_period: '/माह',
    pricing_pos_features: [
      'इनवॉइस की सभी सुविधाएँ +', 'पूर्ण POS सिस्टम', 'बारकोड स्कैनर',
      'अलर्ट के साथ स्टॉक प्रबंधन', 'AI रसीद स्कैनिंग', 'PIN के साथ कर्मचारी प्रबंधन',
      'दिन की समाप्ति रिपोर्ट', 'ESC/POS थर्मल प्रिंटर', 'ऑफ़लाइन मोड',
      'होम डिलीवरी', 'प्राथमिकता सहायता'
    ],
    pricing_popular: 'सबसे लोकप्रिय', pricing_cta_invoice: 'इनवॉइस से शुरू करें',
    pricing_cta_pos: 'POS से शुरू करें',
    pricing_launch: 'विशेष प्रस्ताव: 1 मई 2026 से पहले साइन अप करें - वार्षिक प्लान पर 50% की छूट',
    pricing_monthly: 'मासिक',
    pricing_yearly: 'वार्षिक',
    pricing_yearly_save: '15% बचाएं',
    pricing_per_month: '/माह',
    pricing_per_year: '/वर्ष',
    pricing_billed_yearly: 'वार्षिक बिलिंग',

    testimonials_title: 'हमारे ग्राहक क्या कहते हैं',
    testimonial_1_text: '"VendFactura ने मुझे जुर्माने से बचाया। अब मेरे इनवॉइस VeriFactu के अनुपालित हैं।"',
    testimonial_1_author: 'मारिया गार्सिया', testimonial_1_role: 'किराना स्टोर, मैड्रिड',
    testimonial_2_text: '"बारकोड स्कैनर बेहद तेज़ है। अब कोई कतार नहीं।"',
    testimonial_2_author: 'एंटोनियो लोपेज़', testimonial_2_role: 'तंबाकू की दुकान, बार्सिलोना',
    testimonial_3_text: '"एक फ्रीलांसर के रूप में, मुझे केवल इनवॉइसिंग चाहिए थी। €4.99/माह में सब कुछ है।"',
    testimonial_3_author: 'कार्लोस रुइज़', testimonial_3_role: 'फ्रीलांस डिज़ाइनर, वालेंसिया',

    faq_title: 'अक्सर पूछे जाने वाले प्रश्न',
    faq_1_q: 'VeriFactu क्या है?', faq_1_a: 'VeriFactu AEAT की नई प्रणाली है जो QR कोड और हैश चेन के साथ सत्यापन योग्य इनवॉइस की आवश्यकता रखती है। जुलाई 2027 से अनिवार्य।',
    faq_2_q: 'क्या मैं भुगतान से पहले आज़मा सकता हूँ?', faq_2_a: 'हाँ, बिना क्रेडिट कार्ड के 14 दिन का मुफ्त परीक्षण।',
    faq_3_q: 'क्या यह ऑफ़लाइन काम करता है?', faq_3_a: 'हाँ, ऑफ़लाइन मोड बिना कनेक्शन के बिक्री जारी रखने देता है।',
    faq_4_q: 'कौन से प्रिंटर समर्थित हैं?', faq_4_a: 'कोई भी ESC/POS थर्मल प्रिंटर। Bluetooth, USB या WiFi।',
    faq_5_q: 'क्या मैं प्लान बदल सकता हूँ?', faq_5_a: 'हाँ, कभी भी इनवॉइस से POS में अपग्रेड करें।',

    cta_title: 'VeriFactu अनुपालन के लिए तैयार?',
    cta_subtitle: 'सैकड़ों स्पेनिश व्यवसायों से जुड़ें',
    cta_button: 'मुफ्त शुरू करें',

    footer_description: 'स्पेनिश दुकानों के लिए POS सिस्टम और VeriFactu इनवॉइसिंग।',
    footer_product: 'उत्पाद', footer_company: 'कंपनी', footer_legal: 'कानूनी',
    footer_terms: 'नियम और शर्तें', footer_privacy: 'गोपनीयता नीति', footer_cookies: 'कुकी नीति',
    footer_copyright: '© 2025 VendFactura. सर्वाधिकार सुरक्षित।', footer_made: 'स्पेन में प्यार से बनाया गया',

    auth_login: 'लॉग इन', auth_register: 'साइन अप', auth_email: 'ईमेल',
    auth_password: 'पासवर्ड', auth_forgot: 'पासवर्ड भूल गए?',
    auth_no_account: 'खाता नहीं है?', auth_has_account: 'पहले से खाता है?',

    shop_nav_dashboard: 'डैशबोर्ड', shop_nav_pos: 'बिक्री बिंदु', shop_nav_products: 'उत्पाद',
    shop_nav_stock: 'स्टॉक', shop_nav_invoices: 'इनवॉइस', shop_nav_staff: 'कर्मचारी',
    shop_nav_reports: 'रिपोर्ट', shop_nav_delivery: 'डिलीवरी', shop_nav_printer: 'प्रिंटर',
    shop_nav_settings: 'सेटिंग्स', shop_nav_help: 'सहायता', shop_nav_logout: 'लॉग आउट',

    dashboard_welcome: 'स्वागत है', dashboard_today_sales: 'आज की बिक्री',
    dashboard_today_revenue: 'आज का राजस्व', dashboard_total_products: 'उत्पाद',
    dashboard_low_stock: 'कम स्टॉक', dashboard_pending_invoices: 'लंबित इनवॉइस',
    dashboard_recent_sales: 'हालिया बिक्री', dashboard_quick_actions: 'त्वरित कार्य',
    dashboard_open_pos: 'POS खोलें', dashboard_new_product: 'नया उत्पाद',
    dashboard_create_invoice: 'इनवॉइस बनाएं', dashboard_view_reports: 'रिपोर्ट देखें',
    dashboard_setup_needed: 'सेटअप पूरा करें!', dashboard_setup_desc: 'बिक्री शुरू करने के लिए अपनी दुकान सेट करें',
    dashboard_start_setup: 'सेटअप शुरू करें', dashboard_no_sales_yet: 'अभी तक कोई बिक्री नहीं',
    dashboard_start_selling: 'बिक्री शुरू करें', dashboard_this_week: 'पिछले सप्ताह की तुलना में',
    dashboard_vs_yesterday: 'कल की तुलना में', dashboard_view_all: 'सभी देखें',

    briefing_title: 'दैनिक ब्रीफिंग', briefing_good_morning: 'सुप्रभात',
    briefing_good_afternoon: 'नमस्कार', briefing_good_evening: 'शुभ संध्या',
    briefing_yesterday: 'कल का समापन', briefing_sales: 'बिक्री', briefing_revenue: 'राजस्व',
    briefing_restock: 'पुनःभरण आवश्यक', briefing_products_low: 'कम स्टॉक वाले उत्पाद',
    briefing_view_all: 'सभी देखें', briefing_verifactu: 'VeriFactu स्थिति',
    briefing_all_synced: 'सब सिंक्रनाइज़', briefing_pending_sync: 'लंबित',
    briefing_no_issues: 'कोई समस्या नहीं', briefing_tasks: 'आज के कार्य',
    briefing_check_stock: 'कम स्टॉक जांचें', briefing_review_sales: 'कल की बिक्री देखें',
    briefing_prepare_orders: 'लंबित ऑर्डर तैयार करें',

    pos_title: 'बिक्री बिंदु', pos_search: 'उत्पाद खोजें या बारकोड स्कैन करें...',
    pos_all: 'सभी', pos_cart: 'कार्ट', pos_empty: 'कार्ट खाली',
    pos_add_products: 'शुरू करने के लिए उत्पाद जोड़ें', pos_subtotal: 'उप-योग', pos_tax: 'कर',
    pos_total: 'कुल', pos_pay: 'भुगतान', pos_cash: 'नकद', pos_card: 'कार्ड', pos_split: 'विभाजित',
    pos_cash_received: 'प्राप्त नकद', pos_change: 'वापसी',
    pos_customer_name: 'ग्राहक का नाम (वैकल्पिक)', pos_complete_sale: 'बिक्री पूरी करें',
    pos_print_receipt: 'रसीद प्रिंट करें', pos_new_sale: 'नई बिक्री',
    pos_sale_success: 'बिक्री पूरी हुई!', pos_sale_number: 'बिक्री #',
    pos_quick_cash: 'त्वरित नकद', pos_exact: 'सटीक', pos_back: 'वापस', pos_items: 'आइटम',
    pos_park: 'पार्क', pos_void: 'रद्द करें', pos_no_products: 'कोई उत्पाद नहीं',
    pos_add_first: 'कैटलॉग से उत्पाद जोड़ें',
    pos_offline_mode: 'ऑफ़लाइन मोड', pos_offline_sales_saved: 'बिक्री स्थानीय रूप से सहेजी गई',
    pos_back_online: 'वापस ऑनलाइन', pos_online: 'ऑनलाइन', pos_offline: 'ऑफ़लाइन',
    pos_offline_saved: 'बिक्री ऑफ़लाइन सहेजी गई। कनेक्शन वापस आने पर सिंक होगी।',
    pos_pending: 'लंबित', pos_syncing: 'सिंक हो रहा है...', pos_synced: 'सिंक किया',
    pos_failed: 'विफल', pos_sales_synced: 'बिक्री सिंक हुई', pos_sync_partial: 'आंशिक सिंक',
    pos_cached: 'कैश',

    products_title: 'उत्पाद', products_search: 'उत्पाद खोजें...',
    products_add: 'नया उत्पाद', products_edit: 'उत्पाद संपादित करें', products_create: 'उत्पाद बनाएं',
    products_save: 'सहेजें', products_cancel: 'रद्द करें', products_delete: 'हटाएं',
    products_name: 'नाम', products_description: 'विवरण', products_price: 'मूल्य (€)',
    products_category: 'श्रेणी', products_barcode: 'बारकोड', products_stock: 'स्टॉक',
    products_low_threshold: 'न्यूनतम सीमा', products_tax_rate: 'कर दर', products_unit: 'इकाई',
    products_available: 'उपलब्ध', products_all: 'सभी', products_no_products: 'कोई उत्पाद नहीं मिला',
    products_add_first: 'अपना पहला उत्पाद जोड़ें', products_confirm_delete: 'इस उत्पाद को हटाएं?',
    products_yes_delete: 'हाँ, हटाएं', products_total: 'कुल उत्पाद',

    inv_title: 'इनवॉइस', inv_create: 'नया इनवॉइस', inv_edit: 'इनवॉइस संपादित करें',
    inv_number: 'इनवॉइस #', inv_date: 'तारीख', inv_due_date: 'देय तिथि',
    inv_customer: 'ग्राहक', inv_customer_name: 'ग्राहक का नाम', inv_customer_nif: 'कर ID (NIF)',
    inv_customer_address: 'पता', inv_customer_city: 'शहर', inv_customer_postal: 'पिन कोड',
    inv_customer_email: 'ईमेल', inv_items: 'आइटम', inv_description: 'विवरण',
    inv_quantity: 'मात्रा', inv_price: 'मूल्य', inv_tax_rate: 'कर %', inv_line_total: 'कुल',
    inv_add_line: 'पंक्ति जोड़ें', inv_subtotal: 'उप-योग', inv_tax: 'कर', inv_total: 'कुल',
    inv_payment: 'भुगतान विधि', inv_bank: 'बैंक ट्रांसफर', inv_cash: 'नकद', inv_card: 'कार्ड', inv_other: 'अन्य',
    inv_notes: 'नोट्स', inv_status: 'स्थिति', inv_draft: 'ड्राफ्ट', inv_issued: 'जारी',
    inv_paid: 'भुगतान', inv_cancelled: 'रद्द', inv_save: 'इनवॉइस सहेजें',
    inv_download_pdf: 'PDF डाउनलोड', inv_mark_paid: 'भुगतान चिह्नित करें', inv_cancel_invoice: 'रद्द करें',
    inv_verify: 'हैश सत्यापित करें', inv_verifactu: 'VeriFactu', inv_hash_valid: 'हैश मान्य',
    inv_hash_invalid: 'हैश बदला गया', inv_no_invoices: 'कोई इनवॉइस नहीं',
    inv_create_first: 'अपना पहला इनवॉइस बनाएं', inv_all: 'सभी', inv_search: 'इनवॉइस खोजें...',

    // Payment
    pay_processing: 'भुगतान प्रक्रिया में...', pay_wait: 'कृपया प्रतीक्षा करें जब तक हम भुगतान की पुष्टि करें।',
    pay_success: 'भुगतान सफल!', pay_success_desc: 'आपकी सदस्यता सक्रिय है।',
    pay_plan: 'प्लान', pay_go_dashboard: 'डैशबोर्ड पर जाएं', pay_go_invoices: 'इनवॉइस बनाना शुरू करें',
    pay_back_home: 'होम पर वापस जाएं', pay_error: 'भुगतान त्रुटि',
    pay_error_desc: 'भुगतान में समस्या हुई। कृपया पुनः प्रयास करें।',
    pay_try_again: 'पुनः प्रयास करें', pay_cancelled: 'भुगतान रद्द',
    pay_cancelled_desc: 'कोई शुल्क नहीं लिया गया। आप कभी भी पुनः प्रयास कर सकते हैं।',
    pay_back_pricing: 'मूल्य पर वापस जाएं',

    // Invoice Portal
    inv_portal_dashboard: 'डैशबोर्ड', inv_portal_title: 'इनवॉइस पोर्टल',
    inv_portal_welcome: 'स्वागत है', inv_portal_subtitle: 'VeriFactu इनवॉइस पोर्टल',
    inv_portal_total_invoices: 'कुल इनवॉइस', inv_portal_pending: 'लंबित',
    inv_portal_paid: 'भुगतान', inv_portal_revenue: 'राजस्व',
    inv_portal_recent: 'हाल के इनवॉइस', inv_portal_view_all: 'सभी देखें',
    inv_portal_business: 'व्यवसाय विवरण', inv_portal_biz_name: 'व्यवसाय का नाम',
    inv_setup_title: 'अपना व्यवसाय सेटअप करें', inv_setup_desc: 'VeriFactu इनवॉइस के लिए अपने व्यवसाय का विवरण दर्ज करें',
    inv_setup_name: 'व्यवसाय का नाम', inv_setup_legal: 'कानूनी नाम',
    inv_setup_submit: 'व्यवसाय बनाएं और शुरू करें',
    inv_setup_phone: 'फोन',

    // Stock
    stock_title: 'स्टॉक प्रबंधन', stock_tracked: 'ट्रैक किए गए उत्पाद',
    stock_total: 'कुल', stock_low: 'कम स्टॉक', stock_out: 'स्टॉक खत्म',
    stock_ok: 'ठीक', stock_unlimited: 'असीमित',
    stock_overview: 'अवलोकन', stock_history: 'इतिहास', stock_scanner: 'AI स्कैनर',
    stock_product: 'उत्पाद', stock_category: 'श्रेणी', stock_current: 'स्टॉक',
    stock_threshold: 'न्यूनतम', stock_status: 'स्थिति', stock_search: 'उत्पाद खोजें...',
    stock_alert_title: 'कम स्टॉक चेतावनी', stock_items: 'आइटम',
    stock_add: 'जोड़ें', stock_adjust: 'समायोजित करें', stock_adjust_title: 'स्टॉक समायोजित करें',
    stock_type: 'प्रकार', stock_intake: 'प्रवेश', stock_sale: 'बिक्री',
    stock_adjustment: 'समायोजन', stock_loss: 'नुकसान', stock_return: 'वापसी',
    stock_supplier: 'आपूर्तिकर्ता', stock_cost: 'लागत/इकाई (€)', stock_confirm: 'पुष्टि करें',
    stock_no_movements: 'कोई स्टॉक मूवमेंट नहीं',
    stock_scan_title: 'AI रसीद स्कैनर', stock_scan_desc: 'आपूर्तिकर्ता रसीद अपलोड करें',
    stock_upload: 'रसीद अपलोड करें', stock_scanning: 'स्कैन हो रहा है...',
    stock_scan_results: 'परिणाम', stock_matched: 'मिलान उत्पाद',
    stock_unmatched: 'बेमेल', stock_confirm_intake: 'प्रवेश पुष्टि',
    stock_scan_error: 'स्कैन विफल',
    stock_cost_price: 'लागत', stock_sale_price: 'बिक्री मूल्य',
    stock_reorder: 'पुनः ऑर्डर सुझाव', stock_reorder_desc: 'पिछले 30 दिनों की बिक्री गति पर आधारित',
    stock_reorder_all_good: 'सब ठीक है!', stock_reorder_no_items: 'किसी उत्पाद को पुनः ऑर्डर की आवश्यकता नहीं।',
    stock_reorder_velocity: 'दैनिक बिक्री', stock_reorder_days_left: 'शेष दिन',
    stock_reorder_qty: 'सुझाई गई मात्रा', stock_reorder_est_cost: 'अनुमानित लागत',
    stock_reorder_urgency: 'तात्कालिकता',
    stock_urgency_critical: 'गंभीर', stock_urgency_urgent: 'जरूरी',
    stock_urgency_soon: 'जल्द', stock_urgency_ok: 'ठीक',

    // Reports
    reports_title: 'रिपोर्ट', reports_subtitle: 'बिक्री विश्लेषण और दिन की रिपोर्ट',
    reports_daily: 'दैनिक रिपोर्ट', reports_weekly: 'साप्ताहिक सारांश',
    reports_today: 'आज', reports_revenue: 'राजस्व', reports_sales: 'बिक्री',
    reports_avg: 'औसत बिक्री', reports_invoices: 'इनवॉइस',
    reports_payment_split: 'भुगतान विधियां', reports_no_sales: 'इस दिन कोई बिक्री नहीं',
    reports_hourly: 'प्रति घंटा', reports_top_products: 'शीर्ष उत्पाद',
    reports_sales_short: 'बिक्री', reports_cash: 'नकद', reports_card: 'कार्ड',
    reports_weekly_summary: 'साप्ताहिक सारांश',
    reports_total_revenue: 'कुल राजस्व', reports_total_sales: 'कुल बिक्री',
    reports_daily_avg: 'दैनिक औसत', reports_daily_breakdown: 'दैनिक विवरण',
    staff_title: 'कर्मचारी प्रबंधन', staff_members: 'सदस्य',
    staff_add: 'जोड़ें', staff_active: 'सक्रिय कर्मचारी', staff_inactive: 'निष्क्रिय',
    staff_empty: 'कोई कर्मचारी नहीं', staff_empty_desc: 'अपना पहला सदस्य जोड़ें',
    staff_name: 'नाम', staff_role_label: 'भूमिका',
    staff_role_manager: 'प्रबंधक', staff_role_cashier: 'कैशियर',
    staff_role_stock_clerk: 'स्टॉक क्लर्क', staff_role_driver: 'ड्राइवर',
    staff_edit: 'संपादित', staff_save: 'सहेजें', staff_create: 'बनाएं',
    staff_delete: 'हटाएं', staff_delete_confirm: 'इस सदस्य को हटाएं?',
    staff_deactivate: 'निष्क्रिय करें', staff_activate: 'सक्रिय करें',
    staff_regen_pin: 'नया PIN', staff_new_pin: 'नया PIN',
    notif_title: 'सूचनाएं', notif_mark_all: 'सब पढ़ा', notif_empty: 'कोई सूचना नहीं',
    receipt_ticket: 'टिकट', receipt_subtotal: 'उप-योग', receipt_tax: 'कर', receipt_payment: 'भुगतान',
    receipt_received: 'प्राप्त', receipt_change: 'बाकी', receipt_thanks: 'खरीदारी के लिए धन्यवाद',
    inv_send_email: 'ईमेल से भेजें', inv_send: 'भेजें', inv_email_required: 'ईमेल आवश्यक',
    inv_email_sent: 'चालान ईमेल से भेजा गया', inv_email_failed: 'ईमेल भेजने में त्रुटि',
    inv_email_sent_to: 'भेजा गया',
    print_title: 'प्रिंटर', print_subtitle: 'रसीद प्रिंटर सेटिंग्स',
    print_how_title: 'प्रिंटर कैसे कनेक्ट करें',
    print_usb_guide: 'USB: कनेक्ट करें और प्रिंट डायलॉग में चुनें',
    print_wifi_guide: 'WiFi: नेटवर्क पर प्रिंटर IP सेट करें',
    print_browser_guide: 'ब्राउज़र: Ctrl+P या प्रिंट बटन',
    print_paper_size: 'कागज का आकार', print_80mm_desc: 'अधिकांश प्रिंटर के लिए मानक',
    print_58mm_desc: 'कॉम्पैक्ट और पोर्टेबल',
    print_receipt_options: 'रसीद विकल्प', print_auto_print: 'बिक्री के बाद स्वतः प्रिंट',
    print_show_header: 'दुकान विवरण दिखाएं', print_show_footer: 'रसीद फुटर दिखाएं',
    print_test: 'टेस्ट रसीद प्रिंट करें',
    shop_nav_payments: 'भुगतान',
    paysettings_title: 'भुगतान विकल्प',
    paysettings_subtitle: 'ग्राहकों के लिए भुगतान विकल्प कॉन्फ़िगर करें',
    paysettings_info: 'ये विकल्प ऑनलाइन चालान पर ग्राहकों को दिखाए जाएंगे। EU/UK बैंक ट्रांसफर, नकद या अन्य विधियां जोड़ें।',
    paysettings_save: 'सहेजें', paysettings_saved: 'सहेजा गया',
    paysettings_empty: 'कोई भुगतान विधि कॉन्फ़िगर नहीं है',
    paysettings_add: 'विधि जोड़ें',
    paysettings_label: 'विधि नाम', paysettings_bank_name: 'बैंक नाम',
    paysettings_holder: 'खाता धारक', paysettings_sort_code: 'सॉर्ट कोड',
    paysettings_acc_number: 'खाता संख्या', paysettings_instructions: 'निर्देश',
    inv_copy_link: 'लिंक कॉपी', inv_view_online: 'ऑनलाइन देखें',
    inv_link_copied: 'लिंक कॉपी किया गया',
    reminder_title: 'भुगतान अनुस्मारक', reminder_desc: 'बकाया चालान वाले ग्राहकों को स्वचालित अनुस्मारक भेजें',
    reminder_days_label: 'के बाद अनुस्मारक भेजें', reminder_after: 'बाद',
    reminder_days_unit: 'दिन', reminder_add_day: 'अंतराल जोड़ें',
    reminder_max: 'प्रति चालान अधिकतम अनुस्मारक', reminder_send_now: 'अभी अनुस्मारक भेजें',
    reminder_sent_count: 'अनुस्मारक भेजे गए', inv_reminders_sent: 'अनुस्मारक भेजे गए',
    dlv_title: 'डिलीवरी', dlv_subtitle: 'ऑर्डर और ड्राइवर प्रबंधन',
    dlv_new_delivery: 'नई डिलीवरी', dlv_add_driver: 'ड्राइवर जोड़ें',
    dlv_orders: 'ऑर्डर', dlv_drivers: 'ड्राइवर', dlv_all: 'सभी',
    dlv_pending: 'लंबित', dlv_in_progress: 'प्रगति में', dlv_delivered: 'डिलीवर', dlv_failed: 'विफल',
    dlv_drivers_available: 'उपलब्ध', dlv_revenue: 'राजस्व',
    dlv_assign: 'असाइन', dlv_picked_up: 'उठाया', dlv_mark_delivered: 'डिलीवर', dlv_mark_failed: 'विफल',
    dlv_cancel: 'रद्द', dlv_select_driver: 'ड्राइवर चुनें',
    dlv_no_available_drivers: 'कोई उपलब्ध ड्राइवर नहीं',
    dlv_no_deliveries: 'कोई डिलीवरी नहीं', dlv_no_drivers: 'कोई ड्राइवर नहीं',
    dlv_customer_name: 'ग्राहक नाम', dlv_customer_phone: 'फोन',
    dlv_address: 'डिलीवरी पता', dlv_city: 'शहर', dlv_payment: 'भुगतान',
    dlv_fee: 'डिलीवरी शुल्क', dlv_notes: 'नोट्स', dlv_create: 'डिलीवरी बनाएं',
    dlv_driver_name: 'नाम', dlv_driver_phone: 'फोन', dlv_vehicle: 'वाहन',
    dlv_motorcycle: 'मोटरसाइकिल', dlv_car: 'कार', dlv_bicycle: 'साइकिल', dlv_van: 'वैन',
    dlv_available: 'उपलब्ध', dlv_busy: 'व्यस्त', dlv_completed: 'पूर्ण',
    dlv_delete_driver_confirm: 'ड्राइवर हटाएं?',
    // SMTP Settings
    shop_nav_smtp: 'ईमेल SMTP', shop_nav_email_templates: 'ईमेल टेम्पलेट',
    smtp_title: 'SMTP कॉन्फ़िगरेशन',
    smtp_subtitle: 'अपने डोमेन से ईमेल भेजने के लिए अपना SMTP सर्वर कॉन्फ़िगर करें',
    smtp_verified: 'सत्यापित', smtp_not_verified: 'असत्यापित',
    smtp_config_title: 'SMTP कॉन्फ़िगरेशन',
    smtp_config_desc: 'अपना आउटगोइंग मेल सर्वर सेट करें',
    smtp_preset: 'ईमेल प्रदाता',
    smtp_preset_hint: 'सर्वर विवरण ऑटो-फिल करने के लिए एक प्रदाता चुनें, या Custom चुनें।',
    smtp_host: 'SMTP होस्ट', smtp_port: 'SMTP पोर्ट',
    smtp_username: 'उपयोगकर्ता नाम', smtp_password: 'पासवर्ड',
    smtp_password_hint: 'वर्तमान रखने के लिए खाली छोड़ें',
    smtp_password_required_new: 'नई कॉन्फ़िगरेशन के लिए पासवर्ड आवश्यक है',
    smtp_from_email: 'प्रेषक ईमेल', smtp_from_name: 'प्रेषक नाम',
    smtp_tls: 'TLS एन्क्रिप्शन',
    smtp_tls_465: 'पोर्ट 465 डायरेक्ट SSL उपयोग करता है। TLS लागू नहीं।',
    smtp_tls_587: 'पोर्ट 587 के लिए अनुशंसित। पोर्ट 465 पर SSL के लिए अक्षम करें।',
    smtp_save: 'ईमेल सेटिंग्स सहेजें',
    smtp_saved: 'SMTP सेटिंग्स सहेजी गईं',
    smtp_fill_required: 'कृपया सभी आवश्यक फ़ील्ड भरें',
    smtp_test_title: 'टेस्ट ईमेल भेजें',
    smtp_test_desc: 'टेस्ट ईमेल भेजकर अपनी कॉन्फ़िगरेशन सत्यापित करें',
    smtp_test_recipient: 'प्राप्तकर्ता ईमेल',
    smtp_test_message: 'कस्टम संदेश (वैकल्पिक)',
    smtp_test_message_placeholder: 'टेस्ट ईमेल के लिए एक कस्टम संदेश टाइप करें...',
    smtp_send_test: 'टेस्ट ईमेल भेजें',
    smtp_sending: 'भेजा जा रहा है...',
    smtp_enter_recipient: 'कृपया प्राप्तकर्ता ईमेल दर्ज करें',
    smtp_test_success: 'टेस्ट ईमेल सफलतापूर्वक भेजा गया',
    smtp_save_first: 'टेस्ट भेजने से पहले SMTP सेटिंग्स सहेजें',
    smtp_last_tested: 'अंतिम परीक्षण',
    // Email Templates
    et_title: 'ईमेल टेम्पलेट',
    et_subtitle: 'ईमेल सूचना टेम्पलेट बनाएं और प्रबंधित करें',
    et_create: 'टेम्पलेट बनाएं', et_add_defaults: 'डिफ़ॉल्ट टेम्पलेट जोड़ें',
    et_empty: 'अभी कोई टेम्पलेट नहीं',
    et_empty_hint: 'अपना पहला टेम्पलेट बनाएं या डिफ़ॉल्ट जोड़ें',
    et_create_title: 'टेम्पलेट बनाएं', et_edit_title: 'टेम्पलेट संपादित करें',
    et_create_desc: 'अपना सूचना टेम्पलेट कॉन्फ़िगर करें', et_edit_desc: 'अपना सूचना टेम्पलेट अपडेट करें',
    et_name: 'टेम्पलेट नाम', et_name_placeholder: 'उदा: स्वागत ईमेल',
    et_channel: 'चैनल', et_event_type: 'इवेंट प्रकार',
    et_subject: 'विषय', et_subject_placeholder: '{{वेरिएबल}} के साथ ईमेल विषय',
    et_body: 'संदेश बॉडी', et_body_placeholder: 'ईमेल बॉडी लिखें। डायनामिक डेटा के लिए {{variable}} उपयोग करें।',
    et_placeholders: 'वेरिएबल',
    et_active: 'टेम्पलेट सक्रिय है', et_inactive: 'निष्क्रिय',
    et_cancel: 'रद्द करें', et_save: 'सहेजें', et_update: 'अपडेट करें',
    et_updated: 'टेम्पलेट अपडेट किया गया', et_created: 'टेम्पलेट बनाया गया',
    et_deleted: 'टेम्पलेट हटाया गया', et_confirm_delete: 'क्या आप वाकई इस टेम्पलेट को हटाना चाहते हैं?',
    et_fill_required: 'कृपया नाम, विषय और बॉडी भरें',
    et_preview: 'पूर्वावलोकन', et_edit: 'संपादित करें', et_delete: 'हटाएं', et_send_test: 'टेस्ट भेजें',
    et_test_sent: 'टेस्ट ईमेल भेजा गया',
    et_preview_title: 'टेम्पलेट पूर्वावलोकन',
    et_preview_desc: 'नमूना डेटा के साथ आपका ईमेल ऐसा दिखेगा',
    et_preview_plain: 'सादा पाठ', et_preview_email: 'ईमेल HTML',

    // Tickets / Support
    shop_nav_tickets: 'सहायता',
    tickets_title: 'सहायता टिकट', tickets_subtitle: 'अपने सहायता अनुरोध प्रबंधित करें',
    tickets_new: 'नया टिकट', tickets_empty: 'कोई टिकट नहीं', tickets_empty_desc: 'यदि आपको सहायता चाहिए तो टिकट बनाएं',
    tickets_subject: 'विषय', tickets_category: 'श्रेणी', tickets_priority: 'प्राथमिकता',
    tickets_message: 'संदेश', tickets_submit: 'टिकट भेजें',
    tickets_reply_placeholder: 'अपना उत्तर लिखें...', tickets_close: 'टिकट बंद करें',
    tickets_closed_msg: 'यह टिकट बंद है',
  },

  // ======================== 中文 (CHINESE) ========================
  zh: {
    nav_features: '功能', nav_pricing: '价格', nav_about: '关于我们',
    nav_contact: '联系', nav_faq: '常见问题', nav_login: '登录', nav_register: '注册',
    nav_mobile: '移动应用',

    hero_badge: 'VeriFactu合规保证',
    hero_title: '您的商店。', hero_title_2: '合规。简单。',
    hero_subtitle: '面向西班牙商店和自由职业者的POS系统和VeriFactu合规发票。',
    hero_cta_pos: '完整POS €19.99/月', hero_cta_invoice: '仅发票 €4.99/月',
    hero_trusted: '受到500多家西班牙企业的信赖',

    features_title: '您需要的一切',
    features_subtitle: '从POS到发票、库存管理等',
    feature_pos_title: '完整POS系统',
    feature_pos_desc: '条码扫描、现金和刷卡支付、热敏打印、离线模式。',
    feature_invoice_title: 'VeriFactu发票',
    feature_invoice_desc: '符合AEAT标准的发票，带QR码、哈希链和自动提交。',
    feature_stock_title: '库存管理',
    feature_stock_desc: 'AI收据扫描、低库存警报、保质期。',
    feature_staff_title: '员工管理',
    feature_staff_desc: 'PIN码访问、角色（收银员、经理、仓管）、活动日志。',
    feature_reports_title: '日终报告',
    feature_reports_desc: '每日摘要、每小时销售、热门产品、CSV导出。',
    feature_delivery_title: '送货上门',
    feature_delivery_desc: '司机管理、订单跟踪、可配置配送费。',

    verifactu_label: 'AEAT法规', verifactu_title: 'VeriFactu要求您',
    verifactu_subtitle: '从2027年7月起，所有西班牙企业必须使用经批准的发票软件。',
    verifactu_feature_1: '可验证的SHA-256哈希链', verifactu_feature_2: '每张发票上的QR码',
    verifactu_feature_3: '与AEAT直接连接', verifactu_feature_4: '集成数字证书',
    verifactu_approved: '已批准', verifactu_cta: '立即合规',

    pricing_title: '清晰定价', pricing_subtitle: '无惊喜，无隐藏费用，随时取消。',
    pricing_invoice_title: '发票', pricing_invoice_subtitle: '适用于自由职业者和小型企业',
    pricing_invoice_price: '€4.99', pricing_invoice_period: '/月',
    pricing_invoice_features: [
      '无限VeriFactu发票', '带QR码的PDF生成', '客户目录',
      '可自定义模板', '定期发票', '付款跟踪',
      '导出CSV/Excel', 'iOS/Android移动应用', '电子邮件支持'
    ],
    pricing_pos_title: '商店POS', pricing_pos_subtitle: '适用于商店',
    pricing_pos_price: '€19.99', pricing_pos_period: '/月',
    pricing_pos_features: [
      '发票的所有功能 +', '完整POS系统', '条码扫描器',
      '带警报的库存管理', 'AI收据扫描', '带PIN的员工管理',
      '日终报告', 'ESC/POS热敏打印机', '离线模式',
      '送货上门', '优先支持'
    ],
    pricing_popular: '最受欢迎', pricing_cta_invoice: '从发票开始',
    pricing_cta_pos: '从POS开始',
    pricing_launch: '特别优惠：2026年5月1日前注册 - 年度计划5折优惠',
    pricing_monthly: '月付',
    pricing_yearly: '年付',
    pricing_yearly_save: '省15%',
    pricing_per_month: '/月',
    pricing_per_year: '/年',
    pricing_billed_yearly: '按年计费',

    testimonials_title: '客户评价',
    testimonial_1_text: '"VendFactura帮我避免了罚款。我的发票现在符合VeriFactu标准。"',
    testimonial_1_author: '玛丽亚·加西亚', testimonial_1_role: '杂货店，马德里',
    testimonial_2_text: '"条码扫描器超快。顾客不再排队。"',
    testimonial_2_author: '安东尼奥·洛佩斯', testimonial_2_role: '烟草店，巴塞罗那',
    testimonial_3_text: '"作为自由职业者，我只需要发票功能。每月€4.99就搞定了。"',
    testimonial_3_author: '卡洛斯·鲁伊斯', testimonial_3_role: '自由设计师，瓦伦西亚',

    faq_title: '常见问题',
    faq_1_q: '什么是VeriFactu？', faq_1_a: 'VeriFactu是AEAT的新系统，要求所有发票软件生成带QR码和哈希链的可验证发票。2027年7月起强制执行。',
    faq_2_q: '可以先试用吗？', faq_2_a: '可以，14天免费试用，无需信用卡。',
    faq_3_q: '离线能用吗？', faq_3_a: '可以，离线模式允许在无网络时继续销售。重新连接后自动同步。',
    faq_4_q: '支持哪些打印机？', faq_4_a: '任何ESC/POS热敏打印机。蓝牙、USB或WiFi连接。',
    faq_5_q: '可以换套餐吗？', faq_5_a: '可以，随时从发票升级到POS。',

    cta_title: '准备好符合VeriFactu了吗？',
    cta_subtitle: '加入数百家已经准备就绪的西班牙企业',
    cta_button: '免费开始',

    footer_description: '面向西班牙商店的POS系统和VeriFactu发票。',
    footer_product: '产品', footer_company: '公司', footer_legal: '法律',
    footer_terms: '条款和条件', footer_privacy: '隐私政策', footer_cookies: 'Cookie政策',
    footer_copyright: '© 2025 VendFactura. 保留所有权利。', footer_made: '在西班牙用心打造',

    auth_login: '登录', auth_register: '注册', auth_email: '电子邮件',
    auth_password: '密码', auth_forgot: '忘记密码？',
    auth_no_account: '没有账户？', auth_has_account: '已有账户？',

    shop_nav_dashboard: '仪表板', shop_nav_pos: '收银台', shop_nav_products: '商品',
    shop_nav_stock: '库存', shop_nav_invoices: '发票', shop_nav_staff: '员工',
    shop_nav_reports: '报告', shop_nav_delivery: '配送', shop_nav_printer: '打印机',
    shop_nav_settings: '设置', shop_nav_help: '帮助', shop_nav_logout: '退出登录',

    dashboard_welcome: '欢迎', dashboard_today_sales: '今日销售',
    dashboard_today_revenue: '今日营收', dashboard_total_products: '商品',
    dashboard_low_stock: '低库存', dashboard_pending_invoices: '待处理发票',
    dashboard_recent_sales: '最近销售', dashboard_quick_actions: '快捷操作',
    dashboard_open_pos: '打开收银', dashboard_new_product: '新商品',
    dashboard_create_invoice: '创建发票', dashboard_view_reports: '查看报告',
    dashboard_setup_needed: '完成设置！', dashboard_setup_desc: '设置您的商店以开始销售',
    dashboard_start_setup: '开始设置', dashboard_no_sales_yet: '还没有销售',
    dashboard_start_selling: '开始销售', dashboard_this_week: '对比上周',
    dashboard_vs_yesterday: '对比昨天', dashboard_view_all: '查看全部',

    briefing_title: '每日简报', briefing_good_morning: '早上好',
    briefing_good_afternoon: '下午好', briefing_good_evening: '晚上好',
    briefing_yesterday: '昨日结算', briefing_sales: '笔销售', briefing_revenue: '营收',
    briefing_restock: '需要补货', briefing_products_low: '个低库存商品',
    briefing_view_all: '查看全部', briefing_verifactu: 'VeriFactu状态',
    briefing_all_synced: '全部已同步', briefing_pending_sync: '待提交',
    briefing_no_issues: '无问题', briefing_tasks: '今日任务',
    briefing_check_stock: '检查低库存', briefing_review_sales: '查看昨日销售',
    briefing_prepare_orders: '准备待处理订单',

    pos_title: '收银台', pos_search: '搜索商品或扫描条码...',
    pos_all: '全部', pos_cart: '购物车', pos_empty: '购物车为空',
    pos_add_products: '添加商品开始', pos_subtotal: '小计', pos_tax: '税',
    pos_total: '合计', pos_pay: '付款', pos_cash: '现金', pos_card: '刷卡', pos_split: '分账',
    pos_cash_received: '收到现金', pos_change: '找零',
    pos_customer_name: '客户姓名（可选）', pos_complete_sale: '完成销售',
    pos_print_receipt: '打印小票', pos_new_sale: '新销售',
    pos_sale_success: '销售完成！', pos_sale_number: '销售 #',
    pos_quick_cash: '快速现金', pos_exact: '刚好', pos_back: '返回', pos_items: '件商品',
    pos_park: '暂存', pos_void: '作废', pos_no_products: '无商品',
    pos_add_first: '从目录添加商品',
    pos_offline_mode: '离线模式', pos_offline_sales_saved: '销售记录已本地保存',
    pos_back_online: '已恢复在线', pos_online: '在线', pos_offline: '离线',
    pos_offline_saved: '销售已离线保存。连接恢复后将自动同步。',
    pos_pending: '待同步', pos_syncing: '同步中...', pos_synced: '已同步',
    pos_failed: '失败', pos_sales_synced: '笔销售已同步', pos_sync_partial: '部分同步',
    pos_cached: '缓存',

    products_title: '商品', products_search: '搜索商品...',
    products_add: '新商品', products_edit: '编辑商品', products_create: '创建商品',
    products_save: '保存', products_cancel: '取消', products_delete: '删除',
    products_name: '名称', products_description: '描述', products_price: '价格 (€)',
    products_category: '类别', products_barcode: '条码', products_stock: '库存',
    products_low_threshold: '低库存阈值', products_tax_rate: '税率', products_unit: '单位',
    products_available: '可用', products_all: '全部', products_no_products: '未找到商品',
    products_add_first: '添加您的第一个商品', products_confirm_delete: '删除此商品？',
    products_yes_delete: '是的，删除', products_total: '商品总数',

    inv_title: '发票', inv_create: '新建发票', inv_edit: '编辑发票',
    inv_number: '发票 #', inv_date: '日期', inv_due_date: '到期日',
    inv_customer: '客户', inv_customer_name: '客户名称', inv_customer_nif: '税号 (NIF)',
    inv_customer_address: '地址', inv_customer_city: '城市', inv_customer_postal: '邮编',
    inv_customer_email: '电子邮件', inv_items: '项目', inv_description: '描述',
    inv_quantity: '数量', inv_price: '价格', inv_tax_rate: '税率 %', inv_line_total: '合计',
    inv_add_line: '添加项目', inv_subtotal: '小计', inv_tax: '税', inv_total: '合计',
    inv_payment: '支付方式', inv_bank: '银行转账', inv_cash: '现金', inv_card: '刷卡', inv_other: '其他',
    inv_notes: '备注', inv_status: '状态', inv_draft: '草稿', inv_issued: '已开具',
    inv_paid: '已付', inv_cancelled: '已取消', inv_save: '保存发票',
    inv_download_pdf: '下载PDF', inv_mark_paid: '标记已付', inv_cancel_invoice: '取消',
    inv_verify: '验证哈希', inv_verifactu: 'VeriFactu', inv_hash_valid: '哈希有效',
    inv_hash_invalid: '哈希被篡改', inv_no_invoices: '没有发票',
    inv_create_first: '创建您的第一张发票', inv_all: '全部', inv_search: '搜索发票...',

    // Payment
    pay_processing: '正在处理付款...', pay_wait: '请稍候，我们正在确认您的付款。',
    pay_success: '付款成功！', pay_success_desc: '您的订阅已激活。',
    pay_plan: '套餐', pay_go_dashboard: '前往控制面板', pay_go_invoices: '开始创建发票',
    pay_back_home: '返回首页', pay_error: '付款问题',
    pay_error_desc: '处理付款时出现问题。请重试。',
    pay_try_again: '重试', pay_cancelled: '付款已取消',
    pay_cancelled_desc: '未收取任何费用。您可以随时重试。',
    pay_back_pricing: '返回定价',

    // Invoice Portal
    inv_portal_dashboard: '仪表板', inv_portal_title: '发票门户',
    inv_portal_welcome: '欢迎', inv_portal_subtitle: 'VeriFactu 发票门户',
    inv_portal_total_invoices: '发票总数', inv_portal_pending: '待处理',
    inv_portal_paid: '已付', inv_portal_revenue: '收入',
    inv_portal_recent: '最近发票', inv_portal_view_all: '查看全部',
    inv_portal_business: '企业信息', inv_portal_biz_name: '企业名称',
    inv_setup_title: '设置您的企业', inv_setup_desc: '输入您的企业信息用于VeriFactu发票',
    inv_setup_name: '企业名称', inv_setup_legal: '法定名称',
    inv_setup_submit: '创建企业并开始',
    inv_setup_phone: '电话',

    // Stock
    stock_title: '库存管理', stock_tracked: '跟踪产品',
    stock_total: '总计', stock_low: '库存低', stock_out: '缺货',
    stock_ok: '正常', stock_unlimited: '无限',
    stock_overview: '概览', stock_history: '历史', stock_scanner: 'AI扫描仪',
    stock_product: '产品', stock_category: '类别', stock_current: '库存',
    stock_threshold: '最低', stock_status: '状态', stock_search: '搜索产品...',
    stock_alert_title: '库存低警告', stock_items: '项目',
    stock_add: '添加', stock_adjust: '调整', stock_adjust_title: '调整库存',
    stock_type: '类型', stock_intake: '入库', stock_sale: '销售',
    stock_adjustment: '调整', stock_loss: '损失', stock_return: '退货',
    stock_supplier: '供应商', stock_cost: '成本/单位 (€)', stock_confirm: '确认',
    stock_no_movements: '暂无库存变动',
    stock_scan_title: 'AI收据扫描', stock_scan_desc: '上传供应商收据',
    stock_upload: '上传收据', stock_scanning: '扫描中...',
    stock_scan_results: '结果', stock_matched: '匹配产品',
    stock_unmatched: '未匹配', stock_confirm_intake: '确认入库',
    stock_scan_error: '扫描失败',
    stock_cost_price: '成本', stock_sale_price: '售价',
    stock_reorder: '补货建议', stock_reorder_desc: '基于过去30天的销售速度',
    stock_reorder_all_good: '库存充足!', stock_reorder_no_items: '目前没有产品需要补货。',
    stock_reorder_velocity: '日销量', stock_reorder_days_left: '剩余天数',
    stock_reorder_qty: '建议数量', stock_reorder_est_cost: '预估成本',
    stock_reorder_urgency: '紧急程度',
    stock_urgency_critical: '紧急', stock_urgency_urgent: '较急',
    stock_urgency_soon: '即将', stock_urgency_ok: '正常',

    // Reports
    reports_title: '报告', reports_subtitle: '销售分析与每日报告',
    reports_daily: '每日报告', reports_weekly: '每周总结',
    reports_today: '今天', reports_revenue: '收入', reports_sales: '销售',
    reports_avg: '平均销售', reports_invoices: '发票',
    reports_payment_split: '支付方式', reports_no_sales: '当日无销售',
    reports_hourly: '按小时', reports_top_products: '热销产品',
    reports_sales_short: '销售', reports_cash: '现金', reports_card: '卡',
    reports_weekly_summary: '每周总结',
    reports_total_revenue: '总收入', reports_total_sales: '总销售',
    reports_daily_avg: '日均', reports_daily_breakdown: '每日明细',
    staff_title: '员工管理', staff_members: '成员',
    staff_add: '添加', staff_active: '在职员工', staff_inactive: '离职',
    staff_empty: '暂无员工', staff_empty_desc: '添加您的第一个团队成员',
    staff_name: '姓名', staff_role_label: '角色',
    staff_role_manager: '经理', staff_role_cashier: '收银员',
    staff_role_stock_clerk: '仓管员', staff_role_driver: '司机',
    staff_edit: '编辑', staff_save: '保存', staff_create: '创建',
    staff_delete: '删除', staff_delete_confirm: '删除此成员？',
    staff_deactivate: '停用', staff_activate: '启用',
    staff_regen_pin: '新PIN', staff_new_pin: '新PIN',
    notif_title: '通知', notif_mark_all: '全部已读', notif_empty: '暂无通知',
    receipt_ticket: '小票', receipt_subtotal: '小计', receipt_tax: '税', receipt_payment: '付款',
    receipt_received: '收到', receipt_change: '找零', receipt_thanks: '感谢您的购买',
    inv_send_email: '邮件发送', inv_send: '发送', inv_email_required: '需要邮箱地址',
    inv_email_sent: '发票已发送', inv_email_failed: '发送失败',
    inv_email_sent_to: '已发送至',
    print_title: '打印机', print_subtitle: '配置小票打印机',
    print_how_title: '如何连接打印机',
    print_usb_guide: 'USB: 连接并在打印对话框中选择',
    print_wifi_guide: 'WiFi: 在本地网络设置打印机IP',
    print_browser_guide: '浏览器: 使用Ctrl+P或打印按钮',
    print_paper_size: '纸张尺寸', print_80mm_desc: '大多数打印机的标准尺寸',
    print_58mm_desc: '便携式紧凑打印机',
    print_receipt_options: '小票选项', print_auto_print: '售后自动打印',
    print_show_header: '显示店铺信息', print_show_footer: '显示小票页脚',
    print_test: '打印测试小票',
    shop_nav_payments: '支付',
    paysettings_title: '支付选项',
    paysettings_subtitle: '配置客户在发票上看到的支付选项',
    paysettings_info: '这些支付选项将在在线发票上显示给客户。添加EU/UK银行转账、现金或其他方式。',
    paysettings_save: '保存', paysettings_saved: '已保存',
    paysettings_empty: '未配置支付方式',
    paysettings_add: '添加支付方式',
    paysettings_label: '方式名称', paysettings_bank_name: '银行名称',
    paysettings_holder: '账户持有人', paysettings_sort_code: 'Sort Code',
    paysettings_acc_number: '账号', paysettings_instructions: '说明',
    inv_copy_link: '复制链接', inv_view_online: '在线查看',
    inv_link_copied: '链接已复制',
    reminder_title: '付款提醒', reminder_desc: '自动向逾期发票的客户发送提醒',
    reminder_days_label: '在之后发送提醒', reminder_after: '之后',
    reminder_days_unit: '天', reminder_add_day: '添加间隔',
    reminder_max: '每张发票最大提醒数', reminder_send_now: '立即发送提醒',
    reminder_sent_count: '已发送提醒', inv_reminders_sent: '已发送提醒',
    dlv_title: '配送', dlv_subtitle: '管理订单和配送员',
    dlv_new_delivery: '新配送', dlv_add_driver: '添加配送员',
    dlv_orders: '订单', dlv_drivers: '配送员', dlv_all: '全部',
    dlv_pending: '待处理', dlv_in_progress: '进行中', dlv_delivered: '已送达', dlv_failed: '失败',
    dlv_drivers_available: '可用', dlv_revenue: '收入',
    dlv_assign: '分配', dlv_picked_up: '已取货', dlv_mark_delivered: '已送达', dlv_mark_failed: '失败',
    dlv_cancel: '取消', dlv_select_driver: '选择配送员',
    dlv_no_available_drivers: '无可用配送员',
    dlv_no_deliveries: '暂无配送', dlv_no_drivers: '暂无配送员',
    dlv_customer_name: '客户姓名', dlv_customer_phone: '电话',
    dlv_address: '配送地址', dlv_city: '城市', dlv_payment: '付款',
    dlv_fee: '配送费', dlv_notes: '备注', dlv_create: '创建配送',
    dlv_driver_name: '姓名', dlv_driver_phone: '电话', dlv_vehicle: '车辆',
    dlv_motorcycle: '摩托车', dlv_car: '汽车', dlv_bicycle: '自行车', dlv_van: '面包车',
    dlv_available: '可用', dlv_busy: '忙碌', dlv_completed: '已完成',
    dlv_delete_driver_confirm: '删除此配送员？',
    // SMTP Settings
    shop_nav_smtp: '邮件SMTP', shop_nav_email_templates: '邮件模板',
    smtp_title: 'SMTP配置',
    smtp_subtitle: '配置您自己的SMTP服务器从您的域名发送邮件',
    smtp_verified: '已验证', smtp_not_verified: '未验证',
    smtp_config_title: 'SMTP配置',
    smtp_config_desc: '设置您的发件邮件服务器',
    smtp_preset: '邮件提供商',
    smtp_preset_hint: '选择一个提供商以自动填充服务器详细信息，或选择Custom。',
    smtp_host: 'SMTP主机', smtp_port: 'SMTP端口',
    smtp_username: '用户名', smtp_password: '密码',
    smtp_password_hint: '留空以保持当前密码',
    smtp_password_required_new: '新配置需要密码',
    smtp_from_email: '发件人邮箱', smtp_from_name: '发件人名称',
    smtp_tls: 'TLS加密',
    smtp_tls_465: '端口465使用直接SSL。TLS不适用。',
    smtp_tls_587: '推荐用于端口587。在端口465上禁用以使用SSL。',
    smtp_save: '保存邮件设置',
    smtp_saved: 'SMTP设置已保存',
    smtp_fill_required: '请填写所有必填字段',
    smtp_test_title: '发送测试邮件',
    smtp_test_desc: '通过发送测试邮件验证您的配置',
    smtp_test_recipient: '收件人邮箱',
    smtp_test_message: '自定义消息（可选）',
    smtp_test_message_placeholder: '输入测试邮件的自定义消息...',
    smtp_send_test: '发送测试邮件',
    smtp_sending: '发送中...',
    smtp_enter_recipient: '请输入收件人邮箱',
    smtp_test_success: '测试邮件发送成功',
    smtp_save_first: '请先保存SMTP设置再发送测试',
    smtp_last_tested: '上次测试',
    // Email Templates
    et_title: '邮件模板',
    et_subtitle: '创建和管理邮件通知模板',
    et_create: '创建模板', et_add_defaults: '添加默认模板',
    et_empty: '暂无模板',
    et_empty_hint: '创建您的第一个模板或添加默认模板',
    et_create_title: '创建模板', et_edit_title: '编辑模板',
    et_create_desc: '配置您的通知模板', et_edit_desc: '更新您的通知模板',
    et_name: '模板名称', et_name_placeholder: '例如：欢迎邮件',
    et_channel: '渠道', et_event_type: '事件类型',
    et_subject: '邮件主题', et_subject_placeholder: '带{{变量}}的邮件主题',
    et_body: '邮件正文', et_body_placeholder: '编写邮件正文。使用{{变量}}插入动态数据。',
    et_placeholders: '变量',
    et_active: '模板已激活', et_inactive: '未激活',
    et_cancel: '取消', et_save: '保存', et_update: '更新',
    et_updated: '模板已更新', et_created: '模板已创建',
    et_deleted: '模板已删除', et_confirm_delete: '确定要删除此模板吗？',
    et_fill_required: '请填写名称、主题和正文',
    et_preview: '预览', et_edit: '编辑', et_delete: '删除', et_send_test: '发送测试',
    et_test_sent: '测试邮件已发送',
    et_preview_title: '模板预览',
    et_preview_desc: '这是您的邮件使用示例数据后的效果',
    et_preview_plain: '纯文本', et_preview_email: '邮件HTML',

    // Tickets / Support
    shop_nav_tickets: '支持',
    tickets_title: '支持工单', tickets_subtitle: '管理您的支持请求',
    tickets_new: '新建工单', tickets_empty: '暂无工单', tickets_empty_desc: '如需帮助请创建工单',
    tickets_subject: '主题', tickets_category: '类别', tickets_priority: '优先级',
    tickets_message: '消息', tickets_submit: '提交工单',
    tickets_reply_placeholder: '输入您的回复...', tickets_close: '关闭工单',
    tickets_closed_msg: '此工单已关闭',
  },
};

export default translations;
